export const getAssetUrl = (filename, type = "mechanics_images") => {
  if (!filename) return false;
  return `${process.env.REACT_APP_AWS_S3_BUCKET_CONTENT_URL}/${type}/${filename}`;
};

export const getAssetAudioUrl = (filename, type = "mechanics_audios") => {
  if (!filename) return false;
  return `${process.env.REACT_APP_AWS_S3_BUCKET_CONTENT_URL}/${type}/${filename}`;
};

//syllable audio files
export const atAudio = "c2401c9c-1107-4f62-95c1-e98d671070bd.wav";
export const anAudio = "4d90be3c-15b9-4e11-8887-0e59a8bc7855.wav";
export const inAudio = "f54f8978-b95c-48ff-a1ac-43e25ef649c7.wav";
export const onAudio = "03f8527f-061e-495c-a22f-e669668c7d23.wav";
export const upAudio = "8b295576-0fc5-4e69-aac5-cd58f4b75d8c.wav";
export const isAudio = "95bc43c0-1599-49d3-b3e5-b7e39699336d.wav";
export const orAudio = "d7292b73-8c73-485e-b6b8-787c5ebeb22c.wav";
export const allAudio = "d360505d-ee3c-4dc3-ac85-7b2da58a70ee.wav";
export const ingAudio = "f153cc4e-9b44-436a-8302-68102c111b14.wav";

export const cupAudio = "eb634ba3-69d6-4f64-9520-eb4e67e74568.wav";
export const kingAudio = "a73fdd85-06ac-4ce5-9f44-dd17c2671408.wav";
export const applePhonemeAudio = "c44ffd22-c205-4745-8aca-5f45efabbf4c.mp3";
export const catPhonemeAudio = "1cca4dac-684b-48d2-9dfa-93a4c509dfdd.mp3";
export const peaPhonemeAudio = "137c172a-a9f8-422b-aa7c-1d9126c0dcb1.mp3";
export const ballPhonemeAudio = "0256c499-94a8-4b8a-b34f-e809a0f270a5.mp3";
export const zebraPhonemeAudio = "eab4b8d7-a71c-4149-954b-10cfcc01f887.mp3";
export const cubPhonemeAudio = "a4e8aef3-7819-4a54-bdcc-1939c0ee4530.mp3";
export const icePhonemeAudio = "847f321f-f216-4ef2-96cf-073c6a28d133.mp3";
export const garlicPhonemeAudio = "a741e634-135a-4a09-b10d-8bfea480d228.mp3";
export const dogPhonemeAudio = "6f59dbab-f8b9-4a67-9ffa-2da756e94848.mp3";
export const windowPhonemeAudio = "39d2112c-a9aa-4162-80ce-099f42c56aec.mp3";
export const swordPhonemeAudio = "f04603c4-9d29-4af3-9501-a2293497f25c.mp3";
export const eggPhonemeAudio = "3492971b-35af-46b9-9762-1336da467f84.mp3";
export const penPhonemeAudio = "004aaf85-3641-4a0d-b40e-47de73a17a87.mp3";
export const kitePhonemeAudio = "a951e524-2902-4314-bf10-8643adbc7e0c.mp3";
export const fishPhonemeAudio = "82ceae1e-6c93-4e19-a7e6-a1ca7b6833a2.mp3";
export const giraffePhonemeAudio = "4ab0a9bd-2b8f-4394-b699-15bcce561022.mp3";
export const leafPhonemeAudio = "b182e9e7-154a-4a69-aae1-ccaa537e4a42.mp3";
export const goatPhonemeAudio = "1de204da-3560-4231-8724-844ae084a098.mp3";
export const tigerPhonemeAudio = "a2959a62-d104-481f-9ec1-24085ce48493.mp3";
export const handPhonemeAudio = "b6c90012-3733-4b31-ab84-103732bcf4e8.mp3";
export const teacherPhonemeAudio = "0f51a845-b83e-4ee6-a98a-1e5e636b599c.mp3";
export const earthPhonemeAudio = "94269edd-1ebc-4eda-ac2d-53dfae882077.mp3";
export const pigPhonemeAudio = "5d0a806b-ea53-40eb-8b5a-612aeae3eadd.mp3";
export const dhobiPhonemeAudio = "c1bf5585-cce1-452d-b779-5395b4d559a2.mp3";
export const jamPhonemeAudio = "5c22226b-bd00-421a-b6b2-5e2da30c1550.mp3";
export const brinjalPhonemeAudio = "5f7d78c2-4922-4525-8072-11dad00ed8d9.mp3";
export const rajPhonemeAudio = "28365392-a4cd-4a5c-83c5-cf0219cb8117.mp3";
export const monkeyPhonemeAudio = "8fe2f0f9-6254-4a59-9528-9c07dcbdadb2.mp3";
export const bookPhonemeAudio = "cc92f22c-aad6-4016-a256-a27e99f20800.mp3";
export const lionPhonemeAudio = "0823900f-87fe-4fdb-8af9-d12584595b89.mp3";
export const balloonPhonemeAudio = "87363175-7674-47b7-8216-570be800fb41.mp3";
export const bellPhonemeAudio = "2e7212e4-5275-4d36-837a-768fe060111e.mp3";
export const mangoPhonemeAudio = "21238b39-9e68-450d-8daa-8c0c09d8fc8a.mp3";
export const lemonPhonemeAudio = "21a540c1-a628-497f-a6f0-eecb787d53da.mp3";
export const nestPhonemeAudio = "b31853ee-b1c7-4535-b619-b1930482a974.mp3";
export const honeyPhonemeAudio = "7d4eee6d-9fe4-4a34-8a74-b30de34de97f.mp3";
export const orangePhonemeAudio = "facf1b22-9192-4d93-9741-b41c8e76db35.mp3";
export const capPhonemeAudio = "e94ff881-cd0b-40a0-8f65-b31d79677879.mp3";
export const cupPhonemeAudio = "e94ff881-cd0b-40a0-8f65-b31d79677879.mp3"; // TODO: Replace with actual cup audio file
export const queenPhonemeAudio = "202957b2-5fc6-4301-b1b6-3c44ef7c45f7.mp3";
export const mosquitoPhonemeAudio = "cc301073-cbf4-4070-96c0-b1c92ae30167.mp3";
export const ratPhonemeAudio = "8f122fe9-5a2f-4c73-8f0a-c4bfc661092d.mp3";
export const carrotPhonemeAudio = "0a9aa842-7a57-4c28-8de1-6dd4a7550987.mp3";
export const carPhonemeAudio = "9b8eb9ff-805d-4fd7-8d59-e329f2fd8cff.mp3";
export const sunPhonemeAudio = "acddb132-e3f8-42ba-9d66-eb7e9d1e9df8.mp3";
export const horsePhonemeAudio = "78dd9087-8f05-434d-8824-23449836c575.mp3";
export const busPhonemeAudio = "273458af-7a32-427b-a225-bf1b8422558a.mp3";
export const watchPhonemeAudio = "56e5635f-bdad-47cc-9095-8a9e2b48fc39.mp3";
export const plantPhonemeAudio = "31374a49-1ef2-462a-99a1-48e549740a90.mp3";
export const umbrellaPhonemeAudio = "e03d5bf6-e02e-432f-b756-af61c6cde565.mp3";
export const dustbinPhonemeAudio = "92272976-3d31-4428-b3a2-bfbe28c1265e.mp3";
export const ladduPhonemeAudio = "967d0599-7292-47a6-8300-94205b0940a6.mp3";
export const vanPhonemeAudio = "75056fba-d6a1-41d4-82b3-10385af1dadc.mp3";
export const guavaPhonemeAudio = "4493b265-dc94-4a23-a082-3d58a2e97941.mp3";
export const crowPhonemeAudio = "4f4ea9cb-72e7-47d5-8cc4-27efedd53d68.mp3";
export const xrayPhonemeAudio = "fe3aac79-9b91-4ec4-a4fe-91db7d2f060d.mp3";
export const textbookPhonemeAudio = "2f45dc7c-b8b3-4f5f-a23d-8a5e39acb66a.mp3";
export const foxPhonemeAudio = "a8bffefd-7268-4325-876b-66f0cda2a3b3.mp3";
export const yakPhonemeAudio = "e7357a4d-e2f2-440a-8d4f-bc29cad93a78.mp3";
export const papayaPhonemeAudio = "467472ba-8012-43de-a98e-e15242465c9c.mp3";
export const keyPhonemeAudio = "934e245a-b84a-43ce-a8c4-b77bd6f58e0c.mp3";
export const kingPhonemeAudio = "057dc4c7-febd-4a0f-9605-c867e80b9f18.mp3"; // Using kingAlpAudio as placeholder
export const puzzlePhonemeAudio = "b3f3d4b7-3523-476e-85e0-11bc19160a3a.mp3";
export const quizPhonemeAudio = "fe5e5c29-0cae-4522-83b2-34869fe6d9d6.mp3";

export const APhonemeAudio = "36e1b035-9f56-449f-8c34-1adf7c8de2e3.mp3";
export const BPhonemeAudio = "2cb12b8b-fe90-4c00-bbae-19201b0e5fef.mp3";
export const CPhonemeAudio = "41e58bfb-79de-4d11-b93b-770fb41fcd0e.mp3";
export const DPhonemeAudio = "9292355b-d9a5-4580-b273-36692a786fda.mp3";
export const EPhonemeAudio = "a952532f-b89c-4d6c-9bbb-899fce98b154.mp3";
export const FPhonemeAudio = "ea0898d9-a0a0-4ea5-a650-68dcaf001529.mp3";
export const GPhonemeAudio = "5b4d00cc-eb73-49f2-8232-14f57c664f45.mp3";
export const HPhonemeAudio = "0aeeea80-008f-4a6f-8b1a-f40c92a3a492.mp3";
export const IPhonemeAudio = "8637cfff-4632-4c64-a83e-e1bfcddd4cf8.mp3";
export const JPhonemeAudio = "6d9dbd0f-eb78-4723-a5eb-fc39dbe51df9.mp3";
export const KPhonemeAudio = "a5e9e05f-3023-4574-be8f-18f7f43f64be.mp3";
export const LPhonemeAudio = "08a09a97-ee77-4989-8dc5-e9558e86d2a9.mp3";
export const MPhonemeAudio = "4abab969-88de-4fff-8a0f-a0eedc5c5e3c.mp3";
export const NPhonemeAudio = "c68fdd7e-0f2c-42a2-837e-5835d975dd15.mp3";
export const OPhonemeAudio = "8c497f32-9b10-42c3-929f-876d24d11f8c.mp3";
export const PPhonemeAudio = "6273715b-d5b6-4914-a14b-57e59a3fabe4.mp3";
export const QPhonemeAudio = "6a74dfba-2e15-4f80-8ac0-f180f38db313.mp3";
export const RPhonemeAudio = "98b88457-eb3c-4c2d-89f0-f652b4847ecc.mp3";
export const SPhonemeAudio = "094fa70a-7ae3-4c8e-8979-67d5b45b6c31.mp3";
export const TPhonemeAudio = "9a9f2b36-b97b-42ef-860f-1c42b7c5e4f7.mp3";
export const UPhonemeAudio = "06ec93a2-fd9b-4e51-9873-340e2394c2d2.mp3";
export const VPhonemeAudio = "72abfcd8-c4a4-4d8f-9488-ac8f663a0f13.mp3";
export const WPhonemeAudio = "9f4d7328-a092-4370-82ac-b7533cbf1299.mp3";
export const XPhonemeAudio = "62a3dd27-4af2-46e8-bc76-0be49c316d37.mp3";
export const YPhonemeAudio = "c97b065d-c31e-4ab8-b561-d13d4836de73.mp3";
export const ZPhonemeAudio = "44ca5adb-a9ba-43b5-9611-a9c00369f454.mp3";

export const moonPhonemeAudioYT = "5d7131de-a05a-4dc5-9249-4fa181a963ae.mp3";
export const boatPhonemeAudioYT = "697f57ec-f455-438d-901d-39c3f977e96d.mp3";
export const starPhonemeAudioYT = "d8fb4014-9116-4d08-a420-939a60293897.mp3";
export const chainPhonemeAudioYT = "6fdb65a3-1c5d-4061-a55c-48c63458e4e8.mp3";
export const zipPhonemeAudioYT = "5fbb5d4c-5973-4c81-bbf0-1b041d23e031.mp3";
export const motherPhonemeAudioYT = "baaabf69-6201-4341-8dc1-6c54bf58b086.mp3";
export const bluePhonemeAudioYT = "dd071245-eb86-46db-99df-daa3a66ae0ec.mp3";
export const ballPhonemeAudioYT = "5ea8ae82-7d77-4876-9fe7-c5ffb625757f.mp3";
export const rainPhonemeAudioYT = "2bd5c50c-5727-4239-abb4-6cf3dcf202e3.mp3";
export const quiltPhonemeAudioYT = "af4424d8-fe3c-4d1c-8438-abcba0620e02.mp3";
export const sisterPhonemeAudioYT = "6964ab5d-cbc7-45d3-a23e-60344f8dfa02.mp3";
export const yakPhonemeAudioYT = "ac906bb2-7492-42c1-99b3-324f9467e603.mp3";
export const chairPhonemeAudioYT = "f3d7b913-1c5d-4306-9b02-d390d66dfadd.mp3";
export const fishPhonemeAudioYT = "01ad2b85-75db-4f57-9867-4b50821a4f17.mp3";
export const pumpkinPhonemeAudioYT = "a73be606-455a-46d4-97e9-a5c7040ae282.mp3";
export const applePhonemeAudioYT = "8805e310-ab74-413f-ba88-761b9fc3a392.mp3";
export const piePhonemeAudioYT = "28ea41e4-54ee-4522-bb92-b1854a1cc591.mp3";
export const windowPhonemeAudioYT = "fbeee191-0424-4198-aba6-5d188a379c9f.mp3";
export const lollipopPhonemeAudioYT =
  "1ac624f2-495d-4d96-bf52-ead276d4bc02.mp3";
export const drumPhonemeAudioYT = "fd27767f-0cd7-4c16-8fe9-fbe2095ccd87.mp3";
export const nestPhonemeAudioYT = "2b658c87-9325-46ae-882d-ad9bfd8f984d.mp3";
export const orangePhonemeAudioYT = "b8cb62fd-50f2-4f0d-9156-4d1eed5d21be.mp3";
export const cloudPhonemeAudioYT = "71984b09-190b-4fdc-8096-c4b168ada080.mp3";
export const cornPhonemeAudioYT = "e28ca36f-661b-42de-b7dd-ae64dff8eb3e.mp3";
export const umbrellaPhonemeAudioYT =
  "7181b745-b09f-4680-94fa-bc752ae06585.mp3";
export const monkeyPhonemeAudioYT = "ae42e400-7d52-45de-83bf-f28baae77f09.mp3";
export const vanPhonemeAudioYT = "71f47d42-6e25-4d4f-9596-1b0cfe03e390.mp3";
export const iglooPhonemeAudioYT = "76572697-c5ec-4a51-83d9-bbef8381402e.mp3";
export const foxPhonemeAudioYT = "dafeeeec-3f20-4804-91c7-195424b5aa8c.mp3";
export const rainbowPhonemeAudioYT = "91fa4537-0b69-4830-bf10-aa56d229ff58.mp3";
export const treePhonemeAudioYT = "27d37270-d2b1-4505-9dea-7d16e7d7f08f.mp3";
export const treasurePhonemeAudioYT =
  "724508f5-c5b3-405d-bae7-d31d362bb37a.mp3";
export const coinPhonemeAudioYT = "c7131e3c-3d4b-4cf3-ac26-44cbde9ba1ab.mp3";
export const sawPhonemeAudioYT = "a242d2b6-c8e9-4672-be6a-5e6b406d09d6.mp3";
export const jamPhonemeAudioYT = "3b9c2371-4a60-49c8-8411-43be1b870041.mp3";
export const grapesPhonemeAudioYT = "a6eff47b-4a3a-4935-bcd9-958543aa26f1.mp3";
export const sheepPhonemeAudioYT = "78921841-6a6e-48a6-9a42-4ec3176bffe7.mp3";
export const hearPhonemeAudioYT = "b7a36c03-44c0-4082-b806-ab293a73d899.mp3";
export const beePhonemeAudioYT = "314486a1-8de7-40c3-96e4-090b8ee0fa90.mp3";
export const eggPhonemeAudioYT = "fd04ca68-9c1e-4924-9bf6-67cc6d17576e.mp3";
export const carPhonemeAudioYT = "319ef759-b656-4bcd-92e4-653e6ed8e57d.mp3";
export const handPhonemeAudioYT = "1b62af74-516a-412e-a049-28b6f4b6fc31.mp3";
export const singPhonemeAudioYT = "b8aa7950-7985-43d1-bac3-12773bcd762c.mp3";
export const sunPhonemeAudioYT = "97295ef6-ce46-4612-828e-7a3ca295129e.mp3";

export const cupImage = "bb5e9e21-3939-4127-8b45-bf70045a5a01.png";
export const kingImage = "88b7b90b-fd48-4c50-8bf1-47e9de941b06.png";

export const CrowTwentyThreeImg = "7039f764-a61c-429f-9aba-890639d88161.png";
export const teacherEightImg = "d2d2ff47-a608-4cb0-ac67-41f3a26ce308.png";
export const peaOneImg = "e8711602-20dd-4dc8-9334-c14edd313865.png";
export const dogSevenImg = "b6b282c7-7095-40f8-849f-c39c2ebc5173.png";
export const orangeFifteenImg = "12802045-cff7-44e5-a12f-d36a9909117c.png";
export const appleOneImg = "f83e7d27-4bb7-4ff9-815a-bfdc39fb6198.png";
export const dogFourImg = "8a6e7ec1-913e-4893-865d-904a9b9eb24d.png";
export const tigerTwentyImg = "eda4132e-0599-41b1-9046-f7cd35a25885.png";
export const carrotEighteenImg = "ec2be172-44c3-48f8-9b28-2f89f16c2fbf.png";
export const busNineteenImg = "e3ab7e88-fb96-4b67-9789-a0e9a0838f78.png";
export const kiteFiveImg = "acacfe44-79a5-4f7d-a438-6ecb6bde7e0c.png";
export const penFiveImg = "b44ad14e-db23-45db-913c-6b44a17164d5.png";
export const queenSixteenImg = "5793d1b1-3e39-4c24-86ac-b4475f539d35.png";
export const umbrellaTwentyOneImg = "f43e5389-ab25-4998-b28b-03aef23dbd02.png";
export const watchTwentyImg = "ed06a69f-fe5a-4791-86b0-77abbcafe0e3.png";
export const earthEightImg = "30df4040-68e0-4b2a-930c-b31b33fc7336.png";
export const LionTwelveImg = "a2e2d9c9-dd26-4eb7-b404-e65f6224bc18.png";
export const penFourteenImg = "7a25426c-4441-427e-a4f1-6f7253a98bdb.png";
export const tigerSevenImg = "c5c075e7-9124-4007-b0cb-57130dbad84d.png";
export const capSixteenImg = "bc3cdede-0e62-40e5-bdb4-f42c2c4eac5f.png";
export const cupImg = "bc3cdede-0e62-40e5-bdb4-f42c2c4eac5f.png"; // TODO: Replace with actual cup image file
export const plantTwentyImg = "0b88a768-2bc6-4a12-857b-5c5ac154dc23.png";
export const horseNineteenImg = "beb076e4-8fee-4d4f-b565-c61ace7f6aa2.png";
export const goatSevenImg = "6acdec07-99d6-4e22-8bf6-f15404374f72.png";
export const rajTenImg = "8d3a4053-f9ee-4b23-b56a-2e5c231a7cf4.png";
export const girraffeSixImg = "759bd706-d765-40cb-8d80-20d40090ab09.png";
export const cubTwoImg = "decea96c-15ac-4b91-88db-09476e9dcda7.png";
export const yakTwentyFiveImg = "8edc33ea-fc3e-4d6d-b837-5c9b0803a479.png";
export const HoneyFourteenImg = "f0728d4d-66e8-4ae4-93e0-03a02651508f.png";
export const kiteElevenImg = "9d200529-4f86-43a4-b3d1-fe2fcc602524.png";
export const BookTwentyFourImg = "c3816e74-6e00-462d-b74e-7d79209d6d42.png";
export const brinjalTenImg = "97860ee6-7856-46c8-94b6-cebe38208871.png";
export const mosquitoSeventeenImg = "924b819f-12f5-466a-b1bf-5ef01c492c77.png";
export const NestFourteenImg = "a8292cbc-5e8e-42bc-920d-ef5a437f4a88.png";
export const GuavaTwentyTwoImg = "aa8fd151-5ad5-492d-b366-ae68d0140b02.png";
export const eggFiveImg = "a5e3a32d-0824-480f-b089-48841fd76850.png";
export const zebraTwoImg = "98376705-66ff-4974-b934-fa754ee01e2d.png";
export const swordTwentyThreeImg = "88b235ac-5d90-4fe8-b670-87a4f619ff54.png";
export const zebraTwentySixImg = "55712e35-97cc-4ac4-92e2-1174e0d36720.png";
export const KeyTwentyFiveImg = "efa597e1-68f8-4eff-bc53-2a7729bdf2c6.png";
export const kingImg = "4f379beb-f279-4da7-b88a-56ae3f1f8f73.png"; // Using kingAlpTelImage as placeholder
export const LadduTwentyOneImg = "75508824-783a-41cb-998b-9dbae9833bb2.png";
export const DustbinTwentyOneImg = "7f77d88a-ee57-4822-a38e-fb49387ee4a3.png";
export const sunNineteenImg = "932a2d94-d50a-4b89-ad1d-dcaa22704009.png";
export const swordFourImg = "4a9aeab9-446b-414e-8ad7-a15cd6b1d97d.png";
export const pigNineImg = "d44bc567-ab2a-4981-b14a-b49c993e014a.png";
export const mangoThirteenImg = "45746d7b-258d-4ef8-8156-2dcf0540c5fa.png";
export const papayaTwentyFiveImg = "5699cb1c-9bbb-42b9-a6e9-b59dc22fcac9.png";
export const carEighteenImg = "9a022d9e-b689-424d-9f82-e89bef486563.png";
export const jamThirteenImg = "399fdf90-3734-4914-a0d4-ad795b6e4264.png";
export const catOneImg = "b5a39599-5775-4560-8fd7-c21c707af29c.png";
export const BalloonTwelveImg = "140c7eca-db28-4112-8fd2-eb7a7bb7fed7.png";
export const foxTwentyFourImg = "c610f7f2-a7dc-4a11-8ed3-715f48ed43a2.png";
export const lemonThirteenImg = "7025566e-4bfb-4206-b651-1702a140042e.png";
export const dhobiNineImg = "0b3fd1ed-6d46-458b-b7c5-bfa4db6ef7b4.png";
export const fishSixImg = "83cc685d-1e1b-4698-8e5e-7ad5c841a414.png";
export const bellTwelveImg = "01ad1df8-968d-4e7d-afc4-244bf806202b.png";
export const xrayTwentyFourImg = "8639ec61-af2d-4522-b0b3-559b20f7c334.png";
export const bookElevenImg = "e34a6ae5-5f9b-445e-8951-8fdbdb626882.png";
export const catThreeImg = "58b72554-5d0e-4ada-a0d2-604973678483.png";
export const VanTwentyTwoImg = "a47dd1cb-3a74-4b1c-8f49-61c316a251fa.png";
export const jamTenImg = "bf1a0eb2-fa55-4e72-b2d9-dbe7b28e6620.png";
export const iceThreeImg = "75b45194-1793-4531-9e5c-3659bcac2fd9.png";
export const monkeyElevenImg = "6365521b-8c95-4f03-9205-b61cb5bc154b.png";
export const LeafSixImg = "43333fd8-4232-4add-93e4-953f8df1f6b9.png";
export const ratEighteenImg = "c6c8c6c9-a43c-4575-89e9-e4c5b7c70e6a.png";
export const handEightImg = "c1500135-f677-4b94-95d9-6c3660d221ca.png";
export const garlicThreeImg = "438ceb95-be87-46ff-95dc-44e38859482b.png";
export const PuzzleTwentySixImg = "41169c67-fedd-4f34-b983-3a41393bb178.png";
export const ball = "42c3e65e-8667-4956-b860-c2547e0a43d7.gif";
export const window = "1f785e37-aad0-4a59-a13e-24265e312afd.png";

export const yak = "fd090f8c-0702-40d9-99e9-d1bbe75e014f.png";
export const sing = "b78ca4cc-05fe-4d65-8ee8-b3cab2056a6d.png";
export const saw = "7fa4a172-4165-4b1c-a46b-2713bab40572.png";
export const ballTwoImg = "94bcdb2e-6ea5-4b6f-a8bf-8ef12ba5e24f.png";
export const umbrella = "d62c6de5-d2f8-4035-81b7-6e7072af87fd.png";
export const barbecue = "470aa619-37f2-4389-9daf-148d67bdcb5e.png";
export const corn = "574ae541-f2ea-4fde-9aa1-5e2e9cc1f929.png";
export const chain = "1c6e6bdd-b4ee-4fa0-aa50-1a6c4dae5469.png";
export const sister = "f4035b9e-7b13-4b79-9422-3df944a89aaf.png";
export const sheep = "551cee58-e9b2-4abe-ad1b-e8c1bad082c6.png";
export const igloo = "c97a2021-acd0-4b76-ac07-2f372083929c.png";
export const book = "60f9e94b-2e20-4468-af3b-704e2e2ddc98.png";
export const motherGif = "f40fa26f-0ff1-4f35-a638-a4572739e189.png";
export const boat = "37d3a5fc-2930-4613-a25f-2a386e68bd29.png";
export const bee = "aef5ce6e-afae-4cbb-8d0d-2f249bec0f44.png";
export const quilt = "39c1c701-44c3-4ef0-ad62-44965fbaa8c2.png";
export const star = "110c4502-8e8c-4c9f-b86a-e4b31689d31e.png";
export const fox = "eb1ac5f8-8c7f-43ca-8e56-c388ec9749c1.png";
export const hear = "762ec2a2-4e49-46be-a4b2-c04f3d2eeab6.png";
export const egg = "bed83726-832f-4090-be2c-b3c1cad76c62.png";
export const windowFourImg = "435db5bc-066b-4e7e-91b7-a51e317ce82a.png";
export const tooth = "453ed734-cc8d-41ce-bb82-b22b32f277a0.png";
export const cloud = "3b7fd608-3587-4895-b173-b78ddf6cf635.png";
export const windowGif = "1f785e37-aad0-4a59-a13e-24265e312afd.png";
export const chair = "0bedc1ea-acb0-49c1-bf5d-fcdf35547bdb.png";
export const coin = "0fcef35e-be34-438f-aa27-26bbf8333cb0.png";
export const jam = "b977561e-90ff-414f-8b80-4b5cd6341efb.png";
export const apple = "664cfadb-e7c1-4b7b-938d-94a11d0dd24e.png";
export const grapes = "0f20a751-5ed3-4603-83e8-76bbecd3a8c7.png";
export const hands = "89662c57-b8d9-497f-b9be-82a75a808620.png";
export const orange = "88c75884-0053-4c4d-b4ed-8c529794cbeb.png";
export const moon = "6ad3de93-0f5d-4644-ae12-06c431bdc89f.png";
export const pie = "5136ebc0-e568-4ae6-9226-bb7db1d00838.png";
export const van = "dff7b73d-8cc5-4ffc-846f-3783a48f51f6.gif";
export const lolipop = "f4fb9b99-3263-4da6-b0ef-4e73ab3579e1.gif";
export const tree = "2ae72801-0309-4d7e-bd76-480d1c3f1017.gif";
export const nest = "2e7c1d61-8ab7-4f5e-aeec-9701ce5dca76.gif";
export const car = "f2a92815-a9d8-4702-8849-f823c849d11e.gif";
export const monkey = "9a3ce608-fae5-4318-86eb-3064107716c7.gif";
export const sun = "576a56e4-159b-4d70-a27e-791fc9ff4280.gif";
export const pumpkin = "8adc18b7-6f32-4f5d-a762-5a871be506fe.gif";
export const fish = "20edd691-eece-458c-930c-748b5a0a9158.gif";
export const rain = "cb921941-5e59-4e4a-8501-4937520bb43c.gif";
export const rainbow = "df1cd94a-cb12-4384-a6ae-55174199d411.gif";
export const treasure = "3903bbf2-b1f3-48b1-9248-9b0b0c641dba.gif";
export const drums = "1bf29dc7-c3c1-40cc-b6f8-6ec43cf56bd2.gif";
export const ballGif = "42c3e65e-8667-4956-b860-c2547e0a43d7.gif";
export const zip = "141ac1fb-8acc-4ede-8396-f62722e413b7.gif";

export const RA15b = "b90c0403-a7cc-4f54-a868-07931331e9b2.mp3";
export const RA5c = "6bb5e5e4-34ca-4241-91bf-3c236eae63ab.mp3";
export const RA5b = "40fff886-bac1-4f59-b489-61616ffd4c4e.mp3";
export const RA15c = "4d37819e-8505-4446-8b90-9114f0d77360.mp3";
export const RA9c = "2e53112a-fdad-4547-902b-115a19b1f138.mp3";
export const RA9b = "945b70ba-74f2-4b8d-9c5e-8d2075075821.mp3";
export const RA8b = "47e8480c-a545-4d0b-9006-e23742db537d.mp3";
export const RA8c = "e540c846-568e-44ce-847f-2a3aa5a04c48.mp3";
export const RA14c = "831f9075-9a84-4bc3-8856-c26453ad044d.mp3";
export const RA4b = "f63c7dcf-4b5b-4c8a-93a2-0849a24f6eb2.mp3";
export const RA4c = "cbef75bb-863d-4dd3-a2e5-f98e4f2bbaec.mp3";
export const RA14b = "75327be9-a673-4773-aa7f-219616f2b202.mp3";
export const RA13b = "a63a858e-51c0-4fc2-a4a2-2dd34beb9c85.mp3";
export const RA3c = "6489cabd-4687-4b59-a735-ab0a37196d14.mp3";
export const RA3b = "a019c6a7-d403-4447-b19a-91b4cc4d501c.mp3";
export const RA13c = "febd2261-bcd2-4a41-b8c1-c180be23e625.mp3";
export const RA12c = "98a69048-5af9-4f56-a74d-ae4ba278010f.mp3";
export const RA2b = "33967767-bc70-4159-968d-a7a54c8560ab.mp3";
export const RA2c = "6701510b-80df-4341-ab63-12cbb4ad4367.mp3";
export const RA12b = "e0d7921d-ecc1-4acf-857b-5d0fe54cc1d7.mp3";
export const RA11c = "2b8eaa9f-4c29-4491-be28-033777f74bfd.mp3";
export const RA1b = "0a312bf7-0bf7-437b-8f5c-36102c490480.mp3";
export const RA1c = "66841c5f-56fa-4a7a-91f9-20b03900b929.mp3";
export const RA11b = "d973da95-dff2-407d-8e5d-3994be546965.mp3";
export const RA10b = "f0d650f0-56f7-4989-91fc-a79f9c1c25d2.mp3";
export const RA1ato15a = "2c6ac74c-a71f-427e-93bd-20b3412d662b.mp3";
export const RA10c = "95ceb4c4-9d51-4bff-befd-a6e9cb904224.mp3";
export const RA7b = "2bf2848a-f28f-44f1-8d44-9c6dfe0042d9.mp3";
export const RA7c = "341f85d3-ff9b-42b7-ba2d-0fe385fbc032.mp3";
export const RA6c = "c2befd54-1d58-4e81-ae74-bfae185decef.mp3";
export const RA6b = "47bd0fe3-dcae-409a-962d-1d5358b41f2b.mp3";

export const R7_2 = "602b555d-bee8-4e7f-8872-e0740d038823.png";
export const R5_1 = "a1f58954-917b-49fa-8340-c94776cdea7b.png";
export const R7_1 = "48e2aec4-eab2-4606-8bbb-4689258767a2.png";
export const R5_2 = "320d2a53-124f-4237-8c2a-6285d1a0e58b.png";
export const R1_2 = "6d6010cc-abca-4741-802a-c81b6c29f9de.png";
export const R3_1 = "5e59a23e-158c-40a0-8135-cbc399493293.png";
export const R1_3 = "01714ddd-d373-49e7-9db8-df36381ce625.png";
export const R1_1 = "96e197fb-4132-454b-bc86-711040ee0b9f.png";
export const R8 = "7a9576ff-9369-4c97-9eb2-5d25ec75848d.png";
export const R9 = "936b8806-5335-46f8-a6cc-b495df067a2a.png";
export const R3_2 = "b475906c-20f1-453f-9561-171fe7436ed7.png";
export const R6_1 = "a1ed0c41-e416-4bd1-a7cf-7e7904585c14.png";
export const R14 = "feeb8fd6-f2b5-414c-9b92-c13348c47752.png";
export const R15 = "8957953d-efbe-406c-81a9-e42e85077707.png";
export const R4_2 = "4d64dedf-9897-4f68-8590-8ee06c9ed430.png";
export const R6_2 = "c9059f26-762c-4858-a8d3-e8033d292c3b.png";
export const R4_1 = "6535e0cc-d5f9-4b66-825d-1fca88d0545e.png";
export const R12 = "74b1cb29-899f-40eb-908a-2dacd1dcc850.png";
export const R2_2 = "ceaeb019-f6db-43de-bc3d-6a6e7857081c.png";
export const R13 = "30a202e9-f5cd-4e9c-bbe0-86b25ffa8d70.png";
export const R11 = "23bf77ad-7eef-49a9-a7a2-8300d7d0704e.png";
export const R2_1 = "addbd99a-fd79-4a2f-a5b9-75e3ba282431.png";
export const R10 = "1d7c2915-836a-48ff-900a-452fb08a8693.png";
export const R10_1 = "ec402d39-86de-443c-aa2f-a58f7f44c19b.png";
export const R12_2 = "7b02085c-9507-47fe-ad78-ac534a07cb1a.png";
export const R10_2 = "af4a1333-2d59-4540-99b9-c139716f8e7f.png";
export const R12_1 = "696d4c7d-8227-49b2-9776-4fdc9321ec80.png";
export const R8_1 = "4ed96594-d069-4ecd-a47e-952d294da635.png";
export const R14_2 = "66ff57c6-f7ed-4ddd-a21c-14a53c153dbf.png";
export const R8_2 = "459409a2-d978-49d3-a6f8-1923ee52dae4.png";
export const R14_1 = "2961d801-eb4d-4cbe-8efe-afd04191f9fe.png";
export const R4 = "5eda1be9-81d6-4a43-8a6a-e56730fdaef7.png";
export const R11_2 = "ed4e7893-0750-4aab-88b8-8c46892dc50b.png";
export const R5 = "4523d961-ef4d-40ee-a829-10678f76e521.png";
export const R13_1 = "2247c168-bcfb-4be3-806e-0c46b6c246c7.png";
export const R7 = "136453a9-46c0-4277-baa7-756a2d604c96.png";
export const R11_1 = "38d11a7c-bd6d-4c13-85ba-d05379ec1f39.png";
export const R6 = "6db45d65-03ed-4f21-a489-cac58c5e3180.png";
export const R13_2 = "9ad513a1-88a6-4cd7-a220-9215b17ca7d0.png";
export const R2 = "84811ade-c50f-491c-b6ff-7680ad24208a.png";
export const R9_2 = "ee63530d-514e-4749-9a6a-beac7fb31856.png";
export const R15_1 = "2c866382-3c4b-492d-987e-d73aa4878223.png";
export const R3 = "1dae0011-b1a6-4768-9cd6-2a446c3e7595.png";
export const R1 = "e7f9320f-2735-4f06-b10a-f984b35739d3.png";
export const R9_1 = "094fbc32-e858-4cd1-97af-8acb80e0781f.png";
export const R15_2 = "5d28d025-3089-45d9-b396-c9aae36398b4.png";

export const leafAlpAudio = "1a0c6e70-d449-4059-9fb5-392af325fbc2.mp3";
export const featherAlpAudio = "d703a368-424b-492e-89d3-1bcac426b9eb.mp3";
export const assetMoneyAndJewelsAlpAudio =
  "dee29e31-c04b-488d-8a13-ba1420ba7551.mp3";
export const foxAlpAudio = "7e726331-f455-40b3-9c91-ade8b79d5911.mp3";
export const creeperAlpAudio = "36d5e551-2645-4d5f-b325-741cb7d0a5fd.mp3";
export const earthenLampDiyaAlpAudio =
  "b8df59b3-7c4a-4009-8894-85b89b1afb4f.mp3";
export const kiteAlpAudio = "f54dcf8f-e1e4-4218-8e7b-ccf8ce0870a7.mp3";
export const crocodileAlpAudio = "d2a6225d-6406-46f4-87fe-e363ef19d23d.mp3";
export const goldChainAlpAudio = "85146f6d-60e1-49bb-9b75-88d8c812b7ad.mp3";
export const bellyAlpAudio = "665b807c-e125-42d4-9283-c50d79f64782.mp3";
export const mathAlpAudio = "1f1921ab-28ea-4b64-9e91-b48219c27fc1.mp3";
export const kheerAlpAudio = "92c8c754-002f-4501-8ed5-2d9f1671f42a.mp3";
export const jewelariesAlpAudio = "474d14cd-3717-4735-a73e-7659613a3f5d.mp3";
export const mealAlpAudio = "35ef3070-c011-4ec1-ba46-950e49e8865a.mp3";
export const cow2AlpAudio = "8d4e8b40-e5c7-440b-a396-47854ba2e694.mp3";
export const fearAlpAudio = "8684920e-bd31-4dc5-b3dd-49d4b5ab5865.mp3";
export const fragranceAlpAudio = "f24202a4-d4b1-45a5-9526-cd830080fc0b.mp3";
export const jungleAlpAudio = "dd852efb-c61d-41d9-9271-c985a0545af5.mp3";
export const lotusAlpAudio = "97a38f2b-bb3e-4e74-8b54-ab8bee6acfcc.mp3";
export const manRingingTheBellAlpAudio =
  "b21faecc-64fe-45d7-96a2-40f18c3fe143.mp3";
export const hexagoneAlpAudio = "a3e36851-1dcf-4639-bb2b-aa18c7ac13f1.mp3";
export const fiveAlpAudio = "cbfec947-c575-4d64-b987-c560dc3d6d19.mp3";
export const medalAlpAudio = "0bd80d15-6aca-4ad5-8321-430b0a47096b.mp3";
export const chariot1AlpAudio = "7dfc0727-ccff-4a9d-847a-ee8120af8f05.mp3";
export const familyAlpAudio = "34c65d5b-0a61-488b-9924-5a65ea2a3ab5.mp3";
export const frontPartOfTheNeckAlpAudio =
  "3cebca03-bd60-4fd7-9c80-d8fbdcf23caf.mp3";
export const cowAlpAudio = "314607d9-6d68-4db9-b661-69fd80ccbb7f.mp3";
export const fingerAlpAudio = "048fae1c-e3e2-40d4-b152-92b2c5c68625.mp3";
export const countryAlpAudio = "88b0f2f9-906c-4811-ac0a-92bf9338b81c.mp3";
export const dreamAlpAudio = "77ecf439-5e32-4c64-8af8-e0a640fc8292.mp3";
export const camelAlpAudio = "9011a27a-927a-44d2-a577-d9720d69c6ff.mp3";
export const angryBoyAlpAudio = "d7db91c4-a94a-49ca-bf13-c08b3542e4e5.mp3";
export const cotAlpAudio = "e40005d1-ef0a-471b-bd8d-3787e0a4d579.mp3";
export const joyHappyAlpAudio = "6f0a9125-b154-416b-9d8f-639fa772bd79.mp3";
export const highschoolAlpAudio = "c046f540-ec64-4e37-80a4-cc4be841279c.mp3";
export const ladderAlpAudio = "e6913008-7b58-4bf7-99f9-6cce58f7d9b5.mp3";
export const greenPeasAlpAudio = "25dc5a02-7214-4aed-a222-418716e3f95c.mp3";
export const anOxOrBullAlpAudio = "b2e08305-86df-43d6-9df4-461431458a42.mp3";
export const hairAlpAudio = "c6c5ec4f-7db5-42d6-9e32-a76a0d94a707.mp3";
export const bellAlpAudio = "dc888d47-0fcc-4aa2-88a5-c9eb80d91a9b.mp3";
export const kingAlpAudio = "057dc4c7-febd-4a0f-9605-c867e80b9f18.mp3";
export const gaadhaNoImagAlpAudio = "d30f363a-e172-49a0-b3b1-50f707606abc.mp3";
export const fanAlpAudio = "cad1f181-50b0-4972-bcc1-e1cff95367e0.mp3";
export const fruitsAlpAudio = "587299dd-f51e-4370-8e13-e98078de7bbe.mp3";
export const maleSheepAlpAudio = "c78dbc43-10cb-4f44-94fd-3468474bc007.mp3";
export const elephantAlpAudio = "e0588408-f180-4012-9220-616da587c7c0.mp3";
export const associationAlpAudio = "fcd928f7-8336-4028-903b-773afb8605af.mp3";
export const lionAlpAudio = "a7ecfe42-4bdc-459c-8f64-18682c28207a.mp3";
export const boltAlpAudio = "b50411a0-227b-4263-a510-84164c8d00bc.mp3";
export const chariotAlpAudio = "8d3baecc-da3e-42d4-861f-ed6191666a8a.mp3";
export const runningAlpAudio = "c27e8576-f5cd-44ce-aa6a-f79f6f73b3b7.mp3";
export const rockSaltAlpAudio = "bcafb356-d716-4ff1-a960-a47a95a9ac12.mp3";
export const phlegmAlpAudio = "8e87c582-0175-40a5-b5f9-145fd1a58fb5.mp3";
export const oceanAlpAudio = "59126c40-1073-4838-b31a-259f6708b64e.mp3";
export const medicine2AlpAudio = "770ae1fb-08fb-48ec-9c19-2fce6cc7e7fa.mp3";
export const swimAlpAudio = "890b5c0b-e09c-4cd0-b0bd-d6b31a102d33.mp3";
export const shiningNecklaceAlpAudio =
  "8c7eef30-3729-4f01-843c-e24f7e8aac53.mp3";
export const snakeAlpAudio = "08ccc274-a639-4bcb-a3b0-473ee6f5b022.mp3";
export const peopleAlpAudio = "4fd1736b-d2f3-45fc-a3c8-9d97674a96ac.mp3";
export const vehicleAlpAudio = "07b7f672-a01e-48c6-8c4b-df218cb66dc7.mp3";
export const playAlpAudio = "091f3def-6b32-4a69-a6fb-a13c33a65053.mp3";
export const swordAlpAudio = "eb9b822f-2182-4437-8ac6-680e99e48cb8.mp3";
export const windowAlpAudio = "5ec1a14d-44a5-4938-a50a-b4c5af1809fd.mp3";
export const tabalaAlpAudio = "8cb24205-349c-4678-ae0e-711ce02af7c4.mp3";
export const moonAlpAudio = "21db8c9a-40d0-4ff3-b153-202fd832a19b.mp3";
export const shakingWithFearAlpAudio =
  "07094176-161c-4e3d-bdd1-8fed2cad14a0.mp3";
export const shivaGodAlpAudio = "e5f5c8cc-6488-48bc-bb71-63d32affe0f0.mp3";
export const wolfAlpAudio = "f1e07bfc-8c5f-4fa4-b438-6724b33da5f6.mp3";
export const mouseAlpAudio = "121abb31-d8d6-4188-9357-d7852e9313c3.mp3";
export const washermanDhobiAlpAudio =
  "e1b6b280-5665-4bfb-bfc8-c6a67fe331cc.mp3";
export const skyAlpAudio = "01ec453e-be20-40f3-8649-ef384ac6a41e.mp3";
export const moneyAlpAudio = "7544ad70-a8f8-46a4-b769-03b74f10a0ea.mp3";
export const treeAlpAudio = "bcd38151-6e88-4edc-ab34-7cf69691aac3.mp3";
export const tenInASetAlpAudio = "e19fc090-cf86-4241-b940-80380a309658.mp3";
export const roomAlpAudio = "32d2c27d-ea31-45ba-8ce4-cdf24b2bb8c2.mp3";
export const wednesdayAlpAudio = "9818822c-1ad8-4763-81b3-cf8284fc563d.mp3";
export const swanAlpAudio = "92985fd7-8b2e-419d-88a0-024c66afaec4.mp3";
export const yellowAlpAudio = "e6690575-2179-43ac-aefa-9e0455de5e39.mp3";
export const yamaAlpAudio = "6a68bce3-f147-4817-965d-5cc6434408e9.mp3";
export const palmAlpAudio = "dbf83295-b1ec-4837-8a1b-ca3b7ce8dd8b.mp3";
export const seedCornGrainAlpAudio = "8dd35eb5-11f4-4fcc-a127-c8ccbc2ccce7.mp3";
export const sageAlpAudio = "d07dc6c9-d535-43f7-8396-9f2c2f2d13ba.mp3";
export const shopAlpAudio = "f8119d3a-56cc-49a4-a592-588f7dfbbd49.mp3";
export const purushaManAlpAudio = "5aca5100-a399-42a3-a24b-0e0f6047944d.mp3";
export const medicineAlpAudio = "d84594a8-7ee4-4eb8-b3bc-2230bf4f975d.mp3";
export const solarPanelAlpAudio = "d3d6d95d-0aa9-42d9-ac0a-6f47185033fd.mp3";
export const snowAlpAudio = "5ee53bd3-afe2-46a4-8501-21721efd873d.mp3";
export const smallBoxOrChestAlpAudio =
  "e6acee39-68e5-4288-a833-b83b0c2bd7d1.mp3";
export const plantAlpAudio = "a3c59c02-1fcd-4fe7-89fd-6e4f3d690b43.mp3";
export const namasteAlpAudio = "4c6c7577-2670-4466-b9e2-6b22d8d1c071.mp3";
export const rabbitAlpAudio = "532ee197-96b0-450c-9600-30c0f10211a6.mp3";
export const spoonAlpAudio = "a0ce9f7d-0b6b-43dc-a6c9-d132d169c3f9.mp3";
export const paperAlpAudio = "f9ca6881-317e-4333-90ee-f0354b0b2384.mp3";
export const shoulderAlpAudio = "ee3f1795-42c5-4e53-8622-a4e710334136.mp3";
export const penAlpAudio = "064d7bae-3f7b-4704-b3f6-7850e8909755.mp3";
export const tabalaaAlpAudio = "548b92c4-c2c0-4efb-8fa5-9e11e18c32c0.mp3";
export const thiefAlpAudio = "b5f90d89-de31-4c76-b599-80226700d4b9.mp3";
export const weaverbirdAlpAudio = "8e34a777-2640-4afc-b3ed-fde6768916fc.mp3";

//images

export const fingerAlpTelImage = "4e41171e-12eb-412d-a750-311fde646f30.png";
export const moonAlpTelImage = "174f0531-f145-4045-bcd0-b031bd5c4d6c.png";
export const shivAlpTelImage = "e6079819-d66d-45be-a68b-83710fcd513b.png";
export const ratAlpTelImage = "feff971d-c169-4668-969d-4f635e6b4d9a.png";
export const countryAlpTelImage = "7fab8475-045d-46a5-b77a-8c982575ec43.png";
export const familyAlpTelImage = "06f51a5a-7d95-449b-a38e-5a31163ed3dc.png";
export const yamrajAlpTelImage = "58853b62-d17f-459f-ba31-4008567871b8.png";
export const fruitAlpTelImage = "46b7f782-e11a-48d6-ac27-1a992357af88.png";
export const swanAlpTelImage = "01fd62db-a703-4e8c-b57d-11e07ba031c1.png";
export const treasureAlpTelImage = "69396d88-9c33-47f7-b6b8-eba9ffd1680d.png";
export const lotusAlpTelImage = "e745d4ff-5613-4671-af81-9842ce86ed3d.png";
export const foodAlpTelImage = "8d7bf1a3-395c-4741-a820-fffd05deb9c6.png";
export const colorpencilAlpTelImage =
  "d8549b66-fab3-4c1c-ae94-8256631db89b.png";
export const horsechariotAlpTelImage =
  "e5206af3-810d-4348-83a0-0c5193c155dc.png";
export const swordAlpTelImage = "88796552-7a16-4b9c-ac03-cfab609cd3d2.png";
export const drumAlpTelImage = "0e9e8c57-0509-4d4a-8586-01a9e3841b12.png";
export const hexagonAlpTelImage = "2cd99ca5-9c96-4d5a-91c9-5f5c3125b506.png";
export const necklaceAlpTelImage = "1dbc4083-68a5-4b0c-bd34-82b298936b81.png";
export const fiveAlpTelImage = "26cea228-bf75-4075-a0aa-c3fcd0707bab.png";
export const jewelleryAlpTelImage = "8856c235-bb2a-4eb8-9e63-b5a5dc005b33.png";
export const happyAlpTelImage = "08dab3fe-c865-4e38-ad51-d1dd06308e6d.png";
export const childrenassociationAlpTelImage =
  "e534c038-60da-44d9-90b6-00ee33e693f4.png";
export const fanAlpTelImage = "c991bcc4-0d7f-4919-890d-31c62fb638c2.png";
export const thunderstormAlpTelImage =
  "f931eb29-359c-4c36-8300-de325d9eedb1.png";
export const monkAlpTelImage = "1607cce6-6288-45de-96ff-8217c4dc1d88.png";
export const birdAlpTelImage = "b02aca59-0376-4de2-9cce-a077b9db0a73.png";
export const leafAlpTelImage = "eea77b2a-f2a2-49b5-a46e-b3ee6ddfc917.png";
export const kingAlpTelImage = "4f379beb-f279-4da7-b88a-56ae3f1f8f73.png";
export const cerealAlpTelImage = "7dfae44d-906e-4045-bcef-48aa1e08fb05.png";
export const fragranceAlpTelImage = "87cc656d-5a20-4afe-901e-386abc700dec.png";
export const weplayAlpTelImage = "8cf1c600-16c2-4c89-a46f-cf8bc7bf72b1.png";
export const fearAlpTelImage = "8d42c984-ef45-4f05-a4f5-27bb88c84e59.png";
export const foxAlpTelImage = "cad89d2f-5895-463a-9ade-a5fd3cb33682.png";
export const featherAlpTelImage = "a7a01039-7e0e-4144-b2c6-5399545344e4.png";
export const hairAlpTelImage = "fe2ab25f-06b0-441a-928a-db166e025c95.png";
export const lionAlpTelImage = "9392ed88-625b-4c08-928c-642a1c168b94.png";
export const windowAlpTelImage = "19980eb7-1975-406e-8197-ac40d82136da.png";
export const kiteAlpTelImage = "d1596a61-011f-425a-b4bc-8431c072d968.png";
export const schoolAlpTelImage = "81aab210-6c49-4f56-9e13-ea8227f8e16b.png";
export const medicineAlpTelImage = "58b14867-8dc9-4797-8229-1ca9ee474117.png";
export const coinAlpTelImage = "1e05c89e-d93c-48cd-8626-e2d34b354ee2.png";
export const mathematicsAlpTelImage =
  "53ed7494-b7e6-4e0f-a5b7-e7f5ce89fe83.png";
export const coughAlpTelImage = "ee9cc62b-0312-4eb1-90cd-a7d63f593237.png";
export const sheepAlpTelImage = "5ebd3471-7774-46e1-a7d3-61efa82056f4.png";
export const manAlpTelImage = "631a44eb-2187-454e-bbcc-98004113b060.png";
export const peonAlpTelImage = "30ac3c0a-5150-4943-855e-d57893de71a9.png";
export const solarAlpTelImage = "bcd68769-350b-43c0-8b23-8f640e38b66e.png";
export const peasAlpTelImage = "87de9f6b-5204-4705-a573-3b4cb9959084.png";
export const pranamAlpTelImage = "55ce1248-16e2-4e43-abd4-260f6e3d5a78.png";
export const stewAlpTelImage = "2cf2c9bc-69f6-42fc-b9eb-7c38202d3200.png";
export const plantAlpTelImage = "7042677c-21d3-4dfb-8629-9c970b1b74c4.png";
export const crocodileAlpTelImage = "81462991-970b-4f7d-93e1-d66a4394cbcc.png";
export const spoonAlpTelImage = "4eeb5ded-7c95-4b98-8541-f11d7185674c.png";
export const beachAlpTelImage = "38780657-557e-4471-afb5-252eb508c39a.png";
export const candleAlpTelImage = "525fb136-fc31-404e-beac-ecc2f63bf046.png";
export const shoulderAlpTelImage = "a29f4199-e57b-4d7b-afec-8979083484e1.png";
export const elephentAlpTelImage = "bb82ad72-0cc2-49f2-a506-95c105265c06.png";
export const yellowAlpTelImage = "ce1282f0-e52b-4bb1-88e5-cae06be683a0.png";
export const saltAlpTelImage = "c3d3a849-781f-48a9-9a8b-0c1b5928793b.png";
export const treeAlpTelImage = "4cf124a2-bc27-4dec-a63e-f070551d822e.png";
export const peopleAlpTelImage = "e77999c7-1524-4440-9707-8c4d4b0a1ca1.png";
export const rabbitAlpTelImage = "c1d9146a-2e12-457b-b84c-e7830c722ccf.png";
export const cowAlpTelImage = "04a83da3-a1d9-4ddc-a77d-6cd53fe257a4.png";
export const angerAlpTelImage = "acbda781-1dd1-40e4-b275-e34c42f0dc83.png";
export const swimAlpTelImage = "8470766e-10ca-437b-871a-2ea9d626800d.png";
export const wednesdayAlpTelImage = "84d7753a-bec9-4054-9376-5e2dfc41986d.png";
export const parrotAlpTelImage = "3b547c70-f8fc-49e4-9743-ff07a81adc1c.png";
export const snowAlpTelImage = "7dc423e8-2894-4711-a1af-ca58a5255c7a.png";
export const bellyAlpTelImage = "7b315f27-2f6e-4da8-8102-b567153655e4.png";
export const bullAlpTelImage = "3f22de14-e65c-45e4-ac4a-e0d3ebb03b67.png";
export const tabalaAlpTelImage = "830d0adb-c5b1-4b91-830b-d12a10162a44.png";
export const snakeAlpTelImage = "ae0f04f8-4ca1-42a7-9387-99a87529c425.png";
export const camelAlpTelImage = "5e6a9174-e884-472d-9869-7cbc8f639ee1.png";
export const dreamAlpTelImage = "d3a8ec04-90b9-4ea7-937f-fce881f41605.png";
export const penAlpTelImage = "6533b3e2-e720-4792-aefa-b27690a9c95b.png";
export const forestAlpTelImage = "9fd9f701-c9f9-4784-987b-a9bcd86045c9.png";
export const skyAlpTelImage = "442d99d0-77aa-4bcf-84b2-93261afde1c9.png";
export const bedroomAlpTelImage = "39a0b5b1-75dd-444f-a3c9-1366041b8c3c.png";
export const carAlpTelImage = "b3942546-0c28-48a9-bfd0-5b9042a20562.png";
export const shiverAlpTelImage = "b26193c5-936b-4be0-b44b-ffdb845d8a08.png";
export const neckAlpTelImage = "0f4c9b34-671d-484d-97a6-3ff5182782dc.png";
export const boxAlpTelImage = "601e2943-c870-4dd8-9109-1af83476d37c.png";
export const stomachAlpTelImage = "3bd29efc-cd7e-476f-a6bf-ae7b9c62a6e0.png";
export const medalAlpTelImage = "97469169-e61d-4042-8657-1929b96c841f.png";
export const paperAlpTelImage = "f1b108b7-5cd1-428c-8198-b5b6100205d0.png";
export const runAlpTelImage = "fb5bb38e-d329-4631-a897-a2cc9d57b3cd.png";
export const stairAlpTelImage = "1987c556-46e7-4fe0-ac66-c97b1a1b86a3.png";
export const couchAlpTelImage = "58d17ace-20cf-4504-b0de-5706604f84b7.png";
export const bicepAlpTelImage = "75d35179-e97b-4fec-aa32-b8aadcadc1bb.png";
export const sheSingsAlpTelImage = "9be3f2de-f286-450e-85ca-fd634ea8829c.png";
export const tinklechainAlpTelImage =
  "1c6e6bdd-b4ee-4fa0-aa50-1a6c4dae5469.png";
export const wolfAlpTelImage = "324c81d3-5431-4933-9ae1-37384f2ba2d8.png";

//short audio

export const alphabetWithYellowAudio =
  "53a69e16-357a-404d-8e79-ea3b772756b1.mp3";

export const alphabetWithScaredBoyAudio =
  "d74c958f-0d96-41ff-a87d-3e5c230e8a83.mp3";

export const alphabetJungleImageAudio =
  "1446aa62-ffb1-434e-8b38-54c86903ac63.mp3";

export const alphabetCreeperImageAudio =
  "c94eeccc-89ce-4dec-a467-a14bde879caf.mp3";

export const alphabetHexagoneAudio = "9d576b60-635e-4927-b8d8-133bd3897487.mp3";
export const alphabetWithFruitsImageAudio =
  "aea35287-43ca-486f-8d85-cadd7bad437c.mp3";

export const alphabetWithCowAudio = "8da80e6a-8310-4ccc-9a00-dc6f48d6efc0.mp3";

export const alphabetTreeImageAudio =
  "ae71b5cc-77b0-4d16-8de6-d3d3900a4c24.mp3";

export const saAudio = "c504e802-3ae5-4dea-8127-39d3788cc6b1.mp3";
export const SHAAlphabetHexagoneAudio =
  "298244e0-612b-4565-a2a9-388739d5cd18.mp3";

export const wordWithCowAudio = "1013f5d5-ec16-42b3-8ede-1087e1e3daf1.mp3";
export const kshaAlphabetTeacherImageAudio =
  "272104b3-a43f-422b-b554-cdb53002c591.mp3";
export const moneyImageAudio = "3c06850b-2cf3-4302-bc82-81443eacc1f6.mp3";
export const kaWordBearAudio = "cf734fe7-d5dd-4b47-8a33-0871b521dd42.mp3";
export const u5thAlphabetAudio = "57a40716-3513-4152-a0aa-7d6f1e922c47.mp3";
export const wordWithYellowAudio = "253c1d0e-0fea-466f-871e-b4ae764542aa.mp3";
export const wordWithFruitsImageAudio =
  "96db0763-4993-492e-906c-159b2099bf0f.mp3";
export const taAlphabetWithThiefAudio =
  "85275bac-f325-47a4-97ee-a6204a9090ef.mp3";
export const wordMoonImageAudio = "43de657a-118f-4b8e-b17d-23575d16b9d9.mp3";
export const oWordWithCamelAudio = "30110403-1c44-4dde-8172-753ffd4aef1b.mp3";
export const thakkaWordWithThiefImageAudio =
  "ca49bca3-6395-470e-a354-00bfc3d13aa4.mp3";
export const wordWithGlitteringChainImageAudio =
  "eac96cc9-a4fa-4204-adfa-c857c03c5d50.mp3";
export const naAlphabetWithFoxImageAudio =
  "ac29536d-5c4e-4154-9879-9945d54c4880.mp3";
export const paAlphabetWithCrackersAudio =
  "4c07f234-632a-4c2b-a1bd-bda8adc543c7.mp3";
export const khaAudio = "d5e29a8c-754e-4c2e-b02e-0b7f65320de9.mp3";
export const uu6thAlphabetAudio = "a6b4a1bb-d237-4388-b0f9-f5cdcdb15661.mp3";
export const raAlphabetChariotAudio =
  "8c73a825-f48f-447f-a916-daea723c559b.mp3";
export const naAlphabetWithMoneyImageAudio =
  "004412f7-7404-400e-a6bc-34637c2384ac.mp3";
export const wordJungleImageAudio = "a54bc4e3-e40a-4a80-990e-b2253a8ba8ad.mp3";
export const ru7thAlphabetAudio = "42c432dc-fbbe-452a-a517-c4b77d467b42.mp3";
export const saWordWithGoldChainImageAudio =
  "3a66001e-8828-4d56-9110-553b882b0532.mp3";
export const khaWithSwordWordAudio = "697a54a7-4b44-4396-9364-1a72b1ac5b75.mp3";
export const oo12thAlphabetAudio = "98839aa9-8e57-48d9-85f4-f07ea2ee51c1.mp3";
export const wordWithScaredBoyAudio =
  "4a0eebac-4c01-47a2-b52c-dc7aa83406d5.mp3";
export const wordFor5thLetterInKaAudio =
  "9cbb790b-fd5d-438e-9bf5-dfa176ac8eef.mp3";
export const taAlphabetWithHeadImageAudio =
  "7c86aed0-383b-4f1a-9728-fadb37935f3d.mp3";
export const wordForChariotAudio = "377a2db7-619d-428d-9ce1-23d190c7fd93.mp3";
export const ooWordWithRunningAudio =
  "0366b325-70e7-4a4d-b638-f4ac84517114.mp3";
export const wordWithMaleSheepAudio =
  "0f8c8b38-67d1-47e1-809e-7fda1227cfd4.mp3";
export const wordCreeperImageAudio = "baea241b-1dbb-4364-8837-999c4ae27503.mp3";
export const shaMoonAlphabetAudio = "fea75236-8160-4044-a7f3-4f86048b0c65.mp3";
export const thaAlphabetWithGlitteringChainImageAudio =
  "1b0d77c1-f1f9-4793-ab0b-2d3dc1f07e27.mp3";
export const wordWithYamaImageAudio =
  "0a524844-2ee6-42ef-b4f7-a38706ded5ea.mp3";
export const ru7thAlphabetMonkImageAudio =
  "6774b432-a6fb-402b-be71-680c5bf94487.mp3";
export const yaAlphabetYamaAudio = "0a1f6d47-7d1d-449d-97e8-248fec83ae8d.mp3";
export const uWithWordBellyAudio = "459eeef8-9db1-4e50-80f9-dc4d389084d9.mp3";
export const wordHexagonImageAudio = "4a276dc6-456b-4f78-a585-3a1961dd193a.mp3";
export const wordWithFoxImageAudio = "d5284af2-6617-4191-bff6-8a38da4ad5fb.mp3";
export const uuWithWordMealAudio = "af1b365f-30b0-4e21-b846-587289b40b75.mp3";
export const o11thAlphabetAudio = "8a8967fc-4625-4123-85c8-28f88181bc30.mp3";
export const jnanaKnowledgeWordAudio =
  "f40780da-f164-4c62-8c60-fbcf64634c45.mp3";
export const kaAudio = "050a0c8b-beb5-4742-ad90-44d133b4278d.mp3";
export const saAlphabetGoldChainImageAudio =
  "c504e802-3ae5-4dea-8127-39d3788cc6b1.mp3";
export const wordTeacherImageAudio = "b1665ff1-b4d7-4bf6-83cb-e09ad03965bb.mp3";
export const knowledge5thLetterInChaSeriesAudio =
  "409ca28e-d0f1-4a5d-a2af-c2b71c8a9362.mp3";
export const wordWithMysoreDasaraImageAudio =
  "dc27ec89-0abd-4d83-b9a6-024608fd8556.mp3";
export const wordWithCrackersAudio = "b6e0800a-86ac-4c26-8e31-2670fbcc48ba.mp3";
export const taleWordWithHeadImageAudio =
  "f56646b7-d25a-442c-82f7-f0442f0342d0.mp3";
export const nga5thLetterInKaSeriesAudio =
  "4908d6f3-1ff8-460d-b5e5-b5a02d3fe84c.mp3";
export const wordBangleAudio = "e848fb2b-3d8f-4e2d-a9f2-8c07de3005ff.mp3";
export const wordWithTreeAudio = "7b4dc912-0156-4b69-96d4-13d734c97823.mp3";
export const ta3rdSeriesInKaAudio = "8f4fdf14-3049-4bd6-8add-e4cf6f908855.mp3";

export const am14thAlphabetAudio = "a55bcdcb-ca6e-471f-8061-b42b21df2657.mp3";
export const aiWordWithFiveImageAudio =
  "aa1e5632-30ba-403b-a964-ad1b4391654a.mp3";
export const dhaAlphabetWithSchoolBellImageAudio =
  "05dd8ce1-4cd8-4dca-a34e-06f410ce2f1f.mp3";
export const aa2ndAudio = "5ff6c938-0ee6-43fd-a6ab-9c2d3efd2622.mp3";
export const chaWordWithSpinningImageAudio =
  "5746d71d-ae7e-4a6e-bb4f-c046956caacc.mp3";
export const alphabetLaCreeperImageAudio =
  "81ccaf72-6a3a-4cec-a179-7f3c94621bc8.mp3";
export const dhaAlphabetForAssetWordNewAudio =
  "54424753-bfbd-4697-944d-5cc8b4853b8a.mp3";
export const auWordWithMedicineAudio =
  "983e754b-397b-44f1-8cb3-89f8144386fc.mp3";
export const dabbaWordForContainerImageAudio =
  "84917d10-0bc2-4831-bb18-23959dc7f0a4.mp3";
export const jna5thLetterInTheChaSeriesAudio =
  "9de2bbf3-f21b-4d66-932b-e84fee8e521e.mp3";
export const gaWordWithFeatherAudio =
  "574cffd9-9c31-44ea-883f-3f57666e6900.mp3";
export const e8thAlphabetAudio = "2b702f9f-2923-4d18-8458-586a10668f66.mp3";
export const jaWithPeopleImageAudio =
  "4bee2999-1f89-49db-b8b3-f10754709622.mp3";
export const jhariWaterfallImageAudio =
  "1061eb7c-e5b3-4308-8ccb-11c6d5daebc1.mp3";
export const au13thAlphabetAudio = "7af8b871-dfc0-4414-b4e2-e2c2423f1fcb.mp3";
export const ai10thAlphabetAudio = "966f0dd7-3be8-44b8-a0f0-f4d0d06b5d95.mp3";
export const dhaWordWithAssetOrMoneyImageAudio =
  "662e47a4-db18-46f6-9943-aadb51fdca38.mp3";
export const baAlphabetBangleAudio = "920d6897-b4ed-4673-8a5e-813ae49d7c80.mp3";
export const i3rdAlphabetAudio = "c8a75a0e-c94a-4a08-ab90-4f4ef17fcdf5.mp3";
export const iWithWordMouseAudio = "4871dcc1-f3d3-407e-8686-03f981ec5f3f.mp3";
export const jaAudio = "ed0f227e-4960-4c50-91f4-84cd4affc42f.mp3";
export const dhanaDhanaWordWithSchoolBellRingingImageAudio =
  "11b24b9b-d9c5-40ae-88cd-1e93899ac2c1.mp3";
export const aha15thAlphabetAudio = "4ab3ffae-3368-4b12-83e4-3311d5ed60be.mp3";
export const eeWordWithLadderAudio = "fc35402a-0b78-42f2-9ac7-c0daa7688080.mp3";
export const ghaWithWordBellAudio = "30756b18-61b2-4b06-9e35-f1f4cf3cfe11.mp3";
export const ee9thAlphabetAudio = "7eb23cb4-a939-4a56-bf2e-95bb28a5531e.mp3";
export const gaAudio = "cd68eae9-f4fb-4e75-80e7-878485067ec1.mp3";
export const daAlphabetWithMysoreDasaraImageAudio =
  "1aebb069-030a-4e48-b6cf-caf01b4717cb.mp3";
export const aFirstAlphabetAudio = "0e69d74d-6df9-4d17-a471-61356d326378.mp3";
export const cha2ndChaAudio = "637501aa-91a6-44e6-9fc8-7b598d95bf4d.mp3";
export const jnaTheLastOneAlphabetAudio =
  "108f2bac-9ed1-4e6d-9484-5befff76eac8.mp3";
export const chaWithUmbrellaImageAudio =
  "9de11632-7e09-4fb0-b351-cb209a0b9cda.mp3";
export const hanaWordWithMoneyImageAudio =
  "5a408035-0668-4e01-8b03-9bec770465f2.mp3";
export const ghaAudio = "b358c2b5-f307-428a-b909-b9bbf1c3e750.mp3";
export const daAlphabetWithContainerImageAudio =
  "3347f686-5d69-4f26-ba02-78de014d5bce.mp3";
export const ii4thAlphabetAudio = "b38d7040-1506-4b72-8968-c2661a6862cb.mp3";
export const haAlphabetWithCowAudio =
  "8da80e6a-8310-4ccc-9a00-dc6f48d6efc0.mp3";
export const aWithWordKingAudio = "47c261be-2bae-4503-8af5-35b44d3e7d69.mp3";
export const jhaAudio = "2f9053ec-9e75-4c5e-87cc-7c7641adeae1.mp3";
export const aaWithWordElephantAudio =
  "25718578-8478-4384-a82a-5018de4dc1fe.mp3";
export const chaAudio = "6c4b8c7b-1fd3-49b9-ab11-3b6a79d5e210.mp3";
export const iiWordSwimAudio = "1e3f437f-0dd9-4c27-9bcd-d5e2fa07c8e4.mp3";
export const eWordWithLeafAudio = "0b27a8cc-54ca-42d4-9faf-3e4ac044e4ee.mp3";
export const amWordWithShopAudio = "7257f5a8-95e1-4358-b123-1a3211a2d547.mp3";
export const saalphabetgoldchain = "c504e802-3ae5-4dea-8127-39d3788cc6b1.mp3";

export const bhaAlphabetWithScaredBoyAudio =
  "b4381153-8ce2-41ca-9efe-6dcf476a0c9d.mp3";
export const phaAlphabetWithFruitsImageAudio =
  "60bf7906-afcc-41bb-a83d-d8c356266863.mp3";
export const vaAlphabetJungleImageAudio =
  "077a9948-a44f-4f1a-b801-e23a6c2b7fa4.mp3";
export const maAlphabetTreeImageAudio =
  "787b14b4-b622-47f4-b1f4-882c219fc6d6.mp3";

export const chillyAud = "dcfbb0ed-a599-4cba-be8a-7b9d6a8031ec.mp3";
export const appleAud = "09c6b580-37d7-4b18-9d6a-6f1282b1612c.mp3";
export const queenAud = "59263633-4265-4838-9199-4fc25532ae63.mp3";
export const chilliImg = "2ecfdeab-a97f-4926-84a0-a9345ac09676.png";

export const kelaaudio = "babd2269-35b6-4c6b-8a19-c5e104d29d6c.mp3";
export const pahadaudio = "d4b9b0c3-2704-49f3-b4bf-8a5d0e45f723.mp3";
export const bhaluaudio = "0b25846c-da4a-4177-8108-ec6cf3328758.mp3";
export const papitaaudio = "5e233007-0e7f-4b56-a9df-a55f86ce74eb.mp3";
export const bharataudio = "33de1c41-a4df-43fb-86e1-e4f8e256aa80.mp3";
export const kitabaudio = "33df959f-c81d-460c-b90e-a693088698f3.mp3";
export const sebaudio = "0700066c-7e38-46e3-921e-189ed2144e15.mp3";
export const nadiaudio = "ac751bea-1d89-4340-81cf-12608bd431f4.mp3";
export const jalaudio = "b95b6c4f-0230-41c2-ae37-199fa6b0b661.mp3";
export const rajaaudio = "eb9da286-7bc2-4392-b543-a1b42ebe5e08.mp3";
//tam
export const மலைAudio = "2e60cafc-6f37-4c29-bc4a-f11d762285ef.mp3";
export const நதிAudio = "4af31e39-369b-4494-9aa8-a92528f1e99f.mp3";
export const மாடுAudio = "e9a11a73-acef-4ec5-9b71-7f1d186e9c2b.mp3";
export const வலிAudio = "22ff767b-0dd0-4450-ac0f-ffe3d08f28df.mp3";
export const தலைAudio = "2ae465cf-84f5-4ba1-9a4f-cea6912c54f8.mp3";
export const நாடுAudio = "4de3abcd-0cb1-455e-af4a-f969c0a5e3ad.mp3";
export const புழுAudio = "ecbe0ce9-16d8-41a2-b9ed-9e1ee2b447a3.mp3";
export const மழைAudio = "f3df4c5d-fe27-4762-b099-95e6c2187385.mp3";
export const கடைAudio = "23e02933-f5b0-40d0-a71a-7e4ca3dbf781.mp3";
export const வீடுAudio = "a4d9553b-968a-44a3-9b16-240232e7314b.mp3";

//tel
// export const నీరుAudio = "41c82465-5fbf-475e-a452-57fd9142c4d9.mp3";
export const పాలుAudio = "4f37d514-4592-40df-a82b-89cc2880e27a.mp3";
// export const చేపAudio = "5ce3ed5c-8bce-4e34-8815-9516b831db51.mp3";
export const పక్షిAudio = "5bf7ec6f-a0e2-471a-b930-b369a5d767d9.mp3";
// export const నదిAudio = "3a7958ff-f99d-495d-ad78-cb078ebeba29.mp3";
export const కుక్కAudio = "a3899b6f-7585-4626-8dcc-ea5e5124fa0d.mp3";
export const పిల్లిAudio = "d3d9fef3-02e6-4991-8392-5bd2d77d1a3b.mp3";
export const మనిషిAudio = "e0424d53-ab20-4620-81b1-f6c26688b297.mp3";
export const బడిAudio = "9d3357a5-f210-494a-ac52-2161dda4bbde.mp3";
export const ఇల్లుAudio = "6293bf53-a836-4ad4-8d8d-a012c54ae4a7.mp3";
export const వాన2Audio = "c7beba7e-d925-4b77-813f-bd44754e416c.wav";
export const చీమ2Audio = "7c83c1b6-c47a-442c-a6cc-efd66ddf491e.wav";
export const గుడిAudio = "7da0ac14-b787-4528-87d3-c78f4ed0dc9a.wav";
export const నూరుAudio = "8bb0da1c-048e-4585-bacb-7a1f5ec84b3f.wav";
export const కృషిAudio = "53ee5249-d83a-41ea-8112-b0a5b1776a35.wav";
export const ఖాళీAudio = "06d93f06-9974-4255-a831-21be7055e9f5.wav";
export const చెలిAudio = "bdaff6a2-d7fc-49af-a92f-fd245d103d36.wav";
export const దైవంAudio = "86235202-f104-44c2-b149-3c37428d03b5.wav";
export const చిలుక2Audio = "2f6954bf-9d19-44f4-af97-6e69acf55d94.wav";
export const దేవుడుAudio = "1c762f1e-d2a9-41d5-8d7e-0908d2d0dfd2.wav";
// export const నొసలుAudio = "4a8508f4-8d36-426e-93dc-faa048a4224c.wav";
export const చోటుAudio = "8fe5c1d8-40e3-4817-802b-d4f957ca6b2b.wav";
// export const టౌనుAudio = "ec12c811-7221-47bc-b351-dff71ace9a38.wav";
export const తేలుAudio = "71acefba-9e03-41b2-8a48-9f82d0dc4403.wav";
// export const పావురంAudio = "2e190864-6093-4c22-98d1-0735f9971d5d.wav";
export const నిజంAudio = "f785da47-55c2-4fe6-a67d-218f29fd58d7.wav";
export const కీటకంAudio = "960060f8-f5e8-4594-849d-a61de938c302.wav";
// export const పులిAudio = "dde516fe-fa81-4e58-bf0e-a85e1bd067b1.wav";
export const గూడుAudio = "2e5089a3-6b5a-477d-82b0-67ec202b8708.wav";
// export const గృహంAudio = "9d424736-b845-4897-8a99-5e32e8ef556f.wav";
export const చెలికAudio = "15bd3515-fd30-461d-89b6-5d745e5edcf0.wav";
export const జేబుAudio = "814a3125-0f12-4afc-aa63-963b449af0f0.wav";
export const చైనాAudio = "a0e25100-9cbf-4d71-8d19-8349e05c3fc1.wav";
export const కోడలుAudio = "0b753207-c375-4fd4-b3dd-68c343dae3ca.wav";
export const గౌరిAudio = "4f3b69ab-e2ba-4988-93e3-cc638e998b87.wav";

// export const ನೀರುAudio = "1c85fc5a-4541-46e1-bca6-4821c7eb5020.mp3";
export const ಹಾಲುAudio = "2d8285c6-4145-433c-b4d3-022cab43514c.mp3";
export const ಮೀನುAudio = "50759a48-4acb-4e3f-a80d-6d58f3dea73a.mp3";
export const ಹಕ್ಕಿAudio = "91605a6f-eaa5-46a9-ac59-d2ffe2496d65.mp3";
export const ನದಿAudio = "e6d751e9-79c0-4a0e-9cc4-677b89bc6703.mp3";
//export const ನಾಯಿAudio = "04ac99e0-fdde-41c1-9fb7-f50fb7de06a8.mp3";
export const ಬೆಕ್ಕುAudio = "bd6e15e6-5f56-4bc4-baa9-cb1dd7f2bf22.mp3";
export const ಮನೆAudio = "a851a652-cb93-4293-9f3c-b4cb7497296f.mp3";
export const ಪಾಠAudio = "630654ec-639e-4207-b8fb-b877a808206f.mp3";
export const ಬಳ್ಳಿAudio = "4e5efecf-a825-45f8-ac49-9ef2964f4347.mp3";
export const ಕಾಲAudio = "f32e8948-94b1-4ba9-b26d-2052e04b93ec.wav";
export const ಗರಿAudio = "3048490b-d1e2-4ec9-b530-8e61aa6fd331.wav";
export const ಚೀಲAudio = "f6807318-c664-4bec-9175-a01ab32c08ef.wav";
export const ಗುಡಿAudio = "83ea9325-33ec-4162-9677-eb68845c008d.wav";
// export const ಮೂರುAudio = "e0be77c2-8f64-460b-a864-c68ec31a911f.wav";
// export const ಗೃಹAudio = "44ac107a-c63c-435a-847e-4d1a25288b37.wav";
// export const ಬೆಳೆAudio = "f7af40f6-e4e7-4223-a6b3-a9c20a1bf2d9.wav";
// export const ಸೇರುAudio = "d2d6971b-7782-44ad-baf5-6cb1d0836ec7.wav";
// export const ಪೈರುAudio = "f6a38c16-cfe5-47a2-9364-885d027404bb.wav";
export const ಯಾವುದುAudio = "17cc2803-9a15-4902-8634-951ba9090b5f.wav";
export const ಗಾಳಿAudio = "fcebef0c-e56d-42b2-b7e4-728f373dccc7.wav";
export const ಮೂಲೆAudio = "cbd98fe4-c4a4-4f2c-aeda-765ec7c753d3.wav";
export const ಕೋತಿAudio = "60140e9d-f305-4a33-a8ca-9850f3ba0209.wav";
export const ನಾಯಿAudio = "4a2163a7-d90c-48d5-832c-6600df86662f.wav";
export const ಕೌದಿAudio = "82e3760c-b731-4e9b-ab9b-ca79ceb0b43f.wav";
// export const ಕೇಳುAudio = "645f131a-12b7-4685-973d-5474e827da42.wav";
export const ಯಾರುAudio = "7f64e839-e681-458e-9833-bf0c6a7d3d8a.wav";
export const ಮಾಲಿAudio = "86862c37-0bbd-4e93-a776-94470857a14a.wav";
export const ಹುಳಿAudio = "ed5677c5-bd46-429e-a524-048a6dd37e2f.wav";
export const ನೋಡುAudio = "d7e88a2d-c2bf-447c-95e0-1baeb5b2709b.wav";
export const ಕುದುರೆAudio = "73f00275-18e1-4a4f-ab46-a94418139e68.wav";
export const ಮಾದರಿAudio = "5804054f-1654-43cb-b661-b5777e3cded3.wav";
export const ಕಿಶೋರAudio = "e58f4051-dca2-4fd9-9941-02c092529aaa.wav";
export const ಲೇಖನಿAudio = "32715148-3732-4c18-a86a-0d3ab90b7836.wav";
export const ಕೊಠಡಿAudio = "8af51ac7-2ca8-4c26-8b5f-230437070dbb.wav";

export const ballfullAudio = "e0823953-39c1-4080-8454-ba7cd9e19062.mp3";
export const drumfullAudio = "e28b345e-7d5e-45f8-9f4b-61f06569122c.mp3";
export const fishfullAudio = "d74dc760-ff5b-45b7-903b-fd8ebfb46bf3.mp3";
export const grapesfullAudio = "86a8f38f-f131-40c3-8c54-f1037bf65f14.mp3";
export const handfullAudio = "66496645-cae7-4d8d-896e-545fe53ed1bd.mp3";
export const jamfullAudio = "af9671dd-7961-4ec4-ba6d-3f6d1faf927b.mp3";
export const carfullAudio = "28026dab-b43e-4718-9dd7-8cb086eaceef.mp3";
export const lollipopfullAudio = "5b80a682-0cb7-4fe6-98fa-04a6df4f4f48.mp3";
export const monkeyfullAudio = "2fcc5f69-a8d0-4ccc-92a6-e349c1e1a491.mp3";
export const nestfullAudio = "c31b7a87-5e58-4d6f-8847-fee272d7a9a8.mp3";
export const pumpkinfullAudio = "96561240-b20f-4105-b173-02920fda8bdb.mp3";
export const rainbowfullAudio = "d13d4f25-7c51-4b6e-9253-2122a6461dfb.mp3";
export const sunfullAudio = "6399bb26-0737-48a8-a47c-e9633f13844c.mp3";
export const treasurefullAudio = "b8bab30e-2191-40d4-b636-1cefe2f78dbd.mp3";
export const treefullAudio = "4c18045a-04b0-4b3c-8eab-15825334ffc0.mp3";
export const vanfullAudio = "29bb3fcb-929e-4521-aa39-fc7b6115730b.mp3";
export const windowfullAudio = "53c23149-fe6c-4123-936b-7a0222ca677d.mp3";
export const yakfullAudio = "57a99e4d-cbcc-4d84-a66f-e50b6fb03ef7.mp3";
export const zipfullAudio = "b8320f23-c236-4c12-97e4-ec3b70801c32.mp3";
export const foxfullAudio = "c3975a10-42b7-4f4f-946e-59f6136cb092.mp3";
export const queenfullAudio = "fa62e112-c1ea-4ca6-be2a-6001ac3fef35.mp3";
export const chainfullAudio = "e4e3f136-9bfc-4cf7-80d9-08c5d308d5cf.mp3";
export const sheepfullAudio = "f157fe12-cc6c-4115-8251-ce93bf265203.mp3";
export const motherfullAudio = "c1abf3d1-0c64-4ac3-87a5-c272db8dc318.mp3";
export const singfullAudio = "934f0370-9f6e-42f6-b51b-52eecd25c901.mp3";
export const applefullAudio = "651f374c-7d39-4246-b77e-784b2a10857c.mp3";
export const eggfullAudio = "bc82a1bb-9461-4434-8ea8-9d7335418d2f.mp3";
export const igloofullAudio = "dfb69099-6ab2-437a-a461-4a3e93373b36.mp3";
export const orangefullAudio = "37e16192-bcde-4836-8d1f-cb00e259e71f.mp3";
export const umbrellafullAudio = "81b5b4b0-e0c2-4bac-8d3a-a7a66fb05440.mp3";
export const rainfullAudio = "886c010a-de27-4a89-81fe-e5d12e53c44d.mp3";
export const beefullAudio = "51b931bb-2387-4458-9672-180cd128777c.mp3";
export const piefullAudio = "14e9e9a4-e4dc-472d-bb1f-36d7006fc471.mp3";
export const boatfullAudio = "700dd0f7-6d31-44d3-a12d-484d04c864cc.mp3";
export const moonfullAudio = "7279f890-024f-4874-b538-d84bccbd97a8.mp3";
export const bookfullAudio = "d13e77a7-8902-4f8f-8a8a-3010a915c80a.mp3";
export const cloudfullAudio = "7e73b1f2-9f40-40f9-b5d8-4f75fab86db9.mp3";
export const coinfullAudio = "7ece1f48-02a0-4330-8cf5-716f58d8185a.mp3";
export const sawfullAudio = "ac506c7d-fa92-46a8-8988-4f6666aac82d.mp3";
export const starfullAudio = "f7b68c32-956a-4d50-876b-ee9299c6ec7d.mp3";
export const sisterfullAudio = "126f5fc5-0e39-4dae-a676-e8f2a84feccb.mp3";
export const cornfullAudio = "1fc5dfa0-65b1-493d-a2e8-2ab4b56f2127.mp3";
export const chairfullAudio = "2f947601-50ff-4ee5-b2f2-23d9a683a9b8.mp3";
export const hearfullAudio = "90b160a0-8bce-4d19-bb73-d370b0ba55af.mp3";

//hindi

export const अनारAudio = "8636e91c-1d36-46e6-88db-50b4ca63b77d.wav";
export const अनारImg = "9d3d7f40-85c2-4e5b-9239-363d79f86eba.png";
//export const आमAudio = "92995673-b0a0-48fb-84f4-bde8d64ec46b.wav";
//export const आमImg = "850c278a-5526-4f5b-917d-90fdebac0b5e.png";
export const इमलीAudio = "ddd32cc2-c93e-4fc8-8398-ee2d86b48b6d.wav";
export const इमलीImg = "ca997054-aca9-4900-840e-77fea4f64666.png";
//export const ईखAudio = "ab6ddd38-cdbc-433e-8891-d295df3137a3.wav";
//export const ईखImg = "0b4318a0-6e5b-45a0-8d94-55dcf67821ae.png";
export const उड़Audio = "849b13d5-1c64-452e-b18e-ff85e9a45286.wav";
export const उड़Img = "f179eddc-6fbe-4205-82ec-fb05aa290b3f.png";
export const ऊपरAudio = "637bd8d9-254c-4d67-9913-f483432adf6f.wav";
export const ऊपरImg = "111db6b0-fc82-4eea-8673-b60d2fe9b1e3.png";
export const ऋषिAudio = "04665c48-cbf1-418b-a9b1-5d6641c853b5.wav";
export const ऋषिImg = "0d46c2dd-db3e-4285-ad5e-16ecfde7118a.png";
export const एड़ीAudio = "0ebb4caa-d191-437f-94f7-4db2e352461c.wav";
export const एड़ीImg = "8003335b-e614-4f39-9be4-188635aeca86.png";
// export const ऐनकAudio = "bc3758f7-db03-40ce-94d2-aa64f0f5f08c.wav";
// export const ऐनकImg = "97d0bfbe-0178-47da-81a1-c62a18baf394.png";
export const ओखलीAudio = "2a06c101-12bb-4073-9ea2-13f45b7f0382.wav";
export const ओखलीImg = "f1523352-174c-4dc2-bc2a-bad885c1a1b9.png";
// export const औरतAudio = "ecb8a011-7c44-40ad-b6c8-1ba2da4536fd.wav";
// export const औरतImg = "cb0398ce-8aea-4611-9f42-c15fc423e298.png";
export const अंगूरAudio = "c8d7d90d-cf58-44cb-9ad0-84d2c8573f64.wav";
export const अंगूरImg = "ca6be95f-0610-46b2-8933-9321926a7972.png";
export const कबूतरAudio = "6504e6cb-a8bc-46fc-b5ef-f1fa1657b185.wav";
export const कबूतरImg = "5631c6c0-fa11-4e84-a384-d3aa91da26b5.png";
export const खरगोशAudio = "6187a712-aa4d-4e94-bf89-f2038461c03d.wav";
export const खरगोशImg = "d86eacc2-291b-4370-a743-13bcf3372d50.png";
export const गधाAudio = "d1111c99-c96c-448d-819e-08f6a3645643.wav";
export const गधाImg = "94cc7f4b-0402-40d0-b4f5-d27d9c209361.png";
// export const घरAudio = "01696a5d-e388-4d25-bc18-5e823501df95.wav";
// export const घरImg = "a6491b17-12f9-45a5-aa5b-372863a411d8.png";
export const चढ़Audio = "1cb123d4-3f30-49fb-9fa7-c6dcdfe46756.wav";
export const चढ़Img = "894e3823-cf87-4404-ba03-171ed2cfb10e.png";
// export const छतAudio = "6b824bab-f112-492c-ae98-c3fe4d184758.wav";
// export const छतImg = "7396ca4a-8b37-4e2b-b179-8a04584b24b5.png";
// export const जगAudio = "e93fb7ca-dd81-4e85-9ae2-9ca19b7b885e.wav";
// export const जगImg = "6ec85add-038e-4268-ae86-f8a477f65187.png";
export const झण्डाAudio = "251fe166-0123-4ef8-8d2a-9818bd304aa5.wav";
export const झण्डाImg = "b2bed27b-a05d-45d6-8b5b-2a959cf8f969.png";
export const टमाटरAudio = "93951817-6768-491d-b35e-7c7482f85144.wav";
export const टमाटरImg = "0f8d66b7-7f31-4821-90c4-03ca7106df64.png";
export const ठठेराAudio = "4e01c176-8c9f-4050-ba91-926120c15afc.wav";
export const ठठेराImg = "0954c95b-7df2-4272-81f3-df1ba0906e88.png";
export const डमरूAudio = "9223377a-cb6a-4295-bb55-2accabc67404.wav";
export const डमरूImg = "b9917a02-2271-4363-b270-5dad4eed7144.png";
export const ढक्कनAudio = "5b9b51c9-267e-4e4d-959a-241cc2310cb0.wav";
export const ढक्कनImg = "99be8d2d-76ae-48b6-a9cc-3f62462017ea.png";
// export const तटAudio = "18b99070-bde8-4218-9cc3-7b179637020d.wav";
// export const तटImg = "b991c87d-89d4-4388-8c50-45dca03511a9.png";
// export const थकAudio = "3c3d0241-2dd5-4674-8f38-95d6a48ac24e.wav";
// export const थकImg = "680f387d-30f1-4943-ba20-dd635e822275.png";
export const दरवाजाAudio = "9e1b002e-ba90-4b87-b2c1-bbfa6ffd206c.wav";
export const दरवाजाImg = "e0d5799b-7048-4f00-bbd6-12444f2e6861.png";
export const धनुषAudio = "0f57570f-f5cb-467f-8874-74fcf5ef1692.wav";
export const धनुषImg = "25acc4ee-38b8-45f1-9e5f-ad22c2acad64.png";
// export const नलAudio = "e19a5cb0-5b03-411e-8a2e-ff7016ff9df6.wav";
// export const नलImg = "e22823a6-49f0-43b2-8dad-b04683eb8168.png";
export const पतंगAudio = "c1fbeca9-c166-4878-a05b-a48a72a71e38.wav";
export const पतंगImg = "9c01bd5f-1c1d-4f89-93ba-e442f92f7620.png";
// export const फलAudio = "d08f9fdb-a0a7-40cd-8ae1-e9d5321ed110.wav";
// export const फलImg = "50b28eea-ce87-40a4-b002-a32780e02963.png";
// export const बतखAudio = "7d0fb14e-4aa8-4ec4-8e99-78ff7f735940.wav";
// export const बतखImg = "f91ad36b-5497-48f0-b20f-c0167a0e8ade.png";
// export const भयAudio = "35d18e81-27c1-40d5-8463-ecb84d0b698d.wav";
// export const भयImg = "80e53d49-0a31-48a5-b179-c68105e882ab.png";
export const मछलीAudio = "dc57b947-ce64-4e4d-aec8-b11fa17576d6.wav";
export const मछलीImg = "36256c00-ee25-4918-a880-7ef70e6cbd94.png";
// export const यहAudio = "3e1ec485-a7c9-44c4-9e34-3449c1b96df2.wav";
// export const यहImg = "dd44caa8-5fcb-4ae9-97fc-3cbfd1641b43.png";
// export const रथAudio = "f4d797e6-8423-4cca-aa88-c6416d07a1b3.wav";
// export const रथImg = "372a87ab-3772-4618-b040-fa38739a99cd.png";
export const लड़काAudio = "e8b5fea1-d85f-4ce7-9c1f-f3cb40ed544f.wav";
export const लड़काImg = "e8d45718-0686-4eee-b96d-6331bc2ce00c.png";
// export const वनAudio = "a2f8204a-5805-4fb7-91d3-ff285669aca9.wav";
// export const वनImg = "0c49601a-7f66-48c6-b367-62acf8354f41.png";
// export const शहरAudio = "6a91e0fb-3253-433b-b862-9196fa3c54be.wav";
// export const शहरImg = "73e57f4f-f558-40a6-be91-239d0e420b18.png";
export const षट्‌कोणAudio = "0c868f3c-8ab5-4e45-93a5-a0b51be844f4.wav";
export const षट्‌कोणImg = "0431d520-d257-4aaf-915f-26d9bf2082c8.png";
// export const समयAudio = "3b8e6c24-f76c-4939-864a-6beaf34124b6.wav";
// export const समयImg = "e82b7321-8731-4d1c-bfca-7ac0605f19ae.png";
export const हाथीAudio = "1409b559-2f41-40d9-afda-16bd65761e20.wav";
export const हाथीImg = "ae1a3bf4-7bd7-4fc5-8ff0-ecbf1cab0540.png";
export const क्षत्रियAudio = "3e3d4292-f218-4662-bb73-ba2b35a4143c.wav";
export const क्षत्रियImg = "cecf3c32-e0f1-4453-befd-01cd6f75886c.png";
export const त्रिशूलAudio = "8c9c330f-4deb-44cd-820b-54629233200e.wav";
export const त्रिशूलImg = "cb07d910-f4f3-475b-a728-9e938813a76f.png";
export const ज्ञानीAudio = "b7b1e4f3-f511-44d9-9496-13bbedc35faf.wav";
export const ज्ञानीImg = "141ee8a8-7034-4509-bdb6-be26bf35392f.png";
export const साइकिलAudio = "0a817a32-8c13-4cb9-b69a-1d81004b4da8.wav";
export const साइकिलImg = "19d5c801-d4f9-4686-b0e5-97c59ee98f6e.png";
export const बकरीAudio = "1cff7fba-822a-4c06-8351-052d11b8dca1.wav";
export const बकरीImg = "8eaccda1-102b-40b5-a657-49fdd72534e8.png";
export const लेखनAudio = "7b84434e-844b-4331-95bd-909746d3c6ac.wav";
export const लेखनImg = "3289ced0-5375-45dd-a7a7-f04c6c303e27.png";
// export const नगरAudio = "37f33bef-04d9-4125-8ffe-510f23c7c2ed.wav";
// export const नगरImg = "7b963645-21c1-431d-9406-58927bfb7a49.png";
export const घुँघरूAudio = "8278ec6b-e3fe-47a3-b88d-bfe8231d967f.wav";
export const घुँघरूImg = "1f39ea62-6084-40b2-adb1-09a6d0338643.png";
export const खिचड़ीAudio = "8db33ef8-8632-4d7f-be22-27430170d556.wav";
export const खिचड़ीImg = "0f9e1c77-135d-4102-8390-f31c7c82fe95.png";
export const गाजरAudio = "fc49211b-f12a-4ebb-a671-b6af7d9fe6cd.wav";
export const गाजरImg = "b2c3c69a-1a2f-44fe-aab7-5392d2160d78.png";
// export const मटरAudio = "780eb0d1-3b70-4a37-9e88-747b8d5fcf10.wav";
// export const मटरImg = "6bc2a7eb-b2e2-47e7-8aec-1cc06912eef7.png";
export const गुठलीAudio = "4e62f270-f95e-423c-afef-eedda462766b.wav";
export const गुठलीImg = "d497bce8-0bcf-4b21-b904-64b88233b29c.png";
export const मेंढकAudio = "114901e6-dbcf-4fa8-91c2-a2ce76de1190.wav";
export const मेंढकImg = "fe2e7b19-a3eb-4955-a589-5965be134bd0.png";
export const सुतलीAudio = "037a33c9-8434-438e-8d2f-d6c914340664.wav";
export const सुतलीImg = "2059df08-6338-497c-9394-1b8da986bea9.png";
export const बादलAudio = "e3618ee2-a6b8-4f46-b079-80180fab1c1e.wav";
export const बादलImg = "80e77960-e564-4cab-b3da-99d03d73835d.png";
// export const इधरAudio = "8cdb2b82-803e-4a10-bb2c-25369138c646.wav";
// export const इधरImg = "6d551a7f-a262-4c4a-9523-e7008cfcb18c.png";
export const जानवरAudio = "e4deb23a-5794-49eb-9190-c5c458a9b43d.wav";
export const जानवरImg = "f8c87583-1fe8-4645-a5d8-38cded2a14bd.png";
export const कपड़ेAudio = "e10aa655-92b7-4e7f-a01a-56ccbd9a4df7.wav";
export const कपड़ेImg = "ee0ef83c-65de-4243-a0ae-1726c04dad2a.png";
export const सुबहAudio = "01ad760d-b3f4-4ae6-a47c-dac557721873.wav";
export const सुबहImg = "e267d4c8-ab31-4dc6-8b18-7b0cc69f0b2a.png";
export const अनुभवAudio = "b8b70de7-a1c3-4ac2-9f4c-8c7fd33ca530.wav";
export const अनुभवImg = "8de5f332-dfe8-48be-b83f-efa43c763235.png";
export const गमलाAudio = "fe076834-0c17-4fc1-a70c-650b5718cb8b.wav";
export const गमलाImg = "d3c82598-57c1-46de-a968-6127d14f06b9.png";
export const पायलAudio = "172461a3-2f0a-4a58-953c-1cfdc001d49d.wav";
export const पायलImg = "a850380f-f295-49b6-937d-99b20ad715f0.png";
export const भारतAudio = "93070d52-b1b1-4854-aa7e-952a95a7be95.wav";
export const भारतImg = "f0736306-4728-447c-816e-36151a9e7405.png";
export const चलनाAudio = "a8db654e-a9b0-40be-ac14-5297bd443b3c.wav";
export const चलनाImg = "09aba370-e513-4c7f-aa76-6e390315cd49.png";
export const चावलAudio = "fa8d6c05-0454-4f27-ac11-0a239e60d74a.wav";
export const चावलImg = "6ca0dd65-2ad4-4fff-a659-268058f769ee.png";
export const विषयAudio = "ae9976b3-7d1a-431a-b8fb-ce33f5ce1589.wav";
export const विषयImg = "947a18ca-a485-497e-a86e-6ab7df75910d.png";
export const आसमानAudio = "ebf0a15b-ee7e-4ce3-aad9-8a55970c9189.wav";
export const आसमानImg = "3f9d71cd-8646-4a8d-88ec-26849d6d0e7a.png";
export const बाहरAudio = "617f1662-cb7b-473b-bbc5-4f0a01343223.wav";
export const बाहरImg = "1a153e0a-ed8a-40ee-92fb-1ed791fbd572.png";
export const अक्षरAudio = "5a542670-a1e6-44de-9b45-4c3a8a24f3bc.wav";
export const अक्षरImg = "52f68a3c-b2b8-4ebb-a12d-5ba35c555f17.png";
export const कछुआAudio = "3a76ed79-0b74-40bf-8c64-eec50fab32ab.wav";
export const कछुआImg = "e8460752-bd7f-407a-8406-00c0a8acc621.png";
// export const नईAudio = "23ac663f-a641-42a6-b0de-9ea477d61dfd.wav";
// export const नईImg = "58d56b30-06b1-4dad-be76-0ed498a75cff.png";
export const पढ़िएAudio = "3a70d81f-343e-401c-b686-61bd774c0ce8.wav";
export const पढ़िएImg = "753fe894-8531-4623-b045-f5989aa63ba4.png";
// export const नमकAudio = "408f8df9-7280-4102-ad17-3891329b7c82.wav";
// export const नमकImg = "2860bc6d-2da9-46b8-943d-5538e372282c.png";
export const भूखAudio = "4ff1e054-8559-42ab-ad24-769f1c24254d.wav";
export const भूखImg = "12d4fa6b-739b-4446-b938-e98dca8a8f55.png";
export const लोगAudio = "84dfc1db-4b94-449b-a486-f7ae44ebe8f6.wav";
export const लोगImg = "94aab6ad-1104-4faa-b68b-65cf34e97e27.png";
export const बाघAudio = "3fcfedf6-08f0-4a82-8b02-bbd132d0c21b.wav";
export const बाघImg = "b2fb106b-3f46-448c-b7eb-68d56d5fd5ee.png";
export const पाँचAudio = "86eda492-610a-4b9a-9727-a0172a1bb579.wav";
export const पाँचImg = "13a6b54a-1642-4d00-b1cd-7507c1cf73ce.png";
export const पूछAudio = "79c50843-097d-4733-979b-db27968b22db.wav";
export const पूछImg = "39bb90d9-a4d5-475d-b232-cbc90513e0f7.png";
export const सूरजAudio = "fd5e7e68-92cc-4b03-ac9f-ca99eb3ddacc.wav";
export const सूरजImg = "998ddcc3-9f39-48ed-849d-4ccb42c9ae0e.png";
export const ऊँटAudio = "79ca57a0-163b-42ba-aad1-8063f31ebd5f.wav";
export const ऊँटImg = "39b9a4ce-0800-4337-9115-81049112a5e5.png";
// export const आठAudio = "840c7dea-0cad-4237-9827-54299e445d71.wav";
// export const आठImg = "bf1d56d1-de39-44bf-95bd-da7ab9935515.png";
export const पेड़Audio = "4267107a-1eaa-49e8-8be8-0d45745e817e.wav";
export const पेड़Img = "94816c6c-c18b-40ad-b20e-25d19694f1da.png";
// export const लवणAudio = "867b8376-0dd1-40e9-aaa7-a2e4898c5197.wav";
// export const लवणImg = "2860bc6d-2da9-46b8-943d-5538e372282c.png";
// export const रातAudio = "e64e97c6-c2bb-4199-afd0-e09394117b48.wav";
export const रातImg = "2e9f1e59-7c52-44c8-9d03-8ba774b85184.png";
export const हाथAudio = "739ed9cf-517a-4024-bf37-97c6ea09916f.wav";
export const हाथImg = "ed2652bc-f2d4-44a5-a44d-9bebf34074ff.png";
export const आनंदAudio = "a7393955-3a53-4b40-a6bd-a3a5271e3df9.wav";
export const आनंदImg = "1143f959-bc6d-40c6-be95-a51372b3bd9d.png";
export const दूधAudio = "5fae2338-1f38-42c8-9244-9be9c82985fc.wav";
export const दूधImg = "3943ec7c-2460-4f90-837a-aa3911259554.png";
// export const बहनAudio = "d12eb685-5bf5-471b-975b-34654a7cef91.wav";
// export const बहनImg = "1c9770ea-d87f-4a46-8b28-dfe16e8451e3.png";
export const साँपAudio = "ee562ffa-d151-4da7-93f6-14945b17dc83.wav";
export const साँपImg = "2c9770ea-d87f-4a46-8b28-dfe16e8451e3.png";
export const बर्फAudio = "d9e15a1a-8043-49a3-aebe-4b10e15ce9a7.wav";
export const बर्फImg = "9ee540d5-38d9-456a-81b5-1c02ce0d00c8.png";
export const सेबAudio = "56f32c4d-9d5a-48dc-9f22-ad889cc56cb8.wav";
export const सेबImg = "ca354a27-0fb8-417b-8a06-277794dd433f.png";
// export const नभAudio = "d0c6c2f1-4131-486e-89b1-1357ee1696e9.wav";
// export const नभImg = "3f9d71cd-8646-4a8d-88ec-26849d6d0e7a.png";
// export const कदमAudio = "79eda54b-4755-4f18-b659-63a28a639fb5.wav";
// export const कदमImg = "e2ac18ac-858f-482d-acf7-2a53b68cdd13.png";
export const गायAudio = "8519e871-c612-4540-9055-76f049b793bc.wav";
export const गायImg = "e91bc7e9-622f-47e5-8a1a-78dabd98566c.png";
export const चारAudio = "177242ca-8815-43b3-9e5f-86b484296b30.wav";
export const चारImg = "6f4d5dd9-19a8-4c33-be19-2a94ebc602d0.png";
export const बालAudio = "952b33a5-af48-4025-b490-e21fcf0a1c3e.wav";
export const बालImg = "c52f5d62-5d36-47e2-9437-24c81c410d90.png";
export const नावAudio = "6138a943-42d3-4869-bcb3-d957338aed1d.wav";
export const नावImg = "482ff176-96ce-4635-a74e-0870fc9c7b9e.png";
// export const बारिशAudio = "4b610f12-60b0-4957-b6b6-6436b8be0627.wav";
export const बारिशImg = "7608f173-7926-4ebc-9e77-0abe35b8db71.png";
export const घासAudio = "85ffbc8d-252d-482d-8526-b6172e4d1d1f.wav";
export const घासImg = "4f9c6046-c961-4da5-a4e2-d5175bc5a4a1.png";
export const मुँहAudio = "642bcdf4-6d66-4a8d-b4af-1397b80ef9b8.wav";
export const मुँहImg = "68caa33b-7d01-476b-b4f4-ba9f71ee7592.png";
export const चित्रAudio = "2250dfcd-f523-41cc-8cf3-b1534c7aa183.wav";
export const चित्रImg = "8d5382e4-024f-4576-8946-9f3a5f221496.png";
export const अनरImg = "9d3d7f40-85c2-4e5b-9239-363d79f86eba.png";
export const अनरAudio = "2d3caacb-4015-42b1-ba7c-1a1e8394dca0.wav";
export const आमImg = "7bcb14a8-5e57-4ecc-9701-d47dee76f97f.png";
export const आमAudio = "7bcb14a8-5e57-4ecc-9701-d47dee76f97f.wav";
export const कछआImg = "3a76ed79-0b74-40bf-8c64-eec50fab32ab.png";
export const कछआAudio = "3a76ed79-0b74-40bf-8c64-eec50fab32ab.wav";
export const इमलImg = "3d435d8f-bc2c-4763-aa4c-4ab0013d6b98.png";
export const इमलAudio = "3d435d8f-bc2c-4763-aa4c-4ab0013d6b98.wav";
export const सइकलImg = "0a817a32-8c13-4cb9-b69a-1d81004b4da8.png";
export const सइकलAudio = "0a817a32-8c13-4cb9-b69a-1d81004b4da8.wav";
export const ईखImg = "0b4318a0-6e5b-45a0-8d94-55dcf67821ae.png";
export const ईखAudio = "2e61c3cf-1077-4e4e-bbd6-e9b4cd74c9b8.wav";
export const नईImg = "23ac663f-a641-42a6-b0de-9ea477d61dfd.png";
export const नईAudio = "23ac663f-a641-42a6-b0de-9ea477d61dfd.wav";
export const उडImg = "5acd3e78-2543-4a8f-9553-9ce9b6d72a78.png";
export const उडAudio = "5acd3e78-2543-4a8f-9553-9ce9b6d72a78.wav";
export const ऊनImg = "2ba7aeaf-9241-4088-a382-d2c0de04c590.png";
export const ऊनAudio = "2ba7aeaf-9241-4088-a382-d2c0de04c590.wav";
export const ऋषImg = "0d46c2dd-db3e-4285-ad5e-16ecfde7118a.png";
export const ऋषAudio = "1e7e3621-3d1c-468f-9a94-17271dba3873.wav";
export const एकImg = "84d2ea08-57b7-4abc-b85e-929a7e2b6d7d.png";
export const एकAudio = "84d2ea08-57b7-4abc-b85e-929a7e2b6d7d.wav";
export const पढएImg = "753fe894-8531-4623-b045-f5989aa63ba4.png";
export const पढएAudio = "3a70d81f-343e-401c-b686-61bd774c0ce8.wav";
export const ऐनकImg = "0777291e-04b2-49d4-8273-b3aca45f14eb.png";
export const ऐनकAudio = "0777291e-04b2-49d4-8273-b3aca45f14eb.wav";
export const ओखलImg = "f1523352-174c-4dc2-bc2a-bad885c1a1b9.png";
export const ओखलAudio = "19483b0f-056b-4994-a95c-5182b78bd36b.wav";
export const औरतImg = "2972f3d5-6e68-4ac7-aaaf-17364dd48a93.png";
export const औरतAudio = "2972f3d5-6e68-4ac7-aaaf-17364dd48a93.wav";
export const अगरImg = "0606478c-850a-4287-b52a-3952044b9e56.png";
export const अगरAudio = "0606478c-850a-4287-b52a-3952044b9e56.wav";
export const कबतरImg = "5631c6c0-fa11-4e84-a384-d3aa91da26b5.png";
export const कबतरAudio = "49c8e842-d661-4079-a292-c4b6af621bca.wav";
export const बकरImg = "8eaccda1-102b-40b5-a657-49fdd72534e8.png";
export const बकरAudio = "1cff7fba-822a-4c06-8351-052d11b8dca1.wav";
export const नमकImg = "2860bc6d-2da9-46b8-943d-5538e372282c.png";
export const नमकAudio = "408f8df9-7280-4102-ad17-3891329b7c82.wav";
export const खरगशImg = "d86eacc2-291b-4370-a743-13bcf3372d50.png";
export const खरगशAudio = "569fca65-99b3-4483-915a-0c91de4bf200.wav";
export const लखनImg = "3289ced0-5375-45dd-a7a7-f04c6c303e27.png";
export const लखनAudio = "7b84434e-844b-4331-95bd-909746d3c6ac.wav";
export const भखImg = "12d4fa6b-739b-4446-b938-e98dca8a8f55.png";
export const भखAudio = "4ff1e054-8559-42ab-ad24-769f1c24254d.wav";
export const गधImg = "94cc7f4b-0402-40d0-b4f5-d27d9c209361.png";
export const गधAudio = "dc41e1a1-e7cd-438d-8c6a-c1cb452355ab.wav";
export const नगरImg = "37f33bef-04d9-4125-8ffe-510f23c7c2ed.png";
export const नगरAudio = "37f33bef-04d9-4125-8ffe-510f23c7c2ed.wav";
export const लगImg = "84dfc1db-4b94-449b-a486-f7ae44ebe8f6.png";
export const लगAudio = "84dfc1db-4b94-449b-a486-f7ae44ebe8f6.wav";
export const घरImg = "dc5ba6f3-530b-4799-99c2-5b2b6672d016.png";
export const घरAudio = "dc5ba6f3-530b-4799-99c2-5b2b6672d016.wav";
export const घघरImg = "1f39ea62-6084-40b2-adb1-09a6d0338643.png";
export const घघरAudio = "8278ec6b-e3fe-47a3-b88d-bfe8231d967f.wav";
export const बघImg = "b2fb106b-3f46-448c-b7eb-68d56d5fd5ee.png";
export const बघAudio = "3fcfedf6-08f0-4a82-8b02-bbd132d0c21b.wav";
export const चढImg = "894e3823-cf87-4404-ba03-171ed2cfb10e.png";
export const चढAudio = "05b7176e-4e1c-4943-8837-5004cb22cc18.wav";
export const खचडImg = "0f9e1c77-135d-4102-8390-f31c7c82fe95.png";
export const खचडAudio = "8db33ef8-8632-4d7f-be22-27430170d556.wav";
export const पचImg = "13a6b54a-1642-4d00-b1cd-7507c1cf73ce.png";
export const पचAudio = "86eda492-610a-4b9a-9727-a0172a1bb579.wav";
export const छतImg = "7396ca4a-8b37-4e2b-b179-8a04584b24b5.png";
export const छतAudio = "54f2a499-92aa-418d-b4ea-8c8f049174a3.wav";
export const मछलImg = "36256c00-ee25-4918-a880-7ef70e6cbd94.png";
export const मछलAudio = "dc57b947-ce64-4e4d-aec8-b11fa17576d6.wav";
export const पछImg = "39bb90d9-a4d5-475d-b232-cbc90513e0f7.png";
export const पछAudio = "79c50843-097d-4733-979b-db27968b22db.wav";
export const जगImg = "6ec85add-038e-4268-ae86-f8a477f65187.png";
export const जगAudio = "03b41f02-7a9e-48a4-a606-0011bfe6492b.wav";
export const गजरImg = "b2c3c69a-1a2f-44fe-aab7-5392d2160d78.png";
export const गजरAudio = "fc49211b-f12a-4ebb-a671-b6af7d9fe6cd.wav";
export const सरजImg = "998ddcc3-9f39-48ed-849d-4ccb42c9ae0e.png";
export const सरजAudio = "fd5e7e68-92cc-4b03-ac9f-ca99eb3ddacc.wav";
export const झरनImg = "072aca69-b5c3-4827-bf7a-63391a031c22.png";
export const झरनAudio = "072aca69-b5c3-4827-bf7a-63391a031c22.wav";
export const टमटरImg = "0f8d66b7-7f31-4821-90c4-03ca7106df64.png";
export const टमटरAudio = "77e8c7f3-7940-46c7-b993-4e76ee49a90c.wav";
export const मटरImg = "780eb0d1-3b70-4a37-9e88-747b8d5fcf10.png";
export const मटरAudio = "780eb0d1-3b70-4a37-9e88-747b8d5fcf10.wav";
export const ऊटImg = "39b9a4ce-0800-4337-9115-81049112a5e5.png";
export const ऊटAudio = "79ca57a0-163b-42ba-aad1-8063f31ebd5f.wav";
export const ठठरImg = "3eb6a5d6-fb4b-4f4e-a556-4d0f0b1bdf3e.png";
export const ठठरAudio = "3eb6a5d6-fb4b-4f4e-a556-4d0f0b1bdf3e.wav";
export const गठलImg = "d497bce8-0bcf-4b21-b904-64b88233b29c.png";
export const गठलAudio = "4e62f270-f95e-423c-afef-eedda462766b.wav";
export const आठImg = "bf1d56d1-de39-44bf-95bd-da7ab9935515.png";
export const आठAudio = "840c7dea-0cad-4237-9827-54299e445d71.wav";
export const डमरImg = "fe3d46e4-4a81-49cb-8373-848e2574cffa.png";
export const डमरAudio = "fe3d46e4-4a81-49cb-8373-848e2574cffa.wav";
export const पडImg = "94816c6c-c18b-40ad-b20e-25d19694f1da.png";
export const पडAudio = "4267107a-1eaa-49e8-8be8-0d45745e817e.wav";
export const ढलImg = "fde3578d-3ecf-494d-9355-92cab9fee758.png";
export const ढलAudio = "fde3578d-3ecf-494d-9355-92cab9fee758.wav";
export const मढकImg = "fe2e7b19-a3eb-4955-a589-5965be134bd0.png";
export const मढकAudio = "114901e6-dbcf-4fa8-91c2-a2ce76de1190.wav";
export const लवणImg = "2860bc6d-2da9-46b8-943d-5538e372282c.png";
export const लवणAudio = "867b8376-0dd1-40e9-aaa7-a2e4898c5197.wav";
export const तटImg = "b991c87d-89d4-4388-8c50-45dca03511a9.png";
export const तटAudio = "a2c0019d-40a2-47a2-8023-c32405f413aa.wav";
export const सतलImg = "2059df08-6338-497c-9394-1b8da986bea9.png";
export const सतलAudio = "037a33c9-8434-438e-8d2f-d6c914340664.wav";
export const रतImg = "2e9f1e59-7c52-44c8-9d03-8ba774b85184.png";
export const रतAudio = "e64e97c6-c2bb-4199-afd0-e09394117b48.wav";
export const थकImg = "0b164722-9a22-4e55-80e6-7462c27e089b.png";
export const थकAudio = "0b164722-9a22-4e55-80e6-7462c27e089b.wav";
export const हथImg = "ed2652bc-f2d4-44a5-a44d-9bebf34074ff.png";
export const हथAudio = "739ed9cf-517a-4024-bf37-97c6ea09916f.wav";
export const दरवजImg = "e0d5799b-7048-4f00-bbd6-12444f2e6861.png";
export const दरवजAudio = "771f0483-4886-43e5-8aa8-4b320ee476e2.wav";
export const बदलImg = "80e77960-e564-4cab-b3da-99d03d73835d.png";
export const बदलAudio = "e3618ee2-a6b8-4f46-b079-80180fab1c1e.wav";
export const आनदImg = "1143f959-bc6d-40c6-be95-a51372b3bd9d.png";
export const आनदAudio = "a7393955-3a53-4b40-a6bd-a3a5271e3df9.wav";
export const धनषImg = "25acc4ee-38b8-45f1-9e5f-ad22c2acad64.png";
export const धनषAudio = "873c3e60-1b0c-4e97-ae24-700e4b4fc43a.wav";
export const इधरImg = "6d551a7f-a262-4c4a-9523-e7008cfcb18c.png";
export const इधरAudio = "8cdb2b82-803e-4a10-bb2c-25369138c646.wav";
export const दधImg = "3943ec7c-2460-4f90-837a-aa3911259554.png";
export const दधAudio = "5fae2338-1f38-42c8-9244-9be9c82985fc.wav";
export const नलImg = "e22823a6-49f0-43b2-8dad-b04683eb8168.png";
export const नलAudio = "1b0dc45a-e9dc-4757-b3cb-282b7af22123.wav";
export const जनवरImg = "f8c87583-1fe8-4645-a5d8-38cded2a14bd.png";
export const जनवरAudio = "e4deb23a-5794-49eb-9190-c5c458a9b43d.wav";
export const बहनImg = "1c9770ea-d87f-4a46-8b28-dfe16e8451e3.png";
export const बहनAudio = "d12eb685-5bf5-471b-975b-34654a7cef91.wav";
export const पतगImg = "9c01bd5f-1c1d-4f89-93ba-e442f92f7620.png";
export const पतगAudio = "c491e6d4-b849-4348-8cb1-54cd5060c095.wav";
export const कपडImg = "ee0ef83c-65de-4243-a0ae-1726c04dad2a.png";
export const कपडAudio = "e10aa655-92b7-4e7f-a01a-56ccbd9a4df7.wav";
export const सपImg = "2c9770ea-d87f-4a46-8b28-dfe16e8451e3.png";
export const सपAudio = "ee562ffa-d151-4da7-93f6-14945b17dc83.wav";
export const फलImg = "50b28eea-ce87-40a4-b002-a32780e02963.png";
export const फलAudio = "5dd904b3-890e-4aff-80bf-10fe689f22c3.wav";
export const बरफImg = "9ee540d5-38d9-456a-81b5-1c02ce0d00c8.png";
export const बरफAudio = "d9e15a1a-8043-49a3-aebe-4b10e15ce9a7.wav";
export const बतखImg = "26702b76-54b8-4eb4-8b54-d61449031d2f.png";
export const बतखAudio = "26702b76-54b8-4eb4-8b54-d61449031d2f.wav";
export const सबहImg = "01ad760d-b3f4-4ae6-a47c-dac557721873.png";
export const सबहAudio = "01ad760d-b3f4-4ae6-a47c-dac557721873.wav";
export const सबImg = "ca354a27-0fb8-417b-8a06-277794dd433f.png";
export const सबAudio = "56f32c4d-9d5a-48dc-9f22-ad889cc56cb8.wav";
export const भयImg = "80e53d49-0a31-48a5-b179-c68105e882ab.png";
export const भयAudio = "b0254e25-a084-439c-a4a8-59d0865bb12b.wav";
export const अभयImg = "c9a52f92-093d-42d9-b779-4e8b613e5e5a.png";
export const अभयAudio = "c9a52f92-093d-42d9-b779-4e8b613e5e5a.wav";
export const नभImg = "3f9d71cd-8646-4a8d-88ec-26849d6d0e7a.png";
export const नभAudio = "d0c6c2f1-4131-486e-89b1-1357ee1696e9.wav";
export const मछल2Img = "36256c00-ee25-4918-a880-7ef70e6cbd94.png";
export const मछल2Audio = "4e06deb4-3910-4cf7-9836-a2efd06bb704.wav";
export const गमलImg = "d3c82598-57c1-46de-a968-6127d14f06b9.png";
export const गमलAudio = "fe076834-0c17-4fc1-a70c-650b5718cb8b.wav";
export const कदमImg = "e2ac18ac-858f-482d-acf7-2a53b68cdd13.png";
export const कदमAudio = "79eda54b-4755-4f18-b659-63a28a639fb5.wav";
export const यहImg = "698965c4-64a0-4e1b-a728-d18a1e3a8b43.png";
export const यहAudio = "698965c4-64a0-4e1b-a728-d18a1e3a8b43.wav";
export const पयलImg = "a850380f-f295-49b6-937d-99b20ad715f0.png";
export const पयलAudio = "172461a3-2f0a-4a58-953c-1cfdc001d49d.wav";
export const गयImg = "e91bc7e9-622f-47e5-8a1a-78dabd98566c.png";
export const गयAudio = "8519e871-c612-4540-9055-76f049b793bc.wav";
export const रथImg = "372a87ab-3772-4618-b040-fa38739a99cd.png";
export const रथAudio = "0920684f-6640-4a72-bb03-73814b972cb6.wav";
export const भरतImg = "f0736306-4728-447c-816e-36151a9e7405.png";
export const भरतAudio = "93070d52-b1b1-4854-aa7e-952a95a7be95.wav";
export const चरImg = "6f4d5dd9-19a8-4c33-be19-2a94ebc602d0.png";
export const चरAudio = "177242ca-8815-43b3-9e5f-86b484296b30.wav";
export const लडकImg = "e8d45718-0686-4eee-b96d-6331bc2ce00c.png";
export const लडकAudio = "45f94149-dd47-4bbe-8e79-bea43073ab29.wav";
export const चलनImg = "09aba370-e513-4c7f-aa76-6e390315cd49.png";
export const चलनAudio = "a8db654e-a9b0-40be-ac14-5297bd443b3c.wav";
export const बलImg = "c52f5d62-5d36-47e2-9437-24c81c410d90.png";
export const बलAudio = "952b33a5-af48-4025-b490-e21fcf0a1c3e.wav";
export const वनImg = "0c49601a-7f66-48c6-b367-62acf8354f41.png";
export const वनAudio = "af412a4d-d861-4baa-be7d-b0e5e56124d8.wav";
export const चवलImg = "6ca0dd65-2ad4-4fff-a659-268058f769ee.png";
export const चवलAudio = "fa8d6c05-0454-4f27-ac11-0a239e60d74a.wav";
export const नवImg = "482ff176-96ce-4635-a74e-0870fc9c7b9e.png";
export const नवAudio = "6138a943-42d3-4869-bcb3-d957338aed1d.wav";
export const शहरImg = "73e57f4f-f558-40a6-be91-239d0e420b18.png";
export const शहरAudio = "32427079-69fe-4499-b040-befc379eeb60.wav";
export const बरशImg = "4b610f12-60b0-4957-b6b6-6436b8be0627.png";
export const बरशAudio = "4b610f12-60b0-4957-b6b6-6436b8be0627.wav";
export const षटकणImg = "0431d520-d257-4aaf-915f-26d9bf2082c8.png";
export const षटकणAudio = "81cba076-8930-4751-a443-b8528696424e.wav";
export const वषयImg = "ae9976b3-7d1a-431a-b8fb-ce33f5ce1589.png";
export const वषयAudio = "ae9976b3-7d1a-431a-b8fb-ce33f5ce1589.wav";
export const धनष2Img = "25acc4ee-38b8-45f1-9e5f-ad22c2acad64.png";
export const धनष2Audio = "0f57570f-f5cb-467f-8874-74fcf5ef1692.wav";
export const समयImg = "e82b7321-8731-4d1c-bfca-7ac0605f19ae.png";
export const समयAudio = "d0643600-85df-472e-b3ab-8a86f73e6a45.wav";
export const आसमनImg = "3f9d71cd-8646-4a8d-88ec-26849d6d0e7a.png";
export const आसमनAudio = "ebf0a15b-ee7e-4ce3-aad9-8a55970c9189.wav";
export const घसImg = "4f9c6046-c961-4da5-a4e2-d5175bc5a4a1.png";
export const घसAudio = "85ffbc8d-252d-482d-8526-b6172e4d1d1f.wav";
export const हवImg = "6ec3d318-cf28-4545-990e-bf3e5bb59161.png";
export const हवAudio = "6ec3d318-cf28-4545-990e-bf3e5bb59161.wav";
export const महलImg = "7df78418-fe35-4391-be1a-568ba1f3d0f6.png";
export const महलAudio = "7df78418-fe35-4391-be1a-568ba1f3d0f6.wav";
export const सबह2Img = "81940a08-7b4f-478b-b356-27cfe44530cd.png";
export const सबह2Audio = "81940a08-7b4f-478b-b356-27cfe44530cd.wav";
export const कषतरयImg = "cecf3c32-e0f1-4453-befd-01cd6f75886c.png";
export const कषतरयAudio = "40b75d04-c2e4-4c53-8de1-80d45e4e6a0d.wav";
export const अकषरImg = "52f68a3c-b2b8-4ebb-a12d-5ba35c555f17.png";
export const अकषरAudio = "5a542670-a1e6-44de-9b45-4c3a8a24f3bc.wav";
export const तरशलImg = "cb07d910-f4f3-475b-a728-9e938813a76f.png";
export const तरशलAudio = "1871c8ca-5653-4033-9b8b-fdb7312e36e9.wav";
export const चतरImg = "8d5382e4-024f-4576-8946-9f3a5f221496.png";
export const चतरAudio = "2250dfcd-f523-41cc-8cf3-b1534c7aa183.wav";
export const जञनImg = "141ee8a8-7034-4509-bdb6-be26bf35392f.png";
export const जञनAudio = "60b491b5-5c6c-4baf-b51e-0ed00c9fd1e0.wav";
export const कारAudio = "a6c7131d-fcd4-4b3d-bb3e-5fcc2c0f82b7.wav";
export const रातAudio = "9decac1c-d25f-46a5-b352-bef6a8897664.wav";
export const पिताAudio = "64de7769-3cad-46d5-886d-416ad64747a0.wav";
export const किलाAudio = "9a78721d-5834-4881-ad62-0c0f7870f21a.wav";
export const तीरAudio = "6dd621c3-6e30-44fe-afa0-bf3a35c78047.wav";
export const गीतAudio = "2ce722de-b411-4123-b164-f52ccadad185.wav";
export const सुखAudio = "4127d379-0a9a-49f8-bf42-6112312abc79.wav";
export const रुकAudio = "f6c1e494-36d1-437a-89f0-2db221c401d4.wav";
export const मुखAudio = "c7fb6ec8-2fff-4faa-bf6c-38c3bbf39392.wav";
export const फूलAudio = "15589f54-5298-4014-98a7-b0ed9d44bc04.wav";
export const रूहAudio = "6bdceecb-44f1-484c-8887-3bec54662488.wav";
export const गृहAudio = "58102e52-284e-49fb-a257-a56c3e880a8a.wav";
export const कृपाAudio = "10615646-00cc-4fb6-bc51-8d06c36e46f2.wav";
export const तेलAudio = "ea9d02b8-3295-4d22-9f9a-c59db5c1b849.wav";
export const केलाAudio = "af8d012c-f4da-4425-a2ae-e213ddf8e983.wav";
export const बैठAudio = "af8f79b4-ec51-4d7a-8973-089345099bcf.wav";
export const कैसेAudio = "4ecede2d-60f5-4462-b96e-d5f96db773fb.wav";
export const शोरAudio = "11ec7740-43ff-4b03-a277-832d06e10eea.wav";
export const मोरAudio = "989a18db-d6c7-4a0a-8aea-f5cd50a179b6.wav";
export const कौनAudio = "77b3994c-e1a7-4010-9824-ece666369eae.wav";
export const मौजAudio = "20d34418-c6c8-40e3-9008-00a9f6f6a385.wav";
export const हंसAudio = "3966402f-d02e-4945-8fc1-9b5771021154.wav";
export const नमःAudio = "68949a08-46a0-4cad-b647-568a09fdbf57.wav";
export const पानीAudio = "aa5ea6b0-301a-4cac-b4d3-c818b03da8d9.wav";
export const रुचिAudio = "8b4c74c4-aa89-46f3-965b-b2bccb0ed10b.wav";
export const सामनेAudio = "b35fcc14-10cf-4437-870a-b9a676bc697b.wav";
export const शुरूAudio = "29a39427-d55d-4e85-b679-bb861f6df488.wav";
export const होगाAudio = "ef33e098-49cc-4357-a03f-181f04189b41.wav";
export const दिशाAudio = "32efa15b-7fe6-40f9-a947-a245e2d4ddb8.wav";
export const कितनेAudio = "0af8bb45-ab9c-41ab-b0cf-ec73954a2b10.wav";
export const गोभीAudio = "8e5bee08-82d5-4046-bcf4-d0f6a00b77fc.wav";
export const सुनाAudio = "75363af2-698f-40d4-a6e8-97ba8e42c47e.wav";
export const रुपयाAudio = "ee8f2aa1-69fb-409c-aaf5-fef3d7b211e3.wav";
export const कविताAudio = "f86ab905-db70-4370-9eca-21fc7522483c.wav";
export const मिलाAudio = "88fb7408-908d-44a5-8947-609e353b67d1.wav";
export const सोमारूAudio = "71f4e6b9-52dc-4d54-99f0-a0fc4dffd161.wav";
export const पहेलीAudio = "c483f476-7268-463a-82ed-3403be4a5dac.wav";
export const कहानीAudio = "86625bbb-b25c-4cdc-8439-e90062ef71be.wav";
export const तोसियाAudio = "81f596b3-b7bf-4d97-a611-e9d19147687e.wav";
export const बारिशAudio = "fc5de0ff-41a2-4512-b546-84d107af2a29.wav";
export const कटोरीAudio = "37b31c3d-43f8-4cba-89b1-47c1a6431565.wav";
export const थालीAudio = "acd47ed1-2a06-4ba4-b04d-a4aeaf90a2c6.wav";
export const मुझेAudio = "6450589a-f5f5-4d81-b2a1-611d77386c01.wav";
export const तैरनाAudio = "996afa54-a0ea-4b73-86c0-0dc26bce6cdf.wav";
export const पिताजीAudio = "795180c2-570e-47c1-8ff1-91608045a80e.wav";
export const ढढक्कनAudio = "f6577818-71f5-4b69-8942-abdff7a655a2.wav";
export const सफलImg = "f3j5a3kt-08c8-4d51-b0ab-fa3d944093kt.png";
export const सफलAudio = "f3j5a3kt-08c8-4d51-b0ab-fa3d944093kt.wav";
export const जाताAudio = "be226f53-ca42-4213-9d63-6ff0501a5fb3.wav";
export const खानेAudio = "8a769a36-b144-41a7-bebc-3d8b7f4fe042.wav";
export const केतकीAudio = "2254683a-ece6-47bc-8f93-db33f94b4abe.wav";
export const साराAudio = "5419ba0d-1bfa-4a0d-a24e-6f959f0afcdb.wav";
export const नीमाAudio = "8ae4387d-3fe1-4c5e-bf4c-22eb034274c5.wav";
export const लिखनाAudio = "bd9d0e7d-5333-47ec-a3e9-99e7dcf1f869.wav";
export const लेकिनAudio = "3f5d316c-779c-40c6-afab-58f0cb239761.wav";
export const देखाAudio = "a154e124-3713-476e-ba21-c8dc3f4bf13f.wav";
export const सभीAudio = "24386d3a-e4c4-4c4d-bea8-e318cff99031.wav";
export const गानाAudio = "2745c58d-4551-4bca-80e7-42a519af7db2.wav";
export const मेरेAudio = "7ce8bb74-021f-4110-aa6d-693914f58228.wav";
export const सवारीAudio = "c9b82c35-d1e9-4a44-bbd3-1ae0f5780374.wav";
export const दादाजीAudio = "0c35ece1-6ee6-416c-81eb-154cbff1de84.wav";
export const खेलनेAudio = "a6db9600-de3c-4419-9bc7-b51548f9a930.wav";
export const भाषाAudio = "1a140c87-925f-4a00-8c45-1fb834001119.wav";
export const चाचाजीAudio = "4740c574-d110-4ed4-a8f5-8915db9b6558.wav";
export const सहीAudio = "77584118-be92-4164-a139-2f4a96440192.wav";
export const बिरंगेAudio = "7db05823-0797-40a3-8554-c61a7193b545.wav";
export const कुछAudio = "a375038b-2b7a-4726-a6ba-af8147ea5357.wav";
export const दुनियाAudio = "c94ec56b-3047-4590-a97f-0a2a2da08b5c.wav";
export const किसीAudio = "f78b7e5d-f923-4a94-a7b9-57730f077356.wav";
export const तुमनेAudio = "63663f1b-b6ce-42ba-b26f-7e705befddb1.wav";
export const चाचीAudio = "9ab37f9d-df91-4628-a3f6-da08b82979da.wav";
export const रोटीAudio = "b6689e0a-2e68-4b86-aa68-94bc364aaf6e.wav";
export const छोटीAudio = "56ec5ee1-90c9-4197-87bd-650d34f2b083.wav";
export const खिलौनेAudio = "1afb713c-2d1a-4818-a9ed-ff8590bd34ff.wav";
export const गिनोAudio = "5c6cad17-1d46-43b0-9504-8c5cd43c2212.wav";
export const लिखोAudio = "048d57d9-7992-4875-88a5-17e925128644.wav";
export const देखोAudio = "90b38c9a-c1d9-48b5-9ba5-414c026263a2.wav";
export const जितनीAudio = "2c47eafa-6af2-4259-ac2f-6ec50360578c.wav";
export const निकलाAudio = "23db2cd5-3cfa-4285-a22e-865c943c5e40.wav";
export const बोलाAudio = "361fc098-fa11-40be-bf03-86e1d3856944.wav";
export const चूजाAudio = "096a8313-7ef2-4c51-84b9-1d79843f7550.wav";
export const घूमनेAudio = "c1221563-093e-4c73-8097-da9891ced4d3.wav";
export const बोलेAudio = "839c1f6c-45e3-4da7-b4bf-f481b4027365.wav";
export const गिलासAudio = "c5816f47-01c3-4245-b1ef-51a900c71c39.wav";
export const मिलानाAudio = "bc04575f-82bc-403b-942d-d404c0a1a2b8.wav";
export const रूठाAudio = "72b0c801-4666-4a5b-8bf6-b4fd42f56400.wav";
export const रुकनाAudio = "d0f908f4-3a79-41ea-b33f-59ae58c2b095.wav";
export const रुकावAudio = "7302a842-e0c6-43b4-b67d-e3cdf3e10b57.wav";
export const रूपाAudio = "8316c5be-e7ee-4c6b-81e6-986161667bb1.wav";
export const सिपाहीAudio = "e82ea310-4077-4299-a8db-8fc741baf073.wav";
export const तितलीAudio = "4a3ed0bb-625d-4baf-a5ea-4f22162d9e80.wav";
export const हाथी2Audio = "2c55bff3-141a-4cc4-99ba-17f6feaf96f7.wav";
export const छाताAudio = "92316d85-69ca-4841-a0ad-8039a65830d1.wav";
export const धनियाAudio = "23067eab-daf8-4642-8f82-5272602af776.wav";
export const अःImg = "d8f9b2a1-7c4d-4e92-a1b3-5c8e9f2d1a4b.png";
export const अःAudio = "d8f9b2a1-7c4d-4e92-a1b3-5c8e9f2d1a4b.wav";
export const ङImg = "e3a2c5f0-1b8d-4a7c-9f2e-6d4b3a1c5e9f.png";
export const ङAudio = "e3a2c5f0-1b8d-4a7c-9f2e-6d4b3a1c5e9f.wav";
export const ञImg = "f1c4e7d2-9a3b-4c8d-b5e1-2f0a8c7d6b5e.png";
export const ञAudio = "f1c4e7d2-9a3b-4c8d-b5e1-2f0a8c7d6b5e.wav";

//telegu

export const అలImg = "2ffbd4ff-6bc8-40db-99f1-86acc008d117.png";
export const అలSingleAudio = "570022e9-909f-4ec5-b913-cec732d195a5.wav";
export const అలAudio = "1521c228-c3a7-435c-96d6-efb08d80ea02.wav";
// export const ఆటImg = "3a074e2c-5fb0-44ba-9cd4-ffa7cd7b73b3.png";
export const ఆటSingleAudio = "4d94959f-be7a-4f87-8614-ba1821477629.wav";
// export const ఆటAudio = "5cf280d8-4200-4697-8d76-099fd40ddaa1.wav";
export const ఇలImg = "51d31076-753f-4457-bc74-3a42d755a2d3.png";
export const ఇలSingleAudio = "5fe42a6d-31b3-4803-961a-362e4fd7b3d1.wav";
export const ఇలAudio = "386867ab-fbd7-46b9-8436-1682f83a22b4.wav";
export const ఈగImg = "362cc367-2303-4aad-86e1-f35baa039e43.png";
export const ఈగSingleAudio = "0eb9b2bf-e692-4e0e-8c64-d2697e91215e.wav";
export const ఈగAudio = "d45cb651-e762-4509-87c4-fdff5749a30b.wav";
export const ఉడుతImg = "8319cfd0-1521-43ed-84f8-412d04b1ec5c.png";
export const ఉడుతSingleAudio = "8fae43a2-8c15-4274-b484-79ebc2749012.wav";
export const ఉడుతAudio = "b419c693-b4fa-4b6c-b8c7-50502e2363c9.wav";
// export const ఊయలImg = "3740866d-ca9e-4126-b304-bc427c6ff17b.png";
export const ఊయలSingleAudio = "4fe1f8da-7837-49aa-b141-56404bc5bdb7.wav";
// export const ఊయలAudio = "28c4796f-6529-4c0e-a2b7-5c4fa8df44d5.wav";
export const ఋషిImg = "0bac4bd4-9cd4-4f39-ae4b-dd0868ee14ab.png";
export const ఋషిSingleAudio = "2b518e4f-64b6-4c93-b16c-79edd9d78a5c.wav";
export const ఋషిAudio = "0a0681a4-b18a-4921-9580-5d221068a795.wav";
export const ౠకImg = "672c1107-0025-4380-b2b9-52340e13b192.png";
export const ౠకSingleAudio = "600947f6-1511-417d-aa70-550114214eb0.wav";
export const ౠకAudio = "c55c9287-3dcc-4cba-ad32-787ae015675e.wav";
export const ఎలుకImg = "3f1f4c7a-adb4-4bb6-a34d-9c53877fbd12.png";
export const ఎలుకSingleAudio = "ae011572-8d51-4a84-872f-7ede0c76c8d8.wav";
export const ఎలుకAudio = "fa12a9a3-4273-46a7-8c23-e360018794ad.wav";
export const ఏనుగుImg = "ea2047cd-7182-43bf-9b9e-f3c835e1d647.png";
export const ఏనుగుSingleAudio = "5af76385-c2b0-41d4-92e1-016c336df5f4.wav";
export const ఏనుగుAudio = "47f0daf3-dfde-43df-bc65-a06a538328e5.wav";
export const ఐదుImg = "20e410a6-8e8a-4a9a-b78c-60c2533cbfe2.png";
export const ఐదుSingleAudio = "01de0860-c5a6-40be-a29e-47e3455e1a8f.wav";
export const ఐదుAudio = "18c717cb-9fa5-4fa6-9670-3d66e4058a69.wav";
// export const ఒకImg = "8f7c89a2-4456-443c-b91e-b8b13e1c26f9.png";
export const ఒకSingleAudio = "46dc7de7-8d3f-4db1-aebe-49dc0dc1eb2c.wav";
// export const ఒకAudio = "5bb9b035-5283-4136-9fe8-369461c3b16a.wav";
// export const ఓడImg = "df41b634-9ab1-4b08-9629-e48ee75f6d3a.png";
export const ఓడSingleAudio = "29c008a5-eadf-4b5c-9572-01a3b2181c75.wav";
// export const ఓడAudio = "5dc7edc5-de10-4163-b922-48b6ed7d84f1.wav";
export const ఔషధంImg = "f11e665f-fed2-47a7-aa83-4ce879d6990d.png";
export const ఔషధంSingleAudio = "4b2eb3ed-0eff-4d2d-be0e-a9020d3b0c4e.wav";
export const ఔషధంAudio = "27081b0b-e936-451f-b6b0-714cc8b5a8ac.wav";
export const అంగడిImg = "03f39912-a715-47a5-a9c7-c51735cf0e12.png";
export const అంగడిSingleAudio = "d4535b9b-a76b-48c1-92a9-399fe8b732ea.wav";
export const అంగడిAudio = "fbde2c8c-7097-444d-acd9-5516e59b1803.wav";
export const అఃImg = "ghf39912-a715-47a5-a9c7-c51735cf0e12.png";
export const అఃSingleAudio = "gh535b9b-a76b-48c1-92a9-399fe8b732ea.wav";
export const అఃAudio = "61b80846-4aa4-40a3-88ad-3b55f8e4138b.wav";
export const కలImg = "6b60c09f-486f-48e9-9b24-100f1dff54e3.png";
export const కలSingleAudio = "7fe8d951-8799-4abd-9427-bc08981d34f0.wav";
export const కలAudio = "aee882ab-2447-427c-8d2b-cae2c2c2b2e7.wav";
export const ఆకలిImg = "d6f92441-3e85-4703-a575-0fee44169555.png";
export const ఆకలిSingleAudio = "9ff28a44-7aba-4b42-9078-3fe00384055a.wav";
export const ఆకలిAudio = "248b3183-a7fa-4110-8454-c76d437dce89.wav";
export const చిలుకImg = "79d75593-297d-4400-86e8-e44c7a81a10e.png";
export const చిలుకSingleAudio = "6f210734-af31-43a2-a3c0-ea90005f4d8e.wav";
export const చిలుకAudio = "1d8fec2d-bed7-48e4-abfb-69e8133f3607.wav";
export const ఖరంImg = "7b60c09f-486f-48e9-9b24-100f1dff54e3.png";
export const ఖరంSingleAudio = "802032dd-d2d3-436d-9036-11a1ba3d5b8a.wav";
export const ఖరంAudio = "9e19b83e-63a4-47a2-8919-a0d4c17d156d.wav";
// export const గదImg = "ada68044-9107-4572-8945-11f6dbc73694.png";
export const గదSingleAudio = "01a1d3c8-9b59-4cad-810b-5438f92c8852.wav";
// export const గదAudio = "3d7c27d9-f773-49b8-af09-1c7aa39c3535.wav";
export const ఉంగరంImg = "b0fa8242-9098-4038-94e1-70bd571cf2fd.png";
export const ఉంగరంSingleAudio = "c367e8fa-c6fd-4c15-8f94-a1bc3f9bd126.wav";
export const ఉంగరంAudio = "bc0fa3ca-7c67-4b96-84dd-de0fa3438077.wav";
export const పండుగImg = "d10f0f87-85af-4b8c-b32a-eaecf758409b.png";
export const పండుగSingleAudio = "0a7d5de2-7a96-4c09-8371-ceeaea9540f4.wav";
export const పండుగAudio = "f435e8ea-5d37-4b2c-b2a6-ec9f69e2a64a.wav";
export const ఘటంImg = "d4744503-0d37-42e6-8a1d-0b6dc33b9359.png";
export const ఘటంSingleAudio = "81b4c720-8ad9-4beb-b59f-46fe50b5fe59.wav";
export const ఘటంAudio = "7965d8dd-2a14-4db0-8f00-8889c3dc20cf.wav";
export const మేఘంImg = "b92b8fe4-22fb-4cd7-be5c-b915a0ebb920.png";
export const మేఘంSingleAudio = "bccfb6f7-a546-480a-991e-02f09c9b750b.wav";
// export const మేఘంAudio = "160da39d-d919-4431-9943-6f1637ac3aac.wav";
// export const ఙImg = "gh2b8fe4-22fb-4cd7-be5c-b915a0ebb920.png";
export const ఙSingleAudio = "ghcfb6f7-a546-480a-991e-02f09c9b750b.wav";
// export const ఙAudio = "fcf6351f-1be9-4439-9a8c-fe361e11c59b.wav";
export const చరకాImg = "e3ddc30a-95ff-4c22-9b43-7f0438dff987.png";
export const చరకాSingleAudio = "5e9060c1-b3c3-4273-a365-92d169401355.wav";
export const చరకాAudio = "4420dac0-06e7-4938-90c7-a44c8281cd51.wav";
// export const రచనImg = "6d1ffc8e-aaac-483c-a536-f55acb4adfa6.png";
export const రచనSingleAudio = "9beaa785-4b92-4d17-a20b-3937b70211c9.wav";
// export const రచనAudio = "608a6114-a01b-4384-b07a-54142ed1fc83.wav";
export const కిచకిచImg = "5dda46e7-fdb3-4c83-97f1-68d000ffb27a.png";
export const కిచకిచSingleAudio = "d601b1ba-5b28-4aaf-b04f-5aff2d6de1b6.wav";
export const కిచకిచAudio = "0aade01f-5092-4ad0-a8a9-f20c6602279f.wav";
export const ఛత్రముImg = "7c0b6885-face-4acc-85d6-0a4015a38f12.png";
export const ఛత్రముSingleAudio = "e78de537-e8d3-47c0-8b35-9a46790b7bba.wav";
export const ఛత్రముAudio = "3ac45b41-2ba5-4f17-891d-5b96f930f48d.wav";
// export const జడImg = "154e4c3a-c9a8-4476-a35a-c5dce445f994.png";
export const జడSingleAudio = "ae487b5c-06dd-4fb1-b0bf-f7d405ced369.wav";
// export const జడAudio = "1571096a-fd0b-4ae0-b333-f14a578f2264.wav";
export const కంజరImg = "df27fd9d-986b-4234-b71f-5d95a4ffec66.png";
export const కంజరSingleAudio = "ff80ede9-40c3-4485-b659-80cd8e8bc426.wav";
export const కంజరAudio = "dea63449-339a-4a83-bccb-16ab4bda912b.wav";
// export const జలజImg = "00921181-9e17-48c5-81f9-5820464c3a39.png";
export const జలజSingleAudio = "aa05c392-13ef-4745-9c92-66fd42d65ea8.wav";
// export const జలజAudio = "acbccf63-5361-4a73-ac9d-bfb7acd9be7e.wav";
export const ఝషంImg = "5547a178-79fc-4abc-8994-9bfdb2a0ccae.png";
export const ఝషంSingleAudio = "aff9bee6-f096-4ec2-90b9-d0e82d7c03dd.wav";
export const ఝషంAudio = "4b501d81-35a5-4b55-872c-da448f24645b.wav";
// export const ఞImg = "gh47a178-79fc-4abc-8994-9bfdb2a0ccae.png";
export const ఞSingleAudio = "ghf9bee6-f096-4ec2-90b9-d0e82d7c03dd.wav";
// export const ఞAudio = "192d6451-0507-417b-9d43-e8d95c00a7da.wav";
export const టమాటImg = "5493860c-9c44-451c-b88e-1a95e03fa887.png";
export const టమాటSingleAudio = "da2ca59f-65ce-4ec5-b817-9e0e45731a2a.wav";
export const టమాటAudio = "61147476-b41f-4b46-b118-b410ce669360.wav";
export const నాటకంImg = "d698f429-3a79-417c-9ec5-1f73aa3c565e.png";
export const నాటకంSingleAudio = "74d13a29-e173-4e34-bedb-2a660eb99d81.wav";
export const నాటకంAudio = "ecb83ee0-a0ff-490d-9206-95501604867e.wav";
export const తోటImg = "4655629d-44de-4735-b087-53ad7b280f04.png";
export const తోటSingleAudio = "c24dc08d-43cd-4064-84d7-754132366faa.wav";
export const తోటAudio = "c176561c-3ae2-4075-a60b-afe32d96be1c.wav";
export const పాఠశాలImg = "4ab53dd0-ae61-4a08-8014-10d18dc109cc.png";
export const పాఠశాలSingleAudio = "74143e1d-8ce5-4dd0-8c26-1d6085b27792.wav";
export const పాఠశాలAudio = "0de7d6b9-edf0-4a0d-913e-616a88ddf868.wav";
export const పాఠంImg = "b7bdd811-c183-48bc-8a53-00459afc3f28.png";
export const పాఠంSingleAudio = "d5a86f1d-6f42-460b-8a33-c6daa6b6b94c.wav";
export const పాఠంAudio = "7d2cb5e7-d7b7-4dea-8aaa-0d9d730d10fc.wav";
export const డబ్బాImg = "45f17492-b03f-4b11-a60d-6340593366ae.png";
export const డబ్బాSingleAudio = "dfd123c6-8e7e-47a1-93bf-0257dd0bef05.wav";
export const డబ్బాAudio = "d10c5199-e089-416d-be12-360e36d145e7.wav";
export const అడవిImg = "54f10a3f-6e4c-4100-994c-acd74ba429e4.png";
export const అడవిSingleAudio = "6ff2781d-bb1b-47c2-aab3-e0c43ba040f0.wav";
export const అడవిAudio = "8d271382-40e2-4bad-996c-e8c5290727fc.wav";
export const బండImg = "44ffe770-bb22-4df3-a329-3edb818514fa.png";
export const బండSingleAudio = "43340597-0679-49f7-a484-08d7fcc41401.wav";
export const బండAudio = "fe53c477-2036-4ab6-a24d-0c93532601bd.wav";
// export const ఢమఢమImg = "8666690d-5d3a-46fe-9b41-c12349ffedf9.png";
export const ఢమఢమSingleAudio = "d0fe37f3-36c3-4585-85e5-11a46a4e0ab2.wav";
// export const ఢమఢమAudio = "ad854a75-e23b-4ebc-9c35-785785cbc8bb.wav";
export const గణపతిImg = "31cb0c92-cc43-4e99-9829-d96f750f86a6.png";
export const గణపతిSingleAudio = "609f73f4-12a8-4b79-b7f8-cc48c1994a35.wav";
export const గణపతిAudio = "a4751432-3cbd-496a-b68a-1cc9585218fd.wav";
export const వీణImg = "f0f5cc76-5be2-4049-9a9b-4ec550c39cab.png";
export const వీణSingleAudio = "ce24cdc6-443a-4199-bfcf-e805ad42f67b.wav";
export const వీణAudio = "4a561212-39b3-4043-b49f-c9ac8b86ca61.wav";
export const తలImg = "c255c1f0-86e7-42c9-b544-cc94e4d60653.png";
export const తలSingleAudio = "ad8f382e-3359-46ff-a256-0921f80770a8.wav";
export const తలAudio = "0d746eab-04b1-43cc-9d77-87a828ced07f.wav";
export const జాతరImg = "231df0c7-e05c-4998-a9de-fabc748edc4d.png";
export const జాతరSingleAudio = "911309e1-4cd1-4fc8-b83e-d6e9ccc847f3.wav";
// export const జాతరAudio = "b0debde0-f1df-4107-9dc1-18ecca7bf0e1.wav";
// export const ఈతImg = "9b8e1871-2287-47cf-92e2-6cb1e3c9be90.png";
export const ఈతSingleAudio = "a058a8f8-03e7-4c2d-beb5-8683804615f3.wav";
// export const ఈతAudio = "5f34f671-1b60-455f-8656-bdde280a43a9.wav";
export const థర్మోస్Img = "77bc4b3b-7ae1-40e9-8dc5-41fd087fe646.png";
export const థర్మోస్SingleAudio = "00c3ff1c-6e11-449f-947a-f65f3782d427.wav";
export const థర్మోస్Audio = "4f121915-5a08-4f9d-944b-c72cf07d6c34.wav";
export const రథముImg = "a75914d0-8d88-40ef-96f7-0a75d3e32829.png";
export const రథముSingleAudio = "c2ed2944-a3dd-4d76-85c1-464475c6f552.wav";
export const రథముAudio = "261f3733-ec29-4b2a-8902-5dfb366137d4.wav";
// export const కథImg = "d9a30014-b116-4841-9985-2af591960b03.png";
export const కథSingleAudio = "135b7137-e1f3-4dd8-b6c2-2e78cb4bd41b.wav";
// export const కథAudio = "25c83967-2779-45e6-acf3-29449a6fa2d2.wav";
export const దవడImg = "c872cedb-767c-49be-8305-ccb1142a1d60.png";
export const దవడSingleAudio = "21f6d78f-830c-4839-8f02-8b9630debd7c.wav";
export const దవడAudio = "74b42fb6-b6d6-4ce5-9dc8-f1935c0d494f.wav";
export const ఉదయంImg = "0aa4c88d-5c2a-4ea0-ac0f-818700da3c1c.png";
export const ఉదయంSingleAudio = "139befbc-9b7b-42a8-870c-5633c52cb985.wav";
export const ఉదయంAudio = "413992ab-c5aa-4bbb-886f-def277e32ef6.wav";
export const కిందImg = "a4502f9e-667c-496d-90f0-6297c0bba0b8.png";
export const కిందSingleAudio = "6b55f698-32cf-4610-a4f3-e6e9280a89e0.wav";
export const కిందAudio = "41a0c3bd-900a-47ef-b6b0-61d0ef711a6c.wav";
export const ధనంImg = "5846d600-b639-4652-a527-b5a2b5284a62.png";
export const ధనంSingleAudio = "8e99356f-18fc-452b-a0f1-b2aad15043fb.wav";
export const ధనంAudio = "acda00c6-4c92-46aa-936a-4381e52b8517.wav";
export const బాధImg = "896726de-0691-44fd-94cc-bcde77c39436.png";
export const బాధSingleAudio = "0b739b4d-df63-4d68-ad92-9aa45dedbc18.wav";
export const బాధAudio = "be6992a4-da6c-4dad-935d-dd918e1381ac.wav";
export const నగImg = "0b4fe26a-bda9-4ef6-af5d-e37ad9b28a74.png";
export const నగSingleAudio = "f7219924-5772-409c-9dee-d926a61c42dc.wav";
// export const నగAudio = "c90c2967-d501-4389-adcb-8d6562086394.wav";
// export const అనపImg = "662504b5-d251-4e9f-9c04-1e50c2ca1885.png";
export const అనపSingleAudio = "c78f2624-afd1-458b-89c0-52aa555d7807.wav";
// export const అనపAudio = "2eb475a5-1a0a-4b20-b6fd-6a1cdc5a48ff.wav";
export const వానImg = "dec09045-6182-43c7-95bc-ee493c12248b.png";
export const వానSingleAudio = "fcdd55e3-b1d5-4f5e-a213-29cbde7023f1.wav";
export const వానAudio = "3031a562-3922-4e88-ab03-f0736578cea9.wav";
export const పలకImg = "1d76e2bb-a57c-45c3-8e60-a07632fb4bc8.png";
export const పలకSingleAudio = "f5e06a57-7c1d-4b23-a779-d47bbd7243cd.wav";
export const పలకAudio = "2629e6fc-348a-4c6c-b9cd-0b596c74a479.wav";
export const చేపలుImg = "05834478-6557-46e2-a293-0b48060bc9d2.png";
export const చేపలుSingleAudio = "8520d6ac-c3ed-43be-aa67-c441bc2c9ae1.wav";
export const చేపలుAudio = "402b20c9-bf17-4d26-ac38-24288ea1cfb1.wav";
export const పాపImg = "4c529422-5080-48a9-87a5-ad0c256905c2.png";
export const పాపSingleAudio = "a0842b11-e9c3-4839-8474-01230453d733.wav";
export const పాపAudio = "6e0038d1-54ed-4ee3-afc1-2eefaa9c69f1.wav";
export const ఫలముImg = "527ae6d0-3e1f-43fd-89a9-cdedaf9e1203.png";
export const ఫలముSingleAudio = "a8fbbcbd-963c-45cb-870d-651f06e1d71f.wav";
export const ఫలముAudio = "0318ddec-0912-4f4b-9313-04f973e5aefa.wav";
export const బంతిImg = "0d7b9c70-d904-4e6f-bf5b-033fe5360931.png";
export const బంతిSingleAudio = "7666ed11-0216-4c3d-9385-f34c764a7d40.wav";
// export const బంతిAudio = "9402507d-381a-4f55-a63c-201fdef355b9.wav";
// export const తబలImg = "e38c69f3-1f80-4e8c-b741-31f0c322b237.png";
export const తబలSingleAudio = "04b8d683-8e8e-4166-a88f-be48c81cc66e.wav";
// export const తబలAudio = "682e8ac9-08ba-42a9-8a36-3014034f073d.wav";
export const భవనంImg = "1d7b9c70-d904-4e6f-bf5b-033fe5360931.png";
export const భవనంSingleAudio = "3ee746cf-d34b-4124-92b3-b50698fd4475.wav";
export const భవనంAudio = "406d74b9-29c0-42bd-9af9-7a2bd30f7fb6.wav";
// export const సభImg = "359efe98-8ca8-443d-bf0e-49eed9582fe6.png";
export const సభSingleAudio = "2e8b9e35-f258-4a5e-afa5-15501c757983.wav";
// export const సభAudio = "e2e5d494-a053-4bfc-81c6-2d0522d906f4.wav";
// export const మరImg = "9f6cbd13-208b-4ff5-b700-1f092c005106.png";
export const మరSingleAudio = "5bdbf4a2-c0de-4e48-b645-ce192b602515.wav";
// export const మరAudio = "1d1d4131-19aa-47c8-b561-e90edb428daf.wav";
export const నెమలిImg = "77a8e153-ce5e-49d9-80d9-a545aa84f340.png";
export const నెమలిSingleAudio = "6b9f685d-0601-4e8e-abc4-55928376dcb0.wav";
export const నెమలిAudio = "c0ed1240-391d-4875-8e74-ee27912f5f8c.wav";
export const చీమImg = "3932069c-0965-4245-95cc-d99e7fb2cc97.png";
export const చీమSingleAudio = "df51b22d-3e7c-4105-a2ed-194c81ed287e.wav";
export const చీమAudio = "722c0457-04fb-4c50-88b6-526a8940b65a.wav";
// export const యదImg = "210ea014-5b8d-487a-b5ad-9ca3be44696c.png";
export const యదSingleAudio = "c9b6a00d-256a-4e78-aa44-6048c10ac74a.wav";
// export const యదAudio = "4d3186ef-fc51-4e69-b86f-9a130684922c.wav";
export const కాయలుImg = "f701ab2c-60d2-40e9-a6cf-3282a119d7e2.png";
export const కాయలుSingleAudio = "d5e92c6f-d35f-4ead-9f3e-d81c66b2ea6d.wav";
export const కాయలుAudio = "b9b23b77-5c7f-4d13-9cbc-a95215866fd4.wav";
export const వంకాయImg = "8c7a8489-fed9-46fa-8918-100a2b79ce04.png";
export const వంకాయSingleAudio = "e114d220-1a5b-4bfa-99a1-c4bed7a16cc4.wav";
export const వంకాయAudio = "7f9d59b0-d89d-4a11-8a1a-027cce1d56eb.wav";
export const రవిImg = "8edd2044-4933-4747-adfc-b0752e4bee34.png";
export const రవిSingleAudio = "77b5310d-cf2a-401b-9d95-9789c9934b32.wav";
export const రవిAudio = "59e33bf7-7e69-4232-a835-af4bc6d8fb40.wav";
export const గిరకImg = "27250993-9572-433c-afbf-9ac29487da07.png";
export const గిరకSingleAudio = "a6013a2d-a00a-4922-9658-acd22c8c5e73.wav";
export const గిరకAudio = "94d60ce6-f076-4b16-8a4c-935a3b29ed61.wav";
export const చీరImg = "531dcfe5-9a66-4a55-81a3-a4bd01b6c676.png";
export const చీరSingleAudio = "93e24968-438b-4e30-897d-5e477f7eb00e.wav";
// export const చీరAudio = "4a3dbd3c-d9c8-4cb7-9933-d6db5cd570e8.wav";
// export const లతImg = "5a8ee72e-0bda-41b9-afa3-7c941fb659c8.png";
export const లతSingleAudio = "9693b54e-951b-497f-9dcb-5021186ff028.wav";
// export const లతAudio = "d632901b-9988-4d96-9af9-b285a38b3592.wav";
export const బలపంImg = "71f293f8-c6ff-425b-b4a1-9ed833b8f49d.png";
export const బలపంSingleAudio = "e4abbe9c-71c4-47c2-8f8d-0af6b4400f32.wav";
export const బలపంAudio = "8ee086ce-ad34-44d6-87b8-7e5a9aa508f5.wav";
export const వెలImg = "d1d8ca66-57b7-4a59-876f-37efd68a80e6.png";
export const వెలSingleAudio = "f575c317-ce19-4408-b1e7-3d5bbc6bd5fa.wav";
export const వెలAudio = "e9345080-9a5a-421a-9dee-0a10e42f0523.wav";
// export const వలImg = "94809065-da22-4985-bae1-3e98b036ece2.png";
export const వలSingleAudio = "c78c0397-8ed0-4849-8d3d-9d81ee95d3f0.wav";
// export const వలAudio = "8d5e02ef-cb7f-41f9-b3b0-33aa991ad0f4.wav";
export const లవణంImg = "f3ccef59-a956-44fc-9bbd-171a9f9ab5ab.png";
export const లవణంSingleAudio = "4ec1d5af-6f60-4188-892b-ba8ecc6e7261.wav";
export const లవణంAudio = "4749451c-014f-4bd0-b2b4-4388550fdc19.wav";
// export const పడవImg = "3873fb75-22e8-4a8e-b2f9-9999e0f668cc.png";
export const పడవSingleAudio = "a53f4223-8195-4771-a89e-6281e2128737.wav";
// export const పడవAudio = "1a4742a8-c976-4d4c-b763-61606e5855d5.wav";
export const శకటంImg = "8189c5d2-64ad-4f4f-b948-10f089d05908.png";
export const శకటంSingleAudio = "2d3b9dd8-4a02-44c6-ba26-f4415c7ef442.wav";
export const శకటంAudio = "a50779d7-2d65-48e4-9ae8-ab7f4952bf91.wav";
export const దశమిImg = "1ab95c3e-c13f-4bfa-a85e-7197b99d5232.png";
export const దశమిSingleAudio = "4291e68d-dc61-464d-b408-1ee1afbfb04c.wav";
export const దశమిAudio = "d41b37fb-eb77-4c1c-af53-ac658d9d8707.wav";
export const దిశImg = "1f5a93f4-9fff-4ac1-bd26-02f7eb14160b.png";
export const దిశSingleAudio = "b5a1b08f-84e1-4fdb-893f-05cb55bf30d0.wav";
export const దిశAudio = "8bb3fb68-2087-43c5-940d-ac55d8c54996.wav";
export const షరాయిImg = "3c20a789-40ba-4dd9-ad5d-e29389174bb7.png";
export const షరాయిSingleAudio = "980aabc0-13a2-435a-bc60-a3f65bcf7ae5.wav";
export const షరాయిAudio = "90227dff-6aac-47cc-b9d9-1d7cbdaeb2ea.wav";
// export const ఉషImg = "0a8c4eca-a048-4366-a0d7-b6fe9f0fac95.png";
export const ఉషSingleAudio = "d64eb2bb-88a0-4bc2-8a93-6f6bb6ba403e.wav";
// export const ఉషAudio = "4efb4374-c0ed-4b50-9127-a2ffc6765395.wav";
export const సంతImg = "3e22bf70-9b83-4e46-b647-adf507ef198b.png";
export const సంతSingleAudio = "0e579e49-af6c-4f61-9184-4bb306887d73.wav";
export const సంతAudio = "716a92c9-9ea2-4f8d-81b2-05d01be46dd9.wav";
export const దసరాImg = "0239ec34-f026-4371-9f25-0da1a681a063.png";
export const దసరాSingleAudio = "7003a15d-f213-46c6-8096-9344bd859b59.wav";
export const దసరాAudio = "bc3727ac-8704-456c-8ed2-0288bdf329a9.wav";
// export const పనసImg = "62215cea-0812-436f-9a85-8ec8e519bd27.png";
export const పనసSingleAudio = "1fdf2d1c-1d00-46df-a382-bbb35e293f8a.wav";
// export const పనసAudio = "df290ab7-2dca-4e5e-b0fd-af78b2524e24.wav";
export const హంసImg = "4b6c0c2e-f001-40ab-9e71-2aab2bd21e74.png";
export const హంసSingleAudio = "baefaa24-6a2b-4f42-9276-cb00490df604.wav";
export const హంసAudio = "629f36ca-87cc-4cbf-9f08-d73d04bcb87e.wav";
export const వాహనంImg = "8189c5d2-64ad-4f4f-b948-10f089d05908.png";
export const వాహనంSingleAudio = "b479fa5d-e493-445e-904b-a229779c9c7a.wav";
export const వాహనంAudio = "8779ad25-1574-41d1-9934-d687b6b4f7fc.wav";
export const గుహImg = "a7e78c04-3585-4dec-ae88-5e28c50ba39f.png";
export const గుహSingleAudio = "cb899386-7a26-49a1-9ef1-d56ba8b20baf.wav";
export const గుహAudio = "a9783ffc-eab9-4bc4-959e-61e686ecc151.wav";
export const తాళంImg = "60e26e2e-d54a-49c8-9926-f4bcf834df73.png";
export const తాళంSingleAudio = "d5bd4f58-d6f8-4833-a4d5-aa2aa08911b1.wav";
export const తాళంAudio = "6fda4576-31e4-4cd1-912d-819e48f0d82a.wav";
// export const కళImg = "54abc22f-4e4f-4f65-87b1-0ba307712af1.png";
export const కళSingleAudio = "fca4e7f2-dd40-4ebe-8f23-5aa3b21815bc.wav";
// export const కళAudio = "e2fec9bd-6753-456d-82ad-61c3d6a10c98.wav";
export const క్షత్రియుడుImg = "cd42799d-4dd6-499f-8385-245cd5958b2e.png";
export const క్షత్రియుడుSingleAudio =
  "476a3055-e38e-4b17-9f3d-d46bcd4dc98f.wav";
export const క్షత్రియుడుAudio = "8f4bd62e-75d1-4f81-9b3c-88559c5d9372.wav";
export const అక్షరంImg = "e28dc5ea-dd79-4ab4-a0c8-2c8f303f1bb0.png";
export const అక్షరంSingleAudio = "040c2d96-32d0-4547-9036-430412116bea.wav";
export const అక్షరంAudio = "b5e070eb-0949-444e-b676-2aa0394c013b.wav";
export const పరీక్షImg = "a17f9270-338b-4e65-8719-dff0835eea32.png";
export const పరీక్షSingleAudio = "6417ff08-1b13-452f-a983-ff4f8ec664ee.wav";
export const పరీక్షAudio = "d74be86f-53ae-466d-a885-9488be69de90.wav";
export const ఱంపంImg = "3409bc12-d115-4b26-8abc-aaeb61440a40.png";
export const ఱంపంSingleAudio = "d3343f4e-aa38-4527-9b27-782646ad76c9.wav";
export const ఱంపంAudio = "3fd7770b-ea3f-496f-8e97-83f15d7242b8.wav";

//kannada R0 s3 links
// export const ಅರಸImg = "4f379beb-f279-4da7-b88a-56ae3f1f8f73.png";
export const ಅರಸSingleAudio = "057dc4c7-febd-4a0f-9605-c867e80b9f18.mp3";
// export const ಅರಸAudio = "9b56d01a-17eb-4459-a1e8-83383ebeb667.wav";
export const ಆನೆImg = "bb82ad72-0cc2-49f2-a506-95c105265c06.png";
export const ಆನೆSingleAudio = "e0588408-f180-4012-9220-616da587c7c0.mp3";
export const ಆನೆAudio = "d8a2252f-ff4d-4cd5-b7ea-0eb4f3719d0e.wav";
export const ಇಲಿImg = "feff971d-c169-4668-969d-4f635e6b4d9a.png";
export const ಇಲಿSingleAudio = "121abb31-d8d6-4188-9357-d7852e9313c3.mp3";
export const ಇಲಿAudio = "4e9676c8-4243-430b-99c9-cf11e004b242.wav";
export const ಈಜುImg = "8470766e-10ca-437b-871a-2ea9d626800d.png";
export const ಈಜುSingleAudio = "890b5c0b-e09c-4cd0-b0bd-d6b31a102d33.mp3";
export const ಈಜುAudio = "cb87c0ed-0204-45a0-a296-4f209b9965d3.wav";
export const ಉದರImg = "7b315f27-2f6e-4da8-8102-b567153655e4.png";
export const ಉದರSingleAudio = "665b807c-e125-42d4-9283-c50d79f64782.mp3";
export const ಉದರAudio = "b43117cb-a467-45d6-88f5-9521fb0703a8.wav";
// export const ಊಟImg = "8d7bf1a3-395c-4741-a820-fffd05deb9c6.png";
export const ಊಟSingleAudio = "35ef3070-c011-4ec1-ba46-950e49e8865a.mp3";
// export const ಊಟAudio = "9e0487e1-47fa-465d-bcdd-a1d71deddee2.wav";
export const ಋಷಿImg = "1607cce6-6288-45de-96ff-8217c4dc1d88.png";
export const ಋಷಿSingleAudio = "d07dc6c9-d535-43f7-8396-9f2c2f2d13ba.mp3";
export const ಋಷಿAudio = "04ded1f6-8d5e-4a70-9982-359676d0058e.wav";
export const ಎಲೆImg = "eea77b2a-f2a2-49b5-a46e-b3ee6ddfc917.png";
export const ಎಲೆSingleAudio = "1a0c6e70-d449-4059-9fb5-392af325fbc2.mp3";
export const ಎಲೆAudio = "af724e6d-0c12-430c-953d-d74ce4c4b568.wav";
export const ಏಣಿImg = "1987c556-46e7-4fe0-ac66-c97b1a1b86a3.png";
export const ಏಣಿSingleAudio = "e6913008-7b58-4bf7-99f9-6cce58f7d9b5.mp3";
export const ಏಣಿAudio = "e3f4cd71-1c2a-4b8b-9e3a-3aaac51b9afb.wav";
export const ಐದುImg = "26cea228-bf75-4075-a0aa-c3fcd0707bab.png";
export const ಐದುSingleAudio = "cbfec947-c575-4d64-b987-c560dc3d6d19.mp3";
export const ಐದುAudio = "c3a67e41-3bd2-4413-bd42-7cdacbe1d52f.wav";
export const ಒಂಟೆImg = "5e6a9174-e884-472d-9869-7cbc8f639ee1.png";
export const ಒಂಟೆSingleAudio = "9011a27a-927a-44d2-a577-d9720d69c6ff.mp3";
export const ಒಂಟೆAudio = "c1b25504-6ede-4774-a924-a1ad3efd4a53.wav";
export const ಓಡುImg = "fb5bb38e-d329-4631-a897-a2cc9d57b3cd.png";
export const ಓಡುSingleAudio = "c27e8576-f5cd-44ce-aa6a-f79f6f73b3b7.mp3";
export const ಓಡುAudio = "ec56a830-7375-4668-87fa-4bbaf34a60a8.wav";
// export const ಔಷಧImg = "58b14867-8dc9-4797-8229-1ca9ee474117.png";
export const ಔಷಧSingleAudio = "d84594a8-7ee4-4eb8-b3bc-2230bf4f975d.mp3";
// export const ಔಷಧAudio = "92297ec4-6bb0-4ecf-9243-da67385151e6.wav";
export const ಅಂಗಡಿImg = "78b14867-8dc9-4797-8229-1ca9ee474117.png";
export const ಅಂಗಡಿSingleAudio = "gh4594a8-7ee4-4eb8-b3bc-2230bf4f975d.mp3";
export const ಅಂಗಡಿAudio = "8a146f85-8c9b-4093-8f8b-4e52d1501186.wav";
export const ಅಃImg = "a345d4ff-5613-4671-af81-9842ce86ed3d.png";
export const ಅಃSingleAudio = "97a38f2b-bb3e-4e74-9b54-ab8bee6acfcc.mp3";
export const ಅಃAudio = "b45f8c70-2d99-4e15-9f6e-904efa15e827.wav";
// export const ಕಮಲImg = "e745d4ff-5613-4671-af81-9842ce86ed3d.png";
export const ಕಮಲSingleAudio = "97a38f2b-bb3e-4e74-8b54-ab8bee6acfcc.mp3";
// export const ಕಮಲAudio = "2357b6c5-9342-4220-a39c-d7fa87f88e64.wav";
export const ಏಕದಳImg = "7dfae44d-906e-4045-bcef-48aa1e08fb05.png";
export const ಏಕದಳSingleAudio = "8dd35eb5-11f4-4fcc-a127-c8ccbc2ccce7.mp3";
export const ಏಕದಳAudio = "23ad8f7a-17b8-411d-a49e-fec45db3819e.wav";
// export const ಪದಕImg = "97469169-e61d-4042-8657-1929b96c841f.png";
export const ಪದಕSingleAudio = "0bd80d15-6aca-4ad5-8321-430b0a47096b.mp3";
// export const ಪದಕAudio = "d4d02d9e-1249-47a2-b83e-9a2adb05fc5c.wav";
export const ಖಡ್ಗImg = "88796552-7a16-4b9c-ac03-cfab609cd3d2.png";
export const ಖಡ್ಗSingleAudio = "eb9b822f-2182-4437-8ac6-680e99e48cb8.mp3";
export const ಖಡ್ಗAudio = "07329473-d79e-4c28-9d6d-a14855408d28.wav";
export const ಲೇಖನಿImg = "6533b3e2-e720-4792-aefa-b27690a9c95b.png";
export const ಲೇಖನಿSingleAudio = "064d7bae-3f7b-4704-b3f6-7850e8909755.mp3";
export const ಲೇಖನಿ2Audio = "13cd35da-524a-40ca-af6c-56adcee521f2.wav";
export const ಪಂಖImg = "c991bcc4-0d7f-4919-890d-31c62fb638c2.png";
export const ಪಂಖSingleAudio = "cad1f181-50b0-4972-bcc1-e1cff95367e0.mp3";
export const ಪಂಖAudio = "0ee49ca0-5004-4439-b043-c2f3bc83d011.wav";
export const ಗರಿImg = "a7a01039-7e0e-4144-b2c6-5399545344e4.png";
export const ಗರಿSingleAudio = "d703a368-424b-492e-89d3-1bcac426b9eb.mp3";
export const ಗರಿ2Audio = "b5cfb194-ca66-4da0-b47b-9fe62626046d.wav";
// export const ಆಗಸImg = "442d99d0-77aa-4bcf-84b2-93261afde1c9.png";
export const ಆಗಸSingleAudio = "01ec453e-be20-40f3-8649-ef384ac6a41e.mp3";
// export const ಆಗಸAudio = "61b4cc0f-ba69-447d-a2f2-18978e765374.wav";
// export const ಉರಗImg = "ae0f04f8-4ca1-42a7-9387-99a87529c425.png";
export const ಉರಗSingleAudio = "08ccc274-a639-4bcb-a3b0-473ee6f5b022.mp3";
// export const ಉರಗAudio = "1ad8cb98-6d89-4750-a5e5-b504cff2e08f.wav";
export const ಘಂಟೆImg = "0e9e8c57-0509-4d4a-8586-01a9e3841b12.png";
export const ಘಂಟೆSingleAudio = "dc888d47-0fcc-4aa2-88a5-c9eb80d91a9b.mp3";
export const ಘಂಟೆAudio = "61356885-48fe-41bb-80ec-97c6717b27eb.wav";
export const ಘಮಘಮImg = "87cc656d-5a20-4afe-901e-386abc700dec.png";
export const ಘಮಘಮSingleAudio = "f24202a4-d4b1-45a5-9526-cd830080fc0b.mp3";
export const ಘಮಘಮAudio = "3f677863-7946-47fb-8333-fa8ddf88c668.wav";
export const ಸಂಘImg = "e534c038-60da-44d9-90b6-00ee33e693f4.png";
export const ಸಂಘSingleAudio = "fcd928f7-8336-4028-903b-773afb8605af.mp3";
export const ಸಂಘAudio = "cd6e04c0-70bb-4e4a-98f9-8aa0913be852.wav";
// export const ಙImg = "g34c038-60da-44d9-90b6-00ee33e693f4.png";
export const ಙSingleAudio = "fcd928f7-8336-4028-903b-883afb8605af.mp3";
// export const ಙAudio = "1992777f-1817-4185-bf98-ba5cbfac40d1.wav";
// export const ಚಮಚImg = "4eeb5ded-7c95-4b98-8541-f11d7185674c.png";
export const ಚಮಚSingleAudio = "a0ce9f7d-0b6b-43dc-a6c9-d132d169c3f9.mp3";
// export const ಚಮಚAudio = "ad1b8981-5431-4d85-b0fb-0991b83ec0f5.wav";
// export const ಈಚಲImg = "4cf124a2-bc27-4dec-a63e-f070551d822e.png";
export const ಈಚಲSingleAudio = "dbf83295-b1ec-4837-8a1b-ca3b7ce8dd8b.mp3";
// export const ಈಚಲAudio = "eef0474e-6777-4322-ba52-26ad0580e2ca.wav";
export const ಮಂಚImg = "58d17ace-20cf-4504-b0de-5706604f84b7.png";
export const ಮಂಚSingleAudio = "e40005d1-ef0a-471b-bd8d-3787e0a4d579.mp3";
export const ಮಂಚAudio = "64055b8b-b27b-4d7a-bdb9-2a98142440e7.wav";
export const ಛತ್ರಿImg = "34d17ace-20cf-4504-b0de-5706604f84b7.png";
export const ಛತ್ರಿSingleAudio = "a40005d1-ef0a-471b-bd8d-3787e0a4d579.mp3";
export const ಛತ್ರಿAudio = "03bd03f6-c3ae-4058-8f10-6681e6cd23b7.wav";
// export const ಜನImg = "e77999c7-1524-4440-9707-8c4d4b0a1ca1.png";
export const ಜನSingleAudio = "4fd1736b-d2f3-45fc-a3c8-9d97674a96ac.mp3";
// export const ಜನAudio = "e2584375-2fe9-441b-9897-5cca5b631d89.wav";
export const ಗೀಜಗImg = "b02aca59-0376-4de2-9cce-a077b9db0a73.png";
export const ಗೀಜಗSingleAudio = "8e34a777-2640-4afc-b3ed-fde6768916fc.mp3";
export const ಗೀಜಗAudio = "c6b7b529-fb9c-4b88-a2fe-2f462d6918c6.wav";
export const ಭುಜImg = "a29f4199-e57b-4d7b-afec-8979083484e1.png";
export const ಭುಜSingleAudio = "ee3f1795-42c5-4e53-8622-a4e710334136.mp3";
export const ಭುಜAudio = "2c7521e9-b1f1-42e9-9cba-6ca7eb8dd2ee.wav";
export const ಝರಿImg = "h49f4199-e57b-4d7b-afec-8979083484e1.png";
export const ಝರಿSingleAudio = "gr3f1795-42c5-4e53-8622-a4e710334136.mp3";
export const ಝರಿAudio = "d3669ec3-de06-4047-8b14-e5c46a0b16c8.wav";
// export const ಞImg = "9ebd3471-7774-46e1-a7d3-61efa82056f4.png";
export const ಞSingleAudio = "r78dbc43-10cb-4f44-94fd-3468474bc007.mp3";
// export const ಞAudio = "6ca9520e-49a4-4fac-ac1d-1ac5060f1b62.wav";
export const ಟಗರುImg = "5ebd3471-7774-46e1-a7d3-61efa82056f4.png";
export const ಟಗರುSingleAudio = "c78dbc43-10cb-4f44-94fd-3468474bc007.mp3";
export const ಟಗರುAudio = "5ee1f669-cd4e-46bd-9dc2-ed44476687bf.wav";
export const ಕಿಟಕಿImg = "19980eb7-1975-406e-8197-ac40d82136da.png";
export const ಕಿಟಕಿSingleAudio = "5ec1a14d-44a5-4938-a50a-b4c5af1809fd.mp3";
// export const ಕಿಟಕಿAudio = "c012289b-f4ef-402f-87b1-58ae4b9c448f.wav";
// export const ಆಟImg = "8cf1c600-16c2-4c89-a46f-cf8bc7bf72b1.png";
export const ಆಟSingleAudio = "091f3def-6b32-4a69-a6fb-a13c33a65053.mp3";
// export const ಆಟAudio = "0565f983-a79b-42f5-9db8-73766a6df323.wav";
export const ಠಕ್ಕImg = "5ff1c600-16c2-4c89-a46f-cf8bc7bf72b1.png";
export const ಠಕ್ಕSingleAudio = "63d2c27d-ea31-45ba-8ce4-cdf24b2bb8c2.mp3";
export const ಠಕ್ಕAudio = "24f405e5-bb7d-4950-a4ee-99b10ac43ef1.wav";
export const ಕೊಠಡಿImg = "39a0b5b1-75dd-444f-a3c9-1366041b8c3c.png";
export const ಕೊಠಡಿSingleAudio = "32d2c27d-ea31-45ba-8ce4-cdf24b2bb8c2.mp3";
export const ಕೊಠಡಿ2Audio = "3a57032d-48a9-4ad6-9298-9f406eb5216e.wav";
export const ಕಂಠImg = "0f4c9b34-671d-484d-97a6-3ff5182782dc.png";
export const ಕಂಠSingleAudio = "3cebca03-bd60-4fd7-9c80-d8fbdcf23caf.mp3";
export const ಕಂಠAudio = "af319bf7-9f88-4589-914e-f898b0afe30e.wav";
export const ಡಬ್ಬImg = "601e2943-c870-4dd8-9109-1af83476d37c.png";
export const ಡಬ್ಬSingleAudio = "54ebca03-bd60-4fd7-9c80-d8fbdcf23caf.mp3";
export const ಡಬ್ಬAudio = "3cd43c47-a9d9-4ba9-b085-76582fbb25a6.wav";
export const ಕಡಲುImg = "38780657-557e-4471-afb5-252eb508c39a.png";
export const ಕಡಲುSingleAudio = "59126c40-1073-4838-b31a-259f6708b64e.mp3";
export const ಕಡಲುAudio = "b9058665-6a4a-422c-8929-72e048de3eda.wav";
export const ಗಿಡImg = "7042677c-21d3-4dfb-8629-9c970b1b74c4.png";
export const ಗಿಡSingleAudio = "a3c59c02-1fcd-4fe7-89fd-6e4f3d690b43.mp3";
export const ಗಿಡAudio = "f53ff6b2-01dc-4a33-8fbe-f66b8c17769c.wav";
// export const ಢಣಢಣImg = "0e9e8c57-0509-4d4a-8586-01a9e3841b12.png";
export const ಢಣಢಣSingleAudio = "b21faecc-64fe-45d7-96a2-40f18c3fe143.mp3";
// export const ಢಣಢಣAudio = "a315fc22-1ee5-4da2-aa2b-89e59d5750d9.wav";
export const ಪ್ರೌಢಶಾಲೆImg = "81aab210-6c49-4f56-9e13-ea8227f8e16b.png";
export const ಪ್ರೌಢಶಾಲೆSingleAudio = "c046f540-ec64-4e37-80a4-cc4be841279c.mp3";
export const ಪ್ರೌಢಶಾಲೆAudio = "28fa0164-785a-43f7-bb0e-6dd379c874de.wav";
export const ಗಾಢImg = "a5e3a32d-0824-480f-b089-48841fd76850.png";
export const ಗಾಢSingleAudio = "d30f363a-e172-49a0-b3b1-50f707606abc.mp3";
export const ಗಾಢAudio = "5dda7055-8c65-4e3e-bc4a-e93e6fe75dd6.wav";
// export const ಹಣImg = "1e05c89e-d93c-48cd-8626-e2d34b354ee2.png";
export const ಹಣSingleAudio = "7544ad70-a8f8-46a4-b769-03b74f10a0ea.mp3";
// export const ಹಣAudio = "5738af7a-1161-48e5-b738-c0aa3af3aeab.wav";
export const ಹಣತೆImg = "525fb136-fc31-404e-beac-ecc2f63bf046.png";
export const ಹಣತೆSingleAudio = "b8df59b3-7c4a-4009-8894-85b89b1afb4f.mp3";
export const ಹಣತೆAudio = "7aef502b-3298-4f95-bd79-0541bf4d0210.wav";
// export const ತಬಲImg = "830d0adb-c5b1-4b91-830b-d12a10162a44.png";
export const ತಬಲSingleAudio = "8cb24205-349c-4678-ae0e-711ce02af7c4.mp3";
// export const ತಬಲAudio = "c2549000-f3c4-41da-b05d-1e36c9688e71.wav";
export const ಸಂತಸImg = "08dab3fe-c865-4e38-ad51-d1dd06308e6d.png";
export const ಸಂತಸSingleAudio = "6f0a9125-b154-416b-9d8f-639fa772bd79.mp3";
export const ಸಂತಸAudio = "e7498616-869f-41af-9d36-9c05c7ca1447.wav";
export const ಗಣಿತImg = "53ed7494-b7e6-4e0f-a5b7-e7f5ce89fe83.png";
export const ಗಣಿತSingleAudio = "1f1921ab-28ea-4b64-9e91-b48219c27fc1.mp3";
export const ಗಣಿತAudio = "ec510f4d-da9e-4592-bf98-6b1f60b94baa.wav";
// export const ಥಳಥಳImg = "1dbc4083-68a5-4b0c-bd34-82b298936b81.png";
export const ಥಳಥಳSingleAudio = "8c7eef30-3729-4f01-843c-e24f7e8aac53.mp3";
// export const ಥಳಥಳAudio = "de09de7c-9328-44fe-bcb4-2fd7835b35d1.wav";
export const ಥರಥರImg = "8d42c984-ef45-4f05-a4f5-27bb88c84e59.png";
export const ಥರಥರSingleAudio = "07094176-161c-4e3d-bdd1-8fed2cad14a0.mp3";
export const ಥರಥರAudio = "9dd07aec-aa86-4118-b2e7-bb0b555305b7.wav";
// export const ರಥImg = "e5206af3-810d-4348-83a0-0c5193c155dc.png";
export const ರಥSingleAudio = "8d3baecc-da3e-42d4-861f-ed6191666a8a.mp3";
// export const ರಥAudio = "4de5a99e-448a-43b2-ba1c-78ae4515b7b3.wav";
export const ದನImg = "04a83da3-a1d9-4ddc-a77d-6cd53fe257a4.png";
export const ದನSingleAudio = "314607d9-6d68-4db9-b661-69fd80ccbb7f.mp3";
export const ದನAudio = "bbf6fb96-21dc-4379-9018-344db9d51dde.wav";
export const ಕೂದಲುImg = "fe2ab25f-06b0-441a-928a-db166e025c95.png";
export const ಕೂದಲುSingleAudio = "c6c5ec4f-7db5-42d6-9e32-a76a0d94a707.mp3";
export const ಕೂದಲುAudio = "d2b8ad19-9559-4410-95aa-5101c50a3a21.wav";
export const ಕಾಗದImg = "f1b108b7-5cd1-428c-8198-b5b6100205d0.png";
export const ಕಾಗದSingleAudio = "f9ca6881-317e-4333-90ee-f0354b0b2384.mp3";
export const ಕಾಗದAudio = "dc411771-e76c-44a8-847a-29c35fdef860.wav";
// export const ಧನImg = "69396d88-9c33-47f7-b6b8-eba9ffd1680d.png";
export const ಧನSingleAudio = "dee29e31-c04b-488d-8a13-ba1420ba7551.mp3";
// export const ಧನAudio = "4d676717-338f-4562-9cb8-a93da6d6ef0b.wav";
export const ಬುಧವಾರImg = "84d7753a-bec9-4054-9376-5e2dfc41986d.png";
export const ಬುಧವಾರSingleAudio = "9818822c-1ad8-4763-81b3-cf8284fc563d.mp3";
export const ಬುಧವಾರAudio = "7c71341e-54ac-4eda-a6e6-9c6f3c43af37.wav";
export const ಔಷಧ2Img = "58b14867-8dc9-4797-8229-1ca9ee474117.png";
export const ಔಷಧ2SingleAudio = "d84594a8-7ee4-4eb8-b3bc-2230bf4f975d.mp3";
export const ಔಷಧ2Audio = "1b780b6b-8171-425f-81a7-bf054c6c4d8b.wav";
export const ನರಿImg = "cad89d2f-5895-463a-9ade-a5fd3cb33682.png";
export const ನರಿSingleAudio = "7e726331-f455-40b3-9c91-ade8b79d5911.mp3";
export const ನರಿAudio = "f1fa3f84-70b5-4fbb-9a9d-3b1d1b092be5.wav";
export const ಕನಸುImg = "d3a8ec04-90b9-4ea7-937f-fce881f41605.png";
export const ಕನಸುSingleAudio = "77ecf439-5e32-4c64-8af8-e0a640fc8292.mp3";
export const ಕನಸುAudio = "d4c2b6df-a85f-48d7-869a-f58c2a872fde.wav";
export const ನಮನImg = "55ce1248-16e2-4e43-abd4-260f6e3d5a78.png";
export const ನಮನSingleAudio = "4c6c7577-2670-4466-b9e2-6b22d8d1c071.mp3";
export const ನಮನAudio = "abab6a4a-747f-49b8-a138-399d22be2d8f.wav";
export const ಪದಕ2Img = "97469169-e61d-4042-8657-1929b96c841f.png";
export const ಪದಕ2SingleAudio = "0bd80d15-6aca-4ad5-8321-430b0a47096b.mp3";
export const ಪದಕ2Audio = "3c7105bb-3875-4dae-977f-d66e6f72a9f2.wav";
export const ಗಾಳಿಪಟImg = "d1596a61-011f-425a-b4bc-8431c072d968.png";
export const ಗಾಳಿಪಟSingleAudio = "f54dcf8f-e1e4-4218-8e7b-ccf8ce0870a7.mp3";
export const ಗಾಳಿಪಟAudio = "9c5627d8-e398-441e-9e2f-a812fc741089.wav";
export const ಕೋಪImg = "acbda781-1dd1-40e4-b275-e34c42f0dc83.png";
export const ಕೋಪSingleAudio = "d7db91c4-a94a-49ca-bf13-c08b3542e4e5.mp3";
export const ಕೋಪAudio = "742b5164-a7c1-478e-9878-57e7e05cbb71.wav";
// export const ಫಲImg = "46b7f782-e11a-48d6-ac27-1a992357af88.png";
export const ಫಲSingleAudio = "587299dd-f51e-4370-8e13-e98078de7bbe.mp3";
// export const ಫಲAudio = "d98dc048-4033-4c41-98b3-6724916e442d.wav";
export const ಸೌರಫಲಕImg = "bcd68769-350b-43c0-8b23-8f640e38b66e.png";
export const ಸೌರಫಲಕSingleAudio = "d3d6d95d-0aa9-42d9-ac0a-6f47185033fd.mp3";
export const ಸೌರಫಲಕAudio = "ee34be9a-5e8e-4d4c-8ce4-63e105383cc7.wav";
// export const ಕಫImg = "ee9cc62b-0312-4eb1-90cd-a7d63f593237.png";
export const ಕಫSingleAudio = "8e87c582-0175-40a5-b5f9-145fd1a58fb5.mp3";
// export const ಕಫAudio = "f6597109-80f2-4a22-b7bd-6f97edf566ad.wav";
export const ಬಟಾಣಿImg = "87de9f6b-5204-4705-a573-3b4cb9959084.png";
export const ಬಟಾಣಿSingleAudio = "25dc5a02-7214-4aed-a222-418716e3f95c.mp3";
export const ಬಟಾಣಿAudio = "3450ad34-9bc9-46b5-a43b-6ddc5e4e7871.wav";
// export const ತಬಲ2Img = "830d0adb-c5b1-4b91-830b-d12a10162a44.png";
export const ತಬಲ2SingleAudio = "548b92c4-c2c0-4efb-8fa5-9e11e18c32c0.mp3";
// export const ತಬಲ2Audio = "d53147f4-8dd6-433c-acaa-569e600f8aaf.wav";
export const ಕುಟುಂಬImg = "06f51a5a-7d95-449b-a38e-5a31163ed3dc.png";
export const ಕುಟುಂಬSingleAudio = "34c65d5b-0a61-488b-9924-5a65ea2a3ab5.mp3";
export const ಕುಟುಂಬAudio = "f83d2e93-66ad-4835-9b91-10fc35f476ba.wav";
export const ಭರಣಿImg = "601e2943-c870-4dd8-9109-1af83476d37c.png";
export const ಭರಣಿSingleAudio = "e6acee39-68e5-4288-a833-b83b0c2bd7d1.mp3";
export const ಭರಣಿAudio = "af706a3d-bfdb-4deb-813d-c2e6cc980993.wav";
// export const ಆಭರಣImg = "8856c235-bb2a-4eb8-9e63-b5a5dc005b33.png";
export const ಆಭರಣSingleAudio = "474d14cd-3717-4735-a73e-7659613a3f5d.mp3";
// export const ಆಭರಣAudio = "142568de-667c-48ab-9b50-23c9056dfcdc.wav";
export const ವೃಷಭImg = "3f22de14-e65c-45e4-ac4a-e0d3ebb03b67.png";
export const ವೃಷಭSingleAudio = "b2e08305-86df-43d6-9df4-461431458a42.mp3";
export const ವೃಷಭAudio = "3fff6890-5a84-40b6-9c66-63c13bbb4c62.wav";
// export const ಮರImg = "4cf124a2-bc27-4dec-a63e-f070551d822e.png";
export const ಮರSingleAudio = "bcd38151-6e88-4edc-ab34-7cf69691aac3.mp3";
// export const ಮರAudio = "4641aa90-5381-44a3-8dd6-74c8c4d57ce7.wav";
export const ಕಮಲ2Img = "e745d4ff-5613-4671-af81-9842ce86ed3d.png";
export const ಕಮಲ2SingleAudio = "97a38f2b-bb3e-4e74-8b54-ab8bee6acfcc.mp3";
export const ಕಮಲ2Audio = "d1148090-82b5-4a6a-be1a-d5aeed47c992.wav";
export const ಹಿಮImg = "7dc423e8-2894-4711-a1af-ca58a5255c7a.png";
export const ಹಿಮSingleAudio = "5ee53bd3-afe2-46a4-8501-21721efd873d.mp3";
export const ಹಿಮAudio = "76ff607f-01b4-4c87-9bed-c3f727768520.wav";
// export const ಯಮImg = "58853b62-d17f-459f-ba31-4008567871b8.png";
export const ಯಮSingleAudio = "6a68bce3-f147-4817-965d-5cc6434408e9.mp3";
// export const ಯಮAudio = "0823de89-00fc-4082-adcf-3ed6c6d50387.wav";
export const ಪಾಯಸImg = "2cf2c9bc-69f6-42fc-b9eb-7c38202d3200.png";
export const ಪಾಯಸSingleAudio = "92c8c754-002f-4501-8ed5-2d9f1671f42a.mp3";
export const ಪಾಯಸAudio = "173ec159-c6ba-4321-b80d-fbeb33823810.wav";
export const ಭಯImg = "8d42c984-ef45-4f05-a4f5-27bb88c84e59.png";
export const ಭಯSingleAudio = "8684920e-bd31-4dc5-b3dd-49d4b5ab5865.mp3";
export const ಭಯAudio = "04eb7023-b69c-4694-8d56-40cc84f21d07.wav";
export const ರಥ2Img = "e5206af3-810d-4348-83a0-0c5193c155dc.png";
export const ರಥ2SingleAudio = "7dfc0727-ccff-4a9d-847a-ee8120af8f05.mp3";
export const ರಥ2Audio = "77b03aab-1bc1-46ee-a7a5-3c0befbf2ad2.wav";
export const ಬೆರಳುImg = "4e41171e-12eb-412d-a750-311fde646f30.png";
export const ಬೆರಳುSingleAudio = "048fae1c-e3e2-40d4-b152-92b2c5c68625.mp3";
export const ಬೆರಳುAudio = "2c77f082-9f27-434f-b7c0-3227b2b1ddfe.wav";
export const ಉದರ2Img = "7b315f27-2f6e-4da8-8102-b567153655e4.png";
export const ಉದರ2SingleAudio = "665b807c-e125-42d4-9283-c50d79f64782.mp3";
export const ಉದರ2Audio = "da3c7c0f-9bdb-492b-b8e4-b922f7806fda.wav";
export const ಲತೆImg = "eea77b2a-f2a2-49b5-a46e-b3ee6ddfc917.png";
export const ಲತೆSingleAudio = "36d5e551-2645-4d5f-b325-741cb7d0a5fd.mp3";
export const ಲತೆAudio = "f6b35c26-aca4-45eb-ab6a-237aec278728.wav";
export const ಚಿಲಕImg = "d8549b66-fab3-4c1c-ae94-8256631db89b.png";
export const ಚಿಲಕSingleAudio = "b50411a0-227b-4263-a510-84164c8d00bc.mp3";
export const ಚಿಲಕAudio = "0c3d4c05-cc44-4a06-bae1-cb3fd2cd1e18.wav";
export const ಮೊಲImg = "c1d9146a-2e12-457b-b84c-e7830c722ccf.png";
export const ಮೊಲSingleAudio = "532ee197-96b0-450c-9600-30c0f10211a6.mp3";
export const ಮೊಲAudio = "9921c585-c95f-43bb-a31c-98c1ae33b98e.wav";
// export const ವನImg = "9fd9f701-c9f9-4784-987b-a9bcd86045c9.png";
export const ವನSingleAudio = "dd852efb-c61d-41d9-9271-c985a0545af5.mp3";
// export const ವನAudio = "2b5ec824-2a7d-426c-a8c2-cc00ef23a657.wav";
// export const ಲವಣImg = "c3d3a849-781f-48a9-9a8b-0c1b5928793b.png";
export const ಲವಣSingleAudio = "bcafb356-d716-4ff1-a960-a47a95a9ac12.mp3";
// export const ಲವಣAudio = "31fb0307-fc82-4fb4-9e70-ffca0a9945cc.wav";
export const ಶಿವImg = "e6079819-d66d-45be-a68b-83710fcd513b.png";
export const ಶಿವSingleAudio = "e5f5c8cc-6488-48bc-bb71-63d32affe0f0.mp3";
export const ಶಿವAudio = "df3158b2-0093-4a13-98b9-1bb99b5ab9cf.wav";
export const ಶಶಿImg = "174f0531-f145-4045-bcd0-b031bd5c4d6c.png";
export const ಶಶಿSingleAudio = "21db8c9a-40d0-4ff3-b153-202fd832a19b.mp3";
export const ಶಶಿAudio = "45193555-a44a-47c2-a0fc-a8539559d8cb.wav";
// export const ದಶಕImg = "26cea228-bf75-4075-a0aa-c3fcd0707bab.png";
export const ದಶಕSingleAudio = "e19fc090-cf86-4241-b940-80380a309658.mp3";
// export const ದಶಕAudio = "be14aabb-2542-4b4d-a314-1b59b90da078.wav";
export const ದೇಶImg = "7fab8475-045d-46a5-b77a-8c982575ec43.png";
export const ದೇಶSingleAudio = "88b0f2f9-906c-4811-ac0a-92bf9338b81c.mp3";
export const ದೇಶAudio = "64903442-4ed9-4bdc-908e-5fd07cef4fcc.wav";
export const ಷಡ್ಭುಜImg = "2cd99ca5-9c96-4d5a-91c9-5f5c3125b506.png";
export const ಷಡ್ಭುಜSingleAudio = "a3e36851-1dcf-4639-bb2b-aa18c7ac13f1.mp3";
export const ಷಡ್ಭುಜAudio = "e3335236-b914-4219-b1c0-b7018c16c372.wav";
export const ಔಷಧ3Img = "58b14867-8dc9-4797-8229-1ca9ee474117.png";
export const ಔಷಧ3SingleAudio = "770ae1fb-08fb-48ec-9c19-2fce6cc7e7fa.mp3";
export const ಔಷಧ3Audio = "7cfb2c51-875d-4401-a5f1-45c252dd5e4a.wav";
export const ಪುರುಷImg = "631a44eb-2187-454e-bbcc-98004113b060.png";
export const ಪುರುಷSingleAudio = "5aca5100-a399-42a3-a24b-0e0f6047944d.mp3";
export const ಪುರುಷAudio = "2e02b9cf-eb56-4321-97f4-3844eb74d337.wav";
// export const ಸರImg = "1c6e6bdd-b4ee-4fa0-aa50-1a6c4dae5469.png";
export const ಸರSingleAudio = "85146f6d-60e1-49bb-9b75-88d8c812b7ad.mp3";
// export const ಸರAudio = "dd98710c-db2f-48d7-af03-786c24a31c44.wav";
export const ಮೊಸಳೆImg = "81462991-970b-4f7d-93e1-d66a4394cbcc.png";
export const ಮೊಸಳೆSingleAudio = "d2a6225d-6406-46f4-87fe-e363ef19d23d.mp3";
export const ಮೊಸಳೆAudio = "589f7815-84d4-47e7-b64e-d9ccbb0a3451.wav";
export const ಹಂಸImg = "01fd62db-a703-4e8c-b57d-11e07ba031c1.png";
export const ಹಂಸSingleAudio = "92985fd7-8b2e-419d-88a0-024c66afaec4.mp3";
export const ಹಂಸAudio = "d81532d7-c4f9-49ad-bdeb-3fc10f02c56d.wav";
export const ಹಸುImg = "04a83da3-a1d9-4ddc-a77d-6cd53fe257a4.png";
export const ಹಸುSingleAudio = "8d4e8b40-e5c7-440b-a396-47854ba2e694.mp3";
export const ಹಸುAudio = "fad2c9b4-05d7-45e8-b5ee-931e91d445ea.wav";
export const ವಾಹನImg = "b3942546-0c28-48a9-bfd0-5b9042a20562.png";
export const ವಾಹನSingleAudio = "07b7f672-a01e-48c6-8c4b-df218cb66dc7.mp3";
export const ವಾಹನAudio = "1195f808-e199-4fa7-8439-d36c2da873f3.wav";
export const ಸಿಂಹImg = "9392ed88-625b-4c08-928c-642a1c168b94.png";
export const ಸಿಂಹSingleAudio = "a7ecfe42-4bdc-459c-8f64-18682c28207a.mp3";
export const ಸಿಂಹAudio = "b66f1963-994f-442a-a4b5-d02cd7cab932.wav";
export const ಹಳದಿImg = "ce1282f0-e52b-4bb1-88e5-cae06be683a0.png";
export const ಹಳದಿSingleAudio = "e6690575-2179-43ac-aefa-9e0455de5e39.mp3";
export const ಹಳದಿAudio = "52a792c8-0dd2-4171-a4e0-a805d004b2b8.wav";

//F2 en
export const HeadImg = "7d1c58d2-dedc-4321-9187-bad01e9c4dd2.png";
export const HeadAudio = "3630499a-0650-4d6d-a8c4-0c3531515628.wav";
export const teacherImg = "54d2c58b-6748-40b3-83b9-93584287f0ba.png";
export const teacherAudio = "86e21061-f447-4f30-ac78-ba6f686abd53.wav";
export const PinImg = "c14aa517-c2a7-42b6-a185-23b9bc9c0de6.png";
export const PinAudio = "14cc57e3-ec30-4f05-82f2-29e3e1671171.wav";
export const WinterImg = "a8c73200-b47f-4cf3-b415-2372f78f3a7c.png";
export const WinterAudio = "014422fa-0f4e-40b3-8d2e-1752344afa5e.wav";
export const AntImg = "a5abf780-f1ee-4cf7-8b33-97d169f58c19.png";
export const AntAudio = "43687bb1-d80a-41d5-b371-6f1b9693473c.wav";
export const plantImg = "41353cea-1b1a-47fe-a410-f1a818b6d834.png";
export const plantAudio = "682ea31e-f5e6-440e-80af-a95fdb133501.wav";
export const AtomImg = "0291e500-ea5c-4391-9f3b-779dd13965f3.png";
export const AtomAudio = "9fa6da66-c862-4f92-bd82-f7dc50f726da.wav";
export const CattleImg = "0a303f5c-742c-43b6-8429-eaa9563642c3.png";
export const CattleAudio = "b5e53a8c-7538-4160-a9cb-ba0cbad22a80.wav";
export const orangeImg = "469fec4c-4782-4f2a-a766-824e22f3d15d.png";
export const orangeAudio = "2f70baac-f9fd-453f-9408-8ce830fa0ccc.wav";
export const storeImg = "a28bf02a-9db0-4476-a37a-f6142f8125c0.png";
export const storeAudio = "760e3558-9412-4630-bca1-68b90af08db1.wav";
export const OfficeImg = "8d2f3faf-0317-495b-80b0-2e99a20e74e0.png";
export const OfficeAudio = "cea74e55-cb94-4f7c-a19e-25e1e648504d.wav";
export const SoftImg = "831ed3fc-ea7b-4d23-b45d-fb0cf64ab98e.png";
export const SoftAudio = "26dc7ce4-b0bf-45fa-b8a8-8c88feee8773.wav";
export const kiteImg = "66bc5712-445f-4905-832c-c5e5cf5f5cd7.png";
export const kiteAudio = "47c71f2a-a41e-4218-a2ce-0186516010ee.wav";
export const fruitsImg = "1b03f9b2-eb10-4901-92a5-b970df8b1bfb.png";
export const fruitsAudio = "0afa3ef9-acf2-438d-8258-db7518440ce3.wav";
export const GasImg = "210f2133-f8b9-40d5-b271-8592afa4102e.png";
export const GasAudio = "0947e5ff-790d-4342-b57c-54e2fae1948c.wav";
export const basketImg = "2b03f9b2-eb10-4901-92a5-b970df8b1bfb.png";
export const basketAudio = "ed327ea7-55ea-4696-9605-ef06f266e93c.wav";
export const gameImg = "cbc846fe-6335-4b0d-9248-7145a98cec49.png";
export const gameAudio = "3775d2c0-8225-49e0-bd40-9c3bb75b21de.wav";
export const CamelImg = "82bd4c2f-d7ed-42f4-9059-3a7e48b54d14.png";
export const CamelAudio = "afd35a89-6313-4d5e-8bc3-50a5b0b7292f.wav";
export const TubeImg = "dbb087f5-a68b-4269-82b8-523c8263c688.png";
export const TubeAudio = "f6f5c20c-5307-48db-afeb-7f60005e292a.wav";
export const beautifulImg = "092f1dc9-4bf5-40d4-bcfb-5f2220d95caa.png";
export const beautifulAudio = "8917d756-e072-472e-89ee-8cf314a94c98.wav";
export const featherImg = "2e6c0d15-0ec5-44bf-bb18-c7b990efbafd.png";
export const featherAudio = "04f86bab-6450-48f5-894f-9eb61a7bc49b.wav";
export const CherryImg = "6c253a9b-a6a8-4fe2-a36a-2253250a1f6d.png";
export const CherryAudio = "212c9978-9ca2-4bc8-99d4-5ec47eec4ad5.wav";
export const WaterImg = "1a58012d-b639-49dc-ae8e-5d1d8eae3229.png";
export const WaterAudio = "d3585a54-5644-4737-9156-c1ceafafab7c.wav";
export const GateImg = "ca627d4b-0aea-47ca-b232-2f5722489e8b.png";
export const GateAudio = "d68d7557-ab26-4957-8a6b-abf146f2a369.wav";
export const AllyImg = "df670417-f8b0-4fbb-b0c6-e9bb813f54c2.png";
export const AllyAudio = "399eaa70-549c-4e97-a810-f5ffe2101e3f.wav";
export const BalloonImg = "897bdc0e-d409-40ca-96cc-5c7ddaab5992.png";
export const BalloonAudio = "15524c3a-69ed-4f09-b86b-8a63b8482627.wav";
export const MenuImg = "12591afc-2bb2-4c11-945d-6203c72b9529.png";
export const MenuAudio = "17293e52-5074-4f83-9ef2-855de981783a.wav";
export const WomenImg = "7446f8d4-395e-41b1-87b2-d141326164d4.png";
export const WomenAudio = "83d5c04d-a62b-44a3-b7bb-443de7354308.wav";
export const EarthImg = "92bae697-8741-46f8-b114-93c4fa404f2d.png";
export const EarthAudio = "05d161e9-a3b3-446e-b6c1-334e507db365.wav";
export const NearImg = "56e4b75b-42c3-49cb-b7cb-499033eb8b44.png";
export const NearAudio = "760da3ad-0d9b-40e2-9f0d-37b3ae9fefcb.wav";
export const RattleImg = "0ce7bcaf-8980-489a-a92a-ebbfe5e9c43e.png";
export const RattleAudio = "0fd9c85a-d735-4ca3-a595-015df16476c7.wav";
export const decorateImg = "d4a08176-d8be-4337-ab86-fcfff4f886ca.png";
export const decorateAudio = "3ceba50e-d320-4b5b-8c4b-02f5a16e1576.wav";
export const UpsetImg = "133a4559-9e35-4880-b6df-f439a4379dd5.png";
export const UpsetAudio = "6874566d-09e6-43a2-8edd-9bd07e7ecb41.wav";
export const PuppyImg = "edbcfa77-2ed3-4441-9d5d-e32f4a8020ac.png";
export const PuppyAudio = "1527c2f4-f97c-49f5-a736-fab220a5adb7.wav";
export const BusImg = "1a6a7251-200f-441d-9725-03641a47cb39.png";
export const BusAudio = "75cd3c0a-a0a6-4bd3-bec6-3a32bc0466ef.wav";
export const DustImg = "c2eb73b4-a451-43ea-9668-731ee851513b.png";
export const DustAudio = "d57f9811-b925-448d-bba8-a54a48ddf4ad.wav";
export const JamImg = "0a5825f9-df42-4c8c-bde2-7576cb34ee8e.png";
export const JamAudio = "312dbd31-f912-4848-a3a1-22085a269013.wav";
export const Camel2Img = "82bd4c2f-d7ed-42f4-9059-3a7e48b54d14.png";
export const Camel2Audio = "07dc3a21-433f-4a84-b0a2-57538e92a353.wav";
export const ArmyImg = "00ac38e0-67ec-4014-99fb-b04382a08847.png";
export const ArmyAudio = "2f2ddc93-aed3-4357-bb1e-dc72089fe9f9.wav";
export const TummyImg = "3ab4a2a8-fef4-4c46-8e7f-ad1242bfbbd0.png";
export const TummyAudio = "1e1dd233-4e0b-4145-abea-c90220856d5c.wav";
export const SofaImg = "be707918-e350-4bca-b612-10481fd5e9df.png";
export const SofaAudio = "113eae65-eddb-419d-9a80-cf300458047e.wav";
export const PersonImg = "d210a8e5-fbe3-42f1-9ede-dd37b167457f.png";
export const PersonAudio = "4238e3ac-327f-4a3e-99d9-30a9e55fdaa5.wav";
export const NoseImg = "958321fd-dc8f-4426-93e5-2cad1cb0219d.png";
export const NoseAudio = "dfcec3d6-c8fa-4cc4-9835-760eda1659ff.wav";
export const PianoImg = "0f7391c5-230d-41eb-96d8-a7b62b387d99.png";
export const PianoAudio = "928f598e-de06-4af8-8b48-84617ed6b8e8.wav";
export const listImg = "e55a90ca-afd4-4ead-b7b1-b6a4db705aa0.png";
export const listAudio = "6ec5095f-d64c-4345-a324-b071e1d8f02f.wav";
export const fishImg = "43dca25a-8216-4b67-a092-c65c2d686252.png";
export const fishAudio = "040a8412-17cc-4acc-878e-969b3c67c5f0.wav";
export const OxenImg = "91d811f9-2337-4abf-a8fb-e7505b1b5c86.png";
export const OxenAudio = "f6c8a2b7-19d5-4a9c-a7b7-2764b2dbdb8a.wav";
export const BoxerImg = "502701e2-3146-4689-b0ee-19ab3460336f.png";
export const BoxerAudio = "5074d9a1-1dd9-4525-bd1e-869e534dffd8.wav";
export const DollImg = "902102fb-334f-4c74-8914-c700cfcd8f53.png";
export const DollAudio = "be0718c4-7081-456a-9d7c-eaa6c1670d3d.wav";
export const IndoorImg = "dc2fcff7-ca9c-4d2f-8065-7183dcd7ed88.png";
export const IndoorAudio = "3dd2a360-92f6-458d-9073-f157681f0ff0.wav";
export const GoldImg = "732879fd-b207-4573-8aa9-8f4f85f4b539.png";
export const GoldAudio = "053fda9b-2fc4-4f55-b3c9-9c6c0d32193c.wav";
export const WagonImg = "81a63303-19d5-47a9-91f6-a825fd9dbe4f.png";
export const WagonAudio = "40ecda9f-d57c-4ed5-8c2f-c2fb4daa67e0.wav";
export const oneImg = "38a307c9-bdd2-4718-8b1d-347f650a584d.png";
export const oneAudio = "c9d30710-0dff-4b40-96b4-616ef95609bb.wav";
export const tongueImg = "a34cf757-d2a2-45e3-ade0-46dece78333b.png";
export const tongueAudio = "8ef07f5f-119c-4365-a18a-13fb768fb293.wav";
export const toysImg = "f1cebc09-5e4d-4191-9db0-3d9755ace7b5.png";
export const toysAudio = "db8fd7f4-09fc-4ed2-ac6e-deb19f209947.wav";
export const store2Img = "a28bf02a-9db0-4476-a37a-f6142f8125c0.png";
export const store2Audio = "f59b30ab-1b16-4402-81d8-8415774f54e7.wav";
export const ActorImg = "85f840c5-9fc4-40b6-8247-ab7f368a2a82.png";
export const ActorAudio = "06f89005-5afa-4827-8ea4-6be0ad9e4f81.wav";
export const TractorImg = "23848e6d-2ee8-4fdb-9407-eea8b9f214c8.png";
export const TractorAudio = "aaa6eba6-6d0c-424b-84c6-d58ecda03b8e.wav";
export const AgentImg = "1277dbef-8611-495c-89f7-e8be20e8674f.png";
export const AgentAudio = "9d8aab02-808c-4a90-84b8-c467cf4f7485.wav";
export const CageImg = "7658bfaa-8f51-4aef-87f3-b28e24807fd3.png";
export const CageAudio = "7c2423c8-e11d-4e2c-8876-04068a6a9a00.wav";
export const AirportImg = "ed0345f1-fbde-428e-ba20-e068f60d7823.png";
export const AirportAudio = "7c1c1f28-e9ed-40e2-b6ef-81a5ba685d6d.wav";
export const ChairImg = "46327c04-5317-4121-a9ae-c9549eb315e3.png";
export const ChairAudio = "4568c617-5c91-4c45-bbc2-206d0e6ec562.wav";
export const Army2Img = "00ac38e0-67ec-4014-99fb-b04382a08847.png";
export const Army2Audio = "c57354bd-cd2f-4a13-b5a9-4c51c4d6b3f6.wav";
export const FarmerImg = "8a236b2b-9411-4b01-a12b-181484f8e379.png";
export const FarmerAudio = "a3a8580e-530b-4f8e-a970-3991c71cf5e9.wav";
export const ArtistImg = "a71bd3b2-d8e0-4ea0-ba2b-ef2d9bdee076.png";
export const ArtistAudio = "c01a2737-d52f-4b8d-bf8d-680a5c77f083.wav";
export const PartyImg = "1fe4cc75-fe68-4235-a234-69742b0f145b.png";
export const PartyAudio = "7fe50d97-2f7d-4f3a-b7c7-507950910877.wav";
export const AskingImg = "396400ae-78b3-49d7-ac1a-2d71570b168b.png";
export const AskingAudio = "cf5c103c-e136-43c9-b5be-569701a41fd3.wav";
export const BasketImg = "2b03f9b2-eb10-4901-92a5-b970df8b1bfb.png";
export const MaskAudio = "4b81c440-a41b-43b6-8a4d-d642a02a6058.wav";
export const BitterImg = "0adeff39-a9dc-43b3-babc-5a791da9c82c.png";
export const BitterAudio = "e9704e8b-b07c-4285-9d8b-ef9cd42f2a86.wav";
export const HabitImg = "563071b3-c473-407a-a6d4-c8f60bf0cbc6.png";
export const HabitAudio = "e668bc82-8277-439a-bfa6-669fced43b2b.wav";
export const CarrotImg = "adcee54f-6cc3-4ccf-82ef-c8fea23ea2dd.png";
export const CarrotAudio = "f7a5375e-7c22-432b-a2fa-7ff34cdfa5e9.wav";
export const ScarfImg = "87e3c422-323c-420a-be2e-f0cd4a4c2caf.png";
export const ScarfAudio = "bf0f8f0f-0698-45b7-94a3-017265e70dfa.wav";
export const FitnessImg = "347b23fd-af88-4512-b332-b3c04282c068.png";
export const FitnessAudio = "19124aa3-7a9b-4817-8c33-5e53b735b21d.wav";
export const ProfitImg = "f73e49d3-5788-4f9d-a4a5-60ff65f624c7.png";
export const ProfitAudio = "73cd8e18-4c70-4136-8908-86d1b62f7591.wav";
export const FlyingImg = "6bb5ba21-7898-45be-b058-ada11bc08e14.png";
export const FlyingAudio = "27ee0673-702d-4139-a8a4-b4d46947eae7.wav";
export const ButterflyImg = "150e039e-f991-460b-b7cb-bba519078ca3.png";
export const ButterflyAudio = "d28c63e7-3d32-481c-bada-4bd33f8a64f3.wav";
export const FunnyImg = "0ad1b89d-5f1e-4731-a3a0-686b28dfd1fa.png";
export const FunnyAudio = "54d914a6-33ab-4750-a71f-3e33e62d4e13.wav";
export const FunnelImg = "272cfb2b-173d-408f-b482-f26a1a9a04eb.png";
export const FunnelAudio = "5f2e9839-43fa-40d0-a256-f022165fa8e6.wav";
export const MiceImg = "07ac3aed-4c0f-4525-9964-523a12186e98.png";
export const MiceAudio = "b21b5e8b-d3a5-4738-9902-39e668d5328e.wav";
export const JuiceImg = "d4d17ca8-b658-4907-9ea1-2a424e24cc37.png";
export const JuiceAudio = "81c0c6bf-fc34-4fd5-9d42-47d0745a8439.wav";
export const PinkImg = "f91f20c6-b816-448a-8703-02b8e5009983.png";
export const PinkAudio = "48a382c1-8830-4689-9f52-72bdb12a80e2.wav";
export const TwinkleImg = "9cb152f7-beb6-4bf6-8178-aea01427d752.png";
export const TwinkleAudio = "0c0b38f2-40ba-466a-a7e8-f3e1682bdc6b.wav";
export const KeyboardImg = "6227bea7-0daa-4e82-832c-0782f6f8fe1d.png";
export const KeyboardAudio = "eed17a4f-5109-421f-b6b3-56bedc32b0e5.wav";
export const DonkeyImg = "9ba8c36d-b869-41bd-89dd-2fe05013d500.png";
export const DonkeyAudio = "9069a714-6e8f-4e9d-9962-885b8455a6f6.wav";
export const BatheImg = "bd62cfad-fd3c-4cff-9748-22d0809cfacb.png";
export const BatheAudio = "5a5c279b-d3ab-4de3-951a-7570cad15057.wav";
export const FatherImg = "823f8e74-b5e3-4784-91c2-ed7899e9fb46.png";
export const FatherAudio = "12b8c374-2a01-43c1-b9ec-dd02ad1d1f97.wav";
export const HandImg = "6f19009f-934d-4a7e-8500-f6258f484d27.png";
export const HandAudio = "68adaa92-8e1d-46ea-9b8a-01094dfc88b3.wav";
export const CandleImg = "b79e0596-0c2b-415a-be19-04ba265fef04.png";
export const CandleAudio = "6493451a-4efc-4130-b21e-20754c1fe0af.wav";
export const ForestImg = "0c65677f-1e51-4239-a87f-8dcb8551aaa7.png";
export const ForestAudio = "7f1da8a3-b997-4721-999f-ac8b45aa1563.wav";
export const fortImg = "3d6b4357-4782-4ca3-bcf7-6c18283d86bd.png";
export const fortAudio = "834f4236-9231-4932-b3dd-907e26d9ca99.wav";
export const hateImg = "2821e98b-6d25-41ce-b81b-134c0ce8f54d.png";
export const hateAudio = "51c5e258-7716-493c-a0e3-3d36e8fac829.wav";
export const ChatterImg = "94a58e21-efcf-420a-b2f8-7917864c1485.png";
export const ChatterAudio = "b6b26c54-276c-4068-a660-341119300a56.wav";
export const HistoryImg = "e3572e72-901b-43ab-b74f-f3b6ed0d5269.png";
export const HistoryAudio = "dd35154e-aa5c-4489-8d5d-8d60bfaa1ad3.wav";
export const WhisperImg = "65bfcaae-8b6e-4e59-ad18-f41d84ce0daa.png";
export const WhisperAudio = "873f9ac2-79fa-4f1b-89b9-1208875524b1.wav";
export const WaspImg = "576977a7-33ce-44a3-9288-14d0bc6c6571.png";
export const WaspAudio = "0763af1e-97e7-4c35-ab1c-89d1685973fc.wav";
export const WasteImg = "dfa8a4ec-5e99-41b9-8844-f7b4ad3b2403.png";
export const WasteAudio = "1d87b06e-799c-4524-b891-c8f4e41590e2.wav";
export const BoneImg = "573cd32c-d605-45ef-bce4-a3ab54b7f55b.png";
export const BoneAudio = "6a9e1aa8-cd71-4e7f-88d2-44abbe149114.wav";
export const moneyImg = "514e8121-a1b5-4046-aa8c-fad391181146.png";
export const moneyAudio = "98b7a7c6-d0a1-4af7-9f44-0f3816834990.wav";
export const colourImg = "ef5204fa-3866-415c-93f4-0aba7fb5ee47.png";
export const colourAudio = "9445517f-090d-49b4-bac7-e946a5766653.wav";
export const fourImg = "6ba357f9-fce9-406f-bb91-5ebed0afbc12.png";
export const fourAudio = "361daaf8-8158-49c0-b9f8-f6abcc258530.wav";
export const WitchImg = "70e03006-4011-479b-a93e-b9596f5acaab.png";
export const WitchAudio = "ec84d148-6f6c-4acb-8234-fca0877e35d6.wav";
export const SwitchImg = "6d8dd51c-26bb-4454-b367-81f38358496b.png";
export const SwitchAudio = "c59404e4-cc8c-48b5-b769-1101ef3469fc.wav";
export const notebookImg = "1f333d4d-7155-421a-9b2c-e533940f029b.png";
export const notebookAudio = "0cd0aaf0-3db3-4392-a04b-580669bb586c.wav";
export const noteImg = "0c248e01-d011-4f00-bb78-e536e6b59e44.png";
export const noteAudio = "261e6fa7-61e8-4692-851d-1d6abb1a7469.wav";
export const BedroomImg = "cd58f2b7-9000-4f42-9a5e-77f1151c8e2a.png";
export const BedroomAudio = "33db6783-edc1-482f-a02e-5d4d2a32dcc2.wav";
export const BedtimeImg = "c812d59f-5378-4066-b459-a185e3bfddcd.png";
export const BedtimeAudio = "71acaca0-0cd9-4bef-a53e-5cf407ffdb07.wav";
export const HideImg = "af93f980-36e9-4005-b4ff-06ab8e9f4f8c.png";
export const HideAudio = "fdc70fc8-27a9-4e4f-bf05-f2d702070209.wav";
export const childImg = "63e82d82-ca52-44ec-8e0e-a6e218a288d6.png";
export const childAudio = "8e9e3122-4746-4e3f-967d-1b5fcee0d2e4.wav";
export const MaskImage = "3c03f9b2-eb10-4901-92a5-b970df8b1bfb.png";
export const meatImg = "4fec03ee-32a0-4653-8e8f-fe43710f94fd.png";
export const meatAudio = "4fec03ee-32a0-4653-8e8f-fe43710f94fd.wav";
export const bearImg = "92d60abb-4f68-4b72-bf28-a8348e92dd61.png";
export const bearAudio = "92d60abb-4f68-4b72-bf28-a8348e92dd61.wav";
export const DateImg = "bfe01ca3-fd9f-4759-a62a-86b1e0e70ac9.png";
export const DateAudio = "bfe01ca3-fd9f-4759-a62a-86b1e0e70ac9.wav";
export const TallImg = "1a9e447a-e6be-4e6a-b357-af13e176333f.png";
export const TallAudio = "1a9e447a-e6be-4e6a-b357-af13e176333f.wav";
export const hearImg = "25c528a9-2064-481c-8118-4393a7c4381b.png";
export const hearAudio = "25c528a9-2064-481c-8118-4393a7c4381b.wav";
export const MynahImg = "a2d20f99-2bb7-4e73-989c-3110887c88d9.png";
export const MynahAudio = "a2d20f99-2bb7-4e73-989c-3110887c88d9.wav";
export const OnlineImg = "6ad9efe7-fc53-4821-bdd7-36d662188c03.png";
export const OnlineAudio = "6ad9efe7-fc53-4821-bdd7-36d662188c03.wav";
export const tomorrowImg = "bcbc03e6-08f7-4ddf-b5b0-24ff5df2eb1a.png";
export const tomorrowAudio = "bcbc03e6-08f7-4ddf-b5b0-24ff5df2eb1a.wav";
export const theifImg = "f36faf2e-943b-4ec1-b226-303d4b25945f.png";
export const theifAudio = "f36faf2e-943b-4ec1-b226-303d4b25945f.wav";
export const hatsImg = "b9a8a605-7924-40ef-a558-bc4e434401cd.png";
export const hatsAudio = "b9a8a605-7924-40ef-a558-bc4e434401cd.wav";
export const wittyImg = "236010ff-2a0e-400b-b6e0-296c92c2d1a7.png";
export const wittyAudio = "236010ff-2a0e-400b-b6e0-296c92c2d1a7.wav";
export const HindiImg = "6c12fb3f-a01f-40a5-b441-504ec1588486.png";
export const HindiAudio = "6c12fb3f-a01f-40a5-b441-504ec1588486.wav";
// export const తబలAudio = "04b8d683-8e8e-4166-a88f-be48c81cc66e.wav";
// export const బతImg = "0d7b9c70-d904-4e6f-bf5b-033fe5360931.png";
// export const బతAudio = "7666ed11-0216-4c3d-9385-f34c764a7d40.wav";
// export const లతImg = "5a8ee72e-0bda-41b9-afa3-7c941fb659c8.png";
// export const లతAudio = "9693b54e-951b-497f-9dcb-5021186ff028.wav";
// export const కజరImg = "df27fd9d-986b-4234-b71f-5d95a4ffec66.png";
// export const కజరAudio = "ff80ede9-40c3-4485-b659-80cd8e8bc426.wav";
// export const జడImg = "154e4c3a-c9a8-4476-a35a-c5dce445f994.png";
// export const జడAudio = "ae487b5c-06dd-4fb1-b0bf-f7d405ced369.wav";
// export const రవImg = "8edd2044-4933-4747-adfc-b0752e4bee34.png";
// export const రవAudio = "77b5310d-cf2a-401b-9d95-9789c9934b32.wav";
// export const ఆటImg = "3a074e2c-5fb0-44ba-9cd4-ffa7cd7b73b3.png";
// export const ఆటAudio = "4d94959f-be7a-4f87-8614-ba1821477629.wav";
// export const టమటImg = "5493860c-9c44-451c-b88e-1a95e03fa887.png";
// export const టమటAudio = "da2ca59f-65ce-4ec5-b817-9e0e45731a2a.wav";
// export const ఉగరImg = "b0fa8242-9098-4038-94e1-70bd571cf2fd.png";
// export const ఉగరAudio = "c367e8fa-c6fd-4c15-8f94-a1bc3f9bd126.wav";
// export const గదImg = "ada68044-9107-4572-8945-11f6dbc73694.png";
// export const గదAudio = "01a1d3c8-9b59-4cad-810b-5438f92c8852.wav";
// export const శనగImg = "88f5adbe-20e2-417a-9006-d930c9564e46.png";
// export const శనగAudio = "843da6b0-805c-49b0-8567-b6c0114dca43.wav";
// export const నగImg = "0b4fe26a-bda9-4ef6-af5d-e37ad9b28a74.png";
export const నగAudio = "f7219924-5772-409c-9dee-d926a61c42dc.wav";
// export const అనపImg = "662504b5-d251-4e9f-9c04-1e50c2ca1885.png";
// export const అనపAudio = "c78f2624-afd1-458b-89c0-52aa555d7807.wav";
// export const పటImg = "0943731f-a3ce-45de-85d1-0f24aa2d9e3f.png";
// export const పటAudio = "77aa5f38-b5e5-4bc5-bae9-77f3c2137581.wav";
// export const సవరImg = "7b487e52-43e6-46ae-bbd5-37b033418746.png";
// export const సవరAudio = "3999e598-c74a-4fe5-8fee-87ecbc449ad1.wav";
// export const వలImg = "94809065-da22-4985-bae1-3e98b036ece2.png";
// export const వలAudio = "c78c0397-8ed0-4849-8d3d-9d81ee95d3f0.wav";
// export const ఊయలImg = "3740866d-ca9e-4126-b304-bc427c6ff17b.png";
// export const ఊయలAudio = "4fe1f8da-7837-49aa-b141-56404bc5bdb7.wav";
// export const డబబImg = "45f17492-b03f-4b11-a60d-6340593366ae.png";
// export const డబబAudio = "dfd123c6-8e7e-47a1-93bf-0257dd0bef05.wav";
// export const దడImg = "9ad40c5c-df42-4d8a-9c2f-64ade1989d4a.png";
// export const దడAudio = "f387feeb-3a1c-4447-bb8d-2321cd71c431.wav";
// export const ఈతImg = "6c662113-7b44-41a6-8a4b-aef16ecbbcd9.png";
// export const ఈతAudio = "a058a8f8-03e7-4c2d-beb5-8683804615f3.wav";
// export const మరImg = "9f6cbd13-208b-4ff5-b700-1f092c005106.png";
// export const మరAudio = "5bdbf4a2-c0de-4e48-b645-ce192b602515.wav";
// export const చరకImg = "e3ddc30a-95ff-4c22-9b43-7f0438dff987.png";
// export const చరకAudio = "5e9060c1-b3c3-4273-a365-92d169401355.wav";
// export const ఒకImg = "8f7c89a2-4456-443c-b91e-b8b13e1c26f9.png";
// export const ఒకAudio = "46dc7de7-8d3f-4db1-aebe-49dc0dc1eb2c.wav";
// export const ఓడImg = "df41b634-9ab1-4b08-9629-e48ee75f6d3a.png";
// export const ఓడAudio = "29c008a5-eadf-4b5c-9572-01a3b2181c75.wav";
// export const ఔటImg = "0c1e4e24-82b3-4f6a-b088-f73678ab36e9.png";
// export const ఔటAudio = "72c5e7b9-6585-443e-832d-5190fd110034.wav";
// export const యదImg = "210ea014-5b8d-487a-b5ad-9ca3be44696c.png";
// export const యదAudio = "c9b6a00d-256a-4e78-aa44-6048c10ac74a.wav";
// export const ఇటకImg = "21bbe817-25e4-4a0b-b972-a662be1f2069.png";
// export const ఇటకAudio = "bfbe8854-b301-44de-a204-694ed3b82b44.wav";
// export const ఎలకImg = "3f1f4c7a-adb4-4bb6-a34d-9c53877fbd12.png";
// export const ఎలకAudio = "ae011572-8d51-4a84-872f-7ede0c76c8d8.wav";
// export const ఏనగImg = "ea2047cd-7182-43bf-9b9e-f3c835e1d647.png";
// export const ఏనగAudio = "5af76385-c2b0-41d4-92e1-016c336df5f4.wav";
// export const ఐదImg = "20e410a6-8e8a-4a9a-b78c-60c2533cbfe2.png";
// export const ఐదAudio = "01de0860-c5a6-40be-a29e-47e3455e1a8f.wav";
// export const వణImg = "f0f5cc76-5be2-4049-9a9b-4ec550c39cab.png";
// export const వణAudio = "ce24cdc6-443a-4199-bfcf-e805ad42f67b.wav";
// export const కళImg = "54abc22f-4e4f-4f65-87b1-0ba307712af1.png";
// export const కళAudio = "fca4e7f2-dd40-4ebe-8f23-5aa3b21815bc.wav";
// export const హసImg = "4b6c0c2e-f001-40ab-9e71-2aab2bd21e74.png";
// export const హసAudio = "baefaa24-6a2b-4f42-9276-cb00490df604.wav";
// export const ఖగImg = "011bf2e3-a770-43b2-82e9-9a833cb4b39b.png";
// export const ఖగAudio = "c3b7a021-9d7d-4097-9350-1d55de1eb506.wav";
// export const ఛతరమImg = "7c0b6885-face-4acc-85d6-0a4015a38f12.png";
// export const ఛతరమAudio = "e78de537-e8d3-47c0-8b35-9a46790b7bba.wav";
// export const పఠశలImg = "4ab53dd0-ae61-4a08-8014-10d18dc109cc.png";
// export const పఠశలAudio = "74143e1d-8ce5-4dd0-8c26-1d6085b27792.wav";
// export const ఢమఢమImg = "8666690d-5d3a-46fe-9b41-c12349ffedf9.png";
// export const ఢమఢమAudio = "d0fe37f3-36c3-4585-85e5-11a46a4e0ab2.wav";
// export const ఘటImg = "d4744503-0d37-42e6-8a1d-0b6dc33b9359.png";
// export const ఘటAudio = "81b4c720-8ad9-4beb-b59f-46fe50b5fe59.wav";
// export const ఝషImg = "5547a178-79fc-4abc-8994-9bfdb2a0ccae.png";
// export const ఝషAudio = "aff9bee6-f096-4ec2-90b9-d0e82d7c03dd.wav";
// export const ఋషImg = "0bac4bd4-9cd4-4f39-ae4b-dd0868ee14ab.png";
// export const ఋషAudio = "2b518e4f-64b6-4c93-b16c-79edd9d78a5c.wav";
// export const షరImg = "73e38dae-749f-43f5-af59-e13ffda93948.png";
// export const షరAudio = "91e2b388-31cb-45ec-a33f-6d29378d06b1.wav";
export const రథImg = "e0dd79d0-cf82-44e2-a73c-8693ae94eca9.png";
export const రథAudio = "ec40346b-94de-4c24-bb7a-9d56cef5f683.wav";
// export const ధనImg = "5846d600-b639-4652-a527-b5a2b5284a62.png";
// export const ధనAudio = "8e99356f-18fc-452b-a0f1-b2aad15043fb.wav";
// export const ఫలమImg = "527ae6d0-3e1f-43fd-89a9-cdedaf9e1203.png";
// export const ఫలమAudio = "a8fbbcbd-963c-45cb-870d-651f06e1d71f.wav";
// export const భజనImg = "44afbeee-76d7-447c-9696-a19cf52d627b.png";
// export const భజనAudio = "f6826ead-470b-44ce-a6d5-d00b7648790d.wav";
// export const అకషరImg = "e28dc5ea-dd79-4ab4-a0c8-2c8f303f1bb0.png";
// export const అకషరAudio = "040c2d96-32d0-4547-9036-430412116bea.wav";
// export const అగడImg = "03f39912-a715-47a5-a9c7-c51735cf0e12.png";
// export const అగడAudio = "d4535b9b-a76b-48c1-92a9-399fe8b732ea.wav";
// export const ఙImg = "gh2b8fe4-22fb-4cd7-be5c-b915a0ebb920.png";
// export const ఙAudio = "fcf6351f-1be9-4439-9a8c-fe361e11c59b.wav";
// export const ఞImg = "gh47a178-79fc-4abc-8994-9bfdb2a0ccae.png";
// export const ఞAudio = "192d6451-0507-417b-9d43-e8d95c00a7da.wav";
// export const అImg = "ghf39912-a715-47a5-a9c7-c51735cf0e12.png";
// export const అAudio = "61b80846-4aa4-40a3-88ad-3b55f8e4138b.wav";
// export const ఱపImg = "3409bc12-d115-4b26-8abc-aaeb61440a40.png";
// export const ఱపAudio = "d3343f4e-aa38-4527-9b27-782646ad76c9.wav";

export const నదిAudio = "13ada1fc-73f2-4b3b-9513-00a2978c39b5.wav";
export const చేపAudio = "c01f563f-40fa-4a47-9463-66b68f3713da.wav";
export const చీరAudio = "c4850a17-a76d-4fcf-bbbb-d529aef0ada4.wav";
export const గెలAudio = "02bb15c1-76dc-420b-839d-ac9476f85f51.wav";
export const సౌధంAudio = "74f58e5b-707a-4d9b-b1e9-60a0b58e30c5.wav";
export const గృహంAudio = "2a90bcd0-05ce-4414-bd10-dd834fc59951.wav";
export const జాతరAudio = "ee8d33cb-6933-4f96-a0d2-b0c9ed63ed29.wav";
export const గీతAudio = "48b0bd22-8bb1-4d13-ba34-40d5577d53cd.wav";
export const జైలుAudio = "68dddde9-3f35-4e95-b8ba-b15a55506549.wav";
export const కోతిAudio = "d7ae8920-c629-428c-a4bd-22c9ca4ac53d.wav";
export const నౌకAudio = "2b0c8425-cb4a-4ea0-8205-b64bb5acac9d.wav";
export const నీరుAudio = "6d7c1fa0-669c-4f76-9ab5-1772b1065690.wav";
export const పోరుAudio = "9e02d1c8-3565-4268-9944-c5ff01da7399.wav";
export const మెడAudio = "a4fe71a8-8365-4e47-aea1-d93be75f4d9b.wav";
export const టోపీAudio = "697cff90-bac4-4b83-9c28-6f31f61b4d26.wav";
export const డైరీAudio = "47d4681e-5c4e-45e3-b9fd-22d3784c68c3.wav";
export const రోకలిAudio = "2ce9a21a-1698-4128-a450-618fd407547d.wav";
export const సూదిAudio = "07cbd10b-8c5a-4a8f-8b6b-c93651214120.wav";
export const జౌళిAudio = "d5321682-efaa-4d45-9ba9-5d45af4e7630.wav";
export const సీసాAudio = "76033fef-e07d-41a8-ae0b-184294c80480.wav";
export const బంతిAudio = "e49c48bd-e18e-48b8-9b93-abc3b0aabb65.wav";
export const టౌనుAudio = "d586d2aa-6f17-4be7-b63b-50c60dc48c29.wav";
export const పులిAudio = "f895b460-ab54-44e6-9944-1c51026ab20a.wav";
export const తేనెAudio = "62381190-fdaa-4e94-add5-9623786b2c7a.wav";
export const పశువుAudio = "f6db88fa-8550-42b2-b9f2-a02762b42372.wav";
export const బూడిదAudio = "79268c28-73cd-47c6-9696-db50f370285c.wav";
export const ప్రకృతిAudio = "ec4e5d42-1e29-451d-af66-d6b1937534ef.wav";
export const మైదాకుAudio = "b09c3bf4-1c5a-48a3-b1ad-08979b7724d2.wav";
export const నొసలుAudio = "3a9a743a-b356-41a3-950f-9382e41538ac.wav";
export const పొదుపుAudio = "b60fba9b-eea5-49d4-8fc0-f6a608c7a484.wav";
export const జెండాAudio = "7e211d3f-6a4b-4675-bd25-8db396daf712.wav";
export const పెరుగుAudio = "3c65368b-710e-4fb2-be4c-89f753d128d7.wav";
export const భూకంపంAudio = "59f584f2-a8bf-44f4-8127-3c3552e4a8aa.wav";
export const పావురంAudio = "35a11d4a-14b7-4cf2-bdb1-61ce463785e7.wav";
export const జూకాలుAudio = "d2a5a7ea-8281-4b85-b33f-dc74fb175f50.wav";
export const పసిడిAudio = "afe77542-56a8-41b3-a190-e897921a3d10.wav";
export const గాజులుAudio = "7563a7b3-ca9e-48ef-b553-5b8e4695b508.wav";
export const నృపతిAudio = "7b1f8b81-73a9-4ee5-9dd3-958e4f63a452.wav";
export const పైసలుAudio = "f1ed9e0d-dd44-42f3-a56a-107ab575db85.wav";
export const మొసలిAudio = "bba2b47b-3995-4844-ace1-c288867ea633.wav";
export const సినిమాAudio = "317b1e07-c8d6-4532-a43c-f0062824317a.wav";
export const వివాహంAudio = "f21c39f0-042d-41a1-9d09-a106db041aff.wav";
export const మూకుడుAudio = "9f016c82-e817-4a7b-9ee8-3f1fd88f456b.wav";
export const హృదయంAudio = "849bd3fe-6fe0-426b-996d-d18d2b9f51ec.wav";
export const బేడీలుAudio = "de277fba-36dc-4e88-b2ed-fea403bf40c4.wav";
export const శైశవంAudio = "e1dbc5f9-4f4b-4473-bd1c-896544899f1a.wav";
export const గొడుగుAudio = "c9c3c729-81b1-4ab7-a2a0-db648c3d8052.wav";
export const పొడవైనAudio = "4e8988d8-608a-4948-ae99-51a4b1681579.wav";
export const సొరకాయAudio = "d05b1035-b9a9-4938-a235-4a4b3f67e1c1.wav";
export const జలపాతంAudio = "ee546cde-72a2-4eee-be7c-1f1749ef6968.wav";
export const గిజిగాడుAudio = "a4c31fa9-1a74-46e0-9ced-7a060eb8c3c2.wav";
export const ఊరేగింపుAudio = "114cc112-f63e-481d-b9db-3c0c9da8128e.wav";
export const లేగదూడAudio = "3faace13-3ed9-41fd-a46f-fdb819cfba9f.wav";
export const గులాబీలుAudio = "14d9b772-9698-40a9-8896-47e6a5f10696.wav";
export const మీగడAudio = "714c8de9-a95d-4302-b33a-d82e7b38cccd.wav";
export const చీపురుAudio = "aa851c28-e659-4203-a0b3-a4fa381b296b.wav";
export const రెండుAudio = "3228b0a1-472a-425c-b06b-e7d4db30f562.wav";
export const మేఘంAudio = "c60ffb59-f8e7-49c7-ba4c-522791884c31.wav";
export const నేలAudio = "063c311a-1b64-452d-81d6-58dcbd21e468.wav";
export const బృందంAudio = "e56c1f68-cf21-43a2-8fd5-9ca606d688a5.wav";

export const తబలImg = "e38c69f3-1f80-4e8c-b741-31f0c322b237.png";
export const తబలAudio = "04b8d683-8e8e-4166-a88f-be48c81cc66e.wav";
export const జతరImg = "231df0c7-e05c-4998-a9de-fabc748edc4d.png";
export const జతరAudio = "911309e1-4cd1-4fc8-b83e-d6e9ccc847f3.wav";
export const ఈతImg = "9b8e1871-2287-47cf-92e2-6cb1e3c9be90.png";
export const ఈతAudio = "a058a8f8-03e7-4c2d-beb5-8683804615f3.wav";
export const బతImg = "0d7b9c70-d904-4e6f-bf5b-033fe5360931.png";
export const బతAudio = "7666ed11-0216-4c3d-9385-f34c764a7d40.wav";
export const తబల2Img = "e38c69f3-1f80-4e8c-b741-31f0c322b237.png";
export const తబల2Audio = "04b8d683-8e8e-4166-a88f-be48c81cc66e.wav";
export const లబలబImg = "8e1b6b50-3529-4cdd-b9ab-e44edd76ab33.png";
export const లబలబAudio = "8e1b6b50-3529-4cdd-b9ab-e44edd76ab33.wav";
export const లతImg = "5a8ee72e-0bda-41b9-afa3-7c941fb659c8.png";
export const లతAudio = "9693b54e-951b-497f-9dcb-5021186ff028.wav";
export const బలపImg = "71f293f8-c6ff-425b-b4a1-9ed833b8f49d.png";
export const బలపAudio = "e4abbe9c-71c4-47c2-8f8d-0af6b4400f32.wav";
export const వలImg = "d1d8ca66-57b7-4a59-876f-37efd68a80e6.png";
export const వలAudio = "f575c317-ce19-4408-b1e7-3d5bbc6bd5fa.wav";
export const కజరImg = "df27fd9d-986b-4234-b71f-5d95a4ffec66.png";
export const కజరAudio = "ff80ede9-40c3-4485-b659-80cd8e8bc426.wav";
export const ఆకలImg = "d6f92441-3e85-4703-a575-0fee44169555.png";
export const ఆకలAudio = "9ff28a44-7aba-4b42-9078-3fe00384055a.wav";
export const చలకImg = "79d75593-297d-4400-86e8-e44c7a81a10e.png";
export const చలకAudio = "6f210734-af31-43a2-a3c0-ea90005f4d8e.wav";
export const జడImg = "154e4c3a-c9a8-4476-a35a-c5dce445f994.png";
export const జడAudio = "ae487b5c-06dd-4fb1-b0bf-f7d405ced369.wav";
export const కజర2Img = "df27fd9d-986b-4234-b71f-5d95a4ffec66.png";
export const కజర2Audio = "ff80ede9-40c3-4485-b659-80cd8e8bc426.wav";
export const జలజImg = "00921181-9e17-48c5-81f9-5820464c3a39.png";
export const జలజAudio = "aa05c392-13ef-4745-9c92-66fd42d65ea8.wav";
export const రవImg = "8edd2044-4933-4747-adfc-b0752e4bee34.png";
export const రవAudio = "77b5310d-cf2a-401b-9d95-9789c9934b32.wav";
export const గరకImg = "27250993-9572-433c-afbf-9ac29487da07.png";
export const గరకAudio = "a6013a2d-a00a-4922-9658-acd22c8c5e73.wav";
export const చరImg = "531dcfe5-9a66-4a55-81a3-a4bd01b6c676.png";
export const చరAudio = "93e24968-438b-4e30-897d-5e477f7eb00e.wav";
export const ఆటImg = "3a074e2c-5fb0-44ba-9cd4-ffa7cd7b73b3.png";
export const ఆటAudio = "4d94959f-be7a-4f87-8614-ba1821477629.wav";
export const టమటImg = "5493860c-9c44-451c-b88e-1a95e03fa887.png";
export const టమటAudio = "da2ca59f-65ce-4ec5-b817-9e0e45731a2a.wav";
export const నటకImg = "d698f429-3a79-417c-9ec5-1f73aa3c565e.png";
export const నటకAudio = "74d13a29-e173-4e34-bedb-2a660eb99d81.wav";
export const తటImg = "4655629d-44de-4735-b087-53ad7b280f04.png";
export const తటAudio = "c24dc08d-43cd-4064-84d7-754132366faa.wav";
export const ఉగరImg = "b0fa8242-9098-4038-94e1-70bd571cf2fd.png";
export const ఉగరAudio = "c367e8fa-c6fd-4c15-8f94-a1bc3f9bd126.wav";
export const గదImg = "ada68044-9107-4572-8945-11f6dbc73694.png";
export const గదAudio = "01a1d3c8-9b59-4cad-810b-5438f92c8852.wav";
export const ఉగర2Img = "b0fa8242-9098-4038-94e1-70bd571cf2fd.png";
export const ఉగర2Audio = "c367e8fa-c6fd-4c15-8f94-a1bc3f9bd126.wav";
export const పడగImg = "d10f0f87-85af-4b8c-b32a-eaecf758409b.png";
export const పడగAudio = "0a7d5de2-7a96-4c09-8371-ceeaea9540f4.wav";
export const శనగImg = "88f5adbe-20e2-417a-9006-d930c9564e46.png";
export const శనగAudio = "843da6b0-805c-49b0-8567-b6c0114dca43.wav";
export const దశమImg = "1ab95c3e-c13f-4bfa-a85e-7197b99d5232.png";
export const దశమAudio = "4291e68d-dc61-464d-b408-1ee1afbfb04c.wav";
export const దశImg = "1f5a93f4-9fff-4ac1-bd26-02f7eb14160b.png";
export const దశAudio = "b5a1b08f-84e1-4fdb-893f-05cb55bf30d0.wav";
export const అనపImg = "662504b5-d251-4e9f-9c04-1e50c2ca1885.png";
export const అనపAudio = "c78f2624-afd1-458b-89c0-52aa555d7807.wav";
export const పటImg = "0943731f-a3ce-45de-85d1-0f24aa2d9e3f.png";
export const పటAudio = "77aa5f38-b5e5-4bc5-bae9-77f3c2137581.wav";
export const చపలImg = "05834478-6557-46e2-a293-0b48060bc9d2.png";
export const చపలAudio = "8520d6ac-c3ed-43be-aa67-c441bc2c9ae1.wav";
export const పపImg = "4c529422-5080-48a9-87a5-ad0c256905c2.png";
export const పపAudio = "a0842b11-e9c3-4839-8474-01230453d733.wav";
export const సవరImg = "7b487e52-43e6-46ae-bbd5-37b033418746.png";
export const సవరAudio = "3999e598-c74a-4fe5-8fee-87ecbc449ad1.wav";
export const దసరImg = "0239ec34-f026-4371-9f25-0da1a681a063.png";
export const దసరAudio = "7003a15d-f213-46c6-8096-9344bd859b59.wav";
export const పనసImg = "62215cea-0812-436f-9a85-8ec8e519bd27.png";
export const పనసAudio = "1fdf2d1c-1d00-46df-a382-bbb35e293f8a.wav";
export const వల2Img = "94809065-da22-4985-bae1-3e98b036ece2.png";
export const వల2Audio = "c78c0397-8ed0-4849-8d3d-9d81ee95d3f0.wav";
export const లవణImg = "f3ccef59-a956-44fc-9bbd-171a9f9ab5ab.png";
export const లవణAudio = "4ec1d5af-6f60-4188-892b-ba8ecc6e7261.wav";
export const పడవImg = "3873fb75-22e8-4a8e-b2f9-9999e0f668cc.png";
export const పడవAudio = "a53f4223-8195-4771-a89e-6281e2128737.wav";
export const ఊయలImg = "3740866d-ca9e-4126-b304-bc427c6ff17b.png";
export const ఊయలAudio = "4fe1f8da-7837-49aa-b141-56404bc5bdb7.wav";
export const డబబImg = "45f17492-b03f-4b11-a60d-6340593366ae.png";
export const డబబAudio = "dfd123c6-8e7e-47a1-93bf-0257dd0bef05.wav";
export const అడవImg = "54f10a3f-6e4c-4100-994c-acd74ba429e4.png";
export const అడవAudio = "6ff2781d-bb1b-47c2-aab3-e0c43ba040f0.wav";
export const బడImg = "44ffe770-bb22-4df3-a329-3edb818514fa.png";
export const బడAudio = "43340597-0679-49f7-a484-08d7fcc41401.wav";
export const దడImg = "9ad40c5c-df42-4d8a-9c2f-64ade1989d4a.png";
export const దడAudio = "f387feeb-3a1c-4447-bb8d-2321cd71c431.wav";
export const ఉదయImg = "0aa4c88d-5c2a-4ea0-ac0f-818700da3c1c.png";
export const ఉదయAudio = "139befbc-9b7b-42a8-870c-5633c52cb985.wav";
export const వందImg = "b4502f9e-667c-496d-90f0-6297c0bba0b9.png";
export const వందAudio = "bb55f698-32cf-4610-a4f3-e6e9280a89e9.wav";
export const కదImg = "a4502f9e-667c-496d-90f0-6297c0bba0b8.png";
export const కదAudio = "6b55f698-32cf-4610-a4f3-e6e9280a89e0.wav";
export const ఈత2Img = "9b8e1871-2287-47cf-92e2-6cb1e3c9be90.png";
export const ఈత2Audio = "a058a8f8-03e7-4c2d-beb5-8683804615f3.wav";
export const మరImg = "9f6cbd13-208b-4ff5-b700-1f092c005106.png";
export const మరAudio = "5bdbf4a2-c0de-4e48-b645-ce192b602515.wav";
export const నమలImg = "77a8e153-ce5e-49d9-80d9-a545aa84f340.png";
export const నమలAudio = "6b9f685d-0601-4e8e-abc4-55928376dcb0.wav";
export const చమImg = "3932069c-0965-4245-95cc-d99e7fb2cc97.png";
export const చమAudio = "df51b22d-3e7c-4105-a2ed-194c81ed287e.wav";
export const చరకImg = "e3ddc30a-95ff-4c22-9b43-7f0438dff987.png";
export const చరకAudio = "5e9060c1-b3c3-4273-a365-92d169401355.wav";
export const రచనImg = "6d1ffc8e-aaac-483c-a536-f55acb4adfa6.png";
export const రచనAudio = "9beaa785-4b92-4d17-a20b-3937b70211c9.wav";
export const కచకచImg = "5dda46e7-fdb3-4c83-97f1-68d000ffb27a.png";
export const కచకచAudio = "d601b1ba-5b28-4aaf-b04f-5aff2d6de1b6.wav";
export const ఒకImg = "8f7c89a2-4456-443c-b91e-b8b13e1c26f9.png";
export const ఒకAudio = "46dc7de7-8d3f-4db1-aebe-49dc0dc1eb2c.wav";
export const ఓడImg = "df41b634-9ab1-4b08-9629-e48ee75f6d3a.png";
export const ఓడAudio = "29c008a5-eadf-4b5c-9572-01a3b2181c75.wav";
export const ఔటImg = "0c1e4e24-82b3-4f6a-b088-f73678ab36e9.png";
export const ఔటAudio = "72c5e7b9-6585-443e-832d-5190fd110034.wav";
export const యదImg = "210ea014-5b8d-487a-b5ad-9ca3be44696c.png";
export const యదAudio = "c9b6a00d-256a-4e78-aa44-6048c10ac74a.wav";
export const కయలImg = "f701ab2c-60d2-40e9-a6cf-3282a119d7e2.png";
export const కయలAudio = "d5e92c6f-d35f-4ead-9f3e-d81c66b2ea6d.wav";
export const వకయImg = "8c7a8489-fed9-46fa-8918-100a2b79ce04.png";
export const వకయAudio = "e114d220-1a5b-4bfa-99a1-c4bed7a16cc4.wav";
export const ఇటకImg = "21bbe817-25e4-4a0b-b972-a662be1f2069.png";
export const ఇటకAudio = "bfbe8854-b301-44de-a204-694ed3b82b44.wav";
export const ఎలకImg = "3f1f4c7a-adb4-4bb6-a34d-9c53877fbd12.png";
export const ఎలకAudio = "ae011572-8d51-4a84-872f-7ede0c76c8d8.wav";
export const ఏనగImg = "ea2047cd-7182-43bf-9b9e-f3c835e1d647.png";
export const ఏనగAudio = "5af76385-c2b0-41d4-92e1-016c336df5f4.wav";
export const ఐదImg = "20e410a6-8e8a-4a9a-b78c-60c2533cbfe2.png";
export const ఐదAudio = "01de0860-c5a6-40be-a29e-47e3455e1a8f.wav";
export const గణపతImg = "31cb0c92-cc43-4e99-9829-d96f750f86a6.png";
export const గణపతAudio = "609f73f4-12a8-4b79-b7f8-cc48c1994a35.wav";
export const వణImg = "f0f5cc76-5be2-4049-9a9b-4ec550c39cab.png";
export const వణAudio = "ce24cdc6-443a-4199-bfcf-e805ad42f67b.wav";
export const తళImg = "60e26e2e-d54a-49c8-9926-f4bcf834df73.png";
export const తళAudio = "d5bd4f58-d6f8-4833-a4d5-aa2aa08911b1.wav";
export const కళImg = "54abc22f-4e4f-4f65-87b1-0ba307712af1.png";
export const కళAudio = "fca4e7f2-dd40-4ebe-8f23-5aa3b21815bc.wav";
export const హసImg = "4b6c0c2e-f001-40ab-9e71-2aab2bd21e74.png";
export const హసAudio = "baefaa24-6a2b-4f42-9276-cb00490df604.wav";
export const వహనImg = "8189c5d2-64ad-4f4f-b948-10f089d05908.png";
export const వహనAudio = "b479fa5d-e493-445e-904b-a229779c9c7a.wav";
export const గహImg = "a7e78c04-3585-4dec-ae88-5e28c50ba39f.png";
export const గహAudio = "cb899386-7a26-49a1-9ef1-d56ba8b20baf.wav";
export const ఖగImg = "011bf2e3-a770-43b2-82e9-9a833cb4b39b.png";
export const ఖగAudio = "c3b7a021-9d7d-4097-9350-1d55de1eb506.wav";
export const మఖమImg = "a86e3308-6d3d-42bd-accc-8cb0f7ecc342.png";
export const మఖమAudio = "a86e3308-6d3d-42bd-accc-8cb0f7ecc342.wav";
export const శఖImg = "d1337b53-a8b3-4da5-a7cb-6ba462c83b89.png";
export const శఖAudio = "d1337b53-a8b3-4da5-a7cb-6ba462c83b89.wav";
export const ఛతరమImg = "7c0b6885-face-4acc-85d6-0a4015a38f12.png";
export const ఛతరమAudio = "e78de537-e8d3-47c0-8b35-9a46790b7bba.wav";
export const పఛImg = "58e17a2c-3b52-4819-8f99-0435c4d680cc.png";
export const పఛAudio = "58e17a2c-3b52-4819-8f99-0435c4d680cc.wav";
export const పఠశలImg = "4ab53dd0-ae61-4a08-8014-10d18dc109cc.png";
export const పఠశలAudio = "74143e1d-8ce5-4dd0-8c26-1d6085b27792.wav";
export const పఠImg = "b7bdd811-c183-48bc-8a53-00459afc3f28.png";
export const పఠAudio = "d5a86f1d-6f42-460b-8a33-c6daa6b6b94c.wav";
export const ఢమఢమImg = "8666690d-5d3a-46fe-9b41-c12349ffedf9.png";
export const ఢమఢమAudio = "d0fe37f3-36c3-4585-85e5-11a46a4e0ab2.wav";
export const ఘటImg = "d4744503-0d37-42e6-8a1d-0b6dc33b9359.png";
export const ఘటAudio = "81b4c720-8ad9-4beb-b59f-46fe50b5fe59.wav";
export const సఘటనImg = "0bd91a61-19a5-4adc-8f05-66d0ae1f3b7f.png";
export const సఘటనAudio = "0bd91a61-19a5-4adc-8f05-66d0ae1f3b7f.wav";
export const మఘImg = "b92b8fe4-22fb-4cd7-be5c-b915a0ebb920.png";
export const మఘAudio = "bccfb6f7-a546-480a-991e-02f09c9b750b.wav";
export const ఝషImg = "5547a178-79fc-4abc-8994-9bfdb2a0ccae.png";
export const ఝషAudio = "aff9bee6-f096-4ec2-90b9-d0e82d7c03dd.wav";
export const ఋషImg = "0bac4bd4-9cd4-4f39-ae4b-dd0868ee14ab.png";
export const ఋషAudio = "2b518e4f-64b6-4c93-b16c-79edd9d78a5c.wav";
export const షరImg = "73e38dae-749f-43f5-af59-e13ffda93948.png";
export const షరAudio = "91e2b388-31cb-45ec-a33f-6d29378d06b1.wav";
export const వషమImg = "2c4dec6e-0076-42b7-a62f-14680bfef435.png";
export const వషమAudio = "2c4dec6e-0076-42b7-a62f-14680bfef435.wav";
export const ఉషImg = "0a8c4eca-a048-4366-a0d7-b6fe9f0fac95.png";
export const ఉషAudio = "d64eb2bb-88a0-4bc2-8a93-6f6bb6ba403e.wav";
export const థరమసImg = "77bc4b3b-7ae1-40e9-8dc5-41fd087fe646.png";
export const థరమసAudio = "00c3ff1c-6e11-449f-947a-f65f3782d427.wav";
export const రథమImg = "a75914d0-8d88-40ef-96f7-0a75d3e32829.png";
export const రథమAudio = "c2ed2944-a3dd-4d76-85c1-464475c6f552.wav";
export const కథImg = "d9a30014-b116-4841-9985-2af591960b03.png";
export const కథAudio = "135b7137-e1f3-4dd8-b6c2-2e78cb4bd41b.wav";
export const ధనImg = "5846d600-b639-4652-a527-b5a2b5284a62.png";
export const ధనAudio = "8e99356f-18fc-452b-a0f1-b2aad15043fb.wav";
export const కరధమImg = "17bf3e49-2e72-411e-9a02-8721fffc98dd.png";
export const కరధమAudio = "17bf3e49-2e72-411e-9a02-8721fffc98dd.wav";
export const బధImg = "896726de-0691-44fd-94cc-bcde77c39436.png";
export const బధAudio = "0b739b4d-df63-4d68-ad92-9aa45dedbc18.wav";
export const ఫలమImg = "527ae6d0-3e1f-43fd-89a9-cdedaf9e1203.png";
export const ఫలమAudio = "a8fbbcbd-963c-45cb-870d-651f06e1d71f.wav";
export const టలఫనImg = "52f46996-7c3c-4dfc-b1d8-4658ea169e14.png";
export const టలఫనAudio = "52f46996-7c3c-4dfc-b1d8-4658ea169e14.wav";
export const సతఫలImg = "a66dd526-5c70-4f1f-9628-4c40a4a2031a.png";
export const సతఫలAudio = "a66dd526-5c70-4f1f-9628-4c40a4a2031a.wav";
export const భజనImg = "44afbeee-76d7-447c-9696-a19cf52d627b.png";
export const భజనAudio = "f6826ead-470b-44ce-a6d5-d00b7648790d.wav";
export const సభImg = "359efe98-8ca8-443d-bf0e-49eed9582fe6.png";
export const సభAudio = "2e8b9e35-f258-4a5e-afa5-15501c757983.wav";
export const కషతరయడImg = "cd42799d-4dd6-499f-8385-245cd5958b2e.png";
export const కషతరయడAudio = "476a3055-e38e-4b17-9f3d-d46bcd4dc98f.wav";
export const అకషరImg = "e28dc5ea-dd79-4ab4-a0c8-2c8f303f1bb0.png";
export const అకషరAudio = "040c2d96-32d0-4547-9036-430412116bea.wav";
export const పరకషImg = "a17f9270-338b-4e65-8719-dff0835eea32.png";
export const పరకషAudio = "6417ff08-1b13-452f-a983-ff4f8ec664ee.wav";
export const అగడImg = "03f39912-a715-47a5-a9c7-c51735cf0e12.png";
export const అగడAudio = "d4535b9b-a76b-48c1-92a9-399fe8b732ea.wav";
export const ఙImg = "gh2b8fe4-22fb-4cd7-be5c-b915a0ebb920.png";
export const ఙAudio = "fcf6351f-1be9-4439-9a8c-fe361e11c59b.wav";
export const ఞImg = "gh47a178-79fc-4abc-8994-9bfdb2a0ccae.png";
export const ఞAudio = "192d6451-0507-417b-9d43-e8d95c00a7da.wav";
export const అImg = "ghf39912-a715-47a5-a9c7-c51735cf0e12.png";
export const అAudio = "61b80846-4aa4-40a3-88ad-3b55f8e4138b.wav";
export const ఱపImg = "3409bc12-d115-4b26-8abc-aaeb61440a40.png";
export const ఱపAudio = "d3343f4e-aa38-4527-9b27-782646ad76c9.wav";
export const యమImg = "f424949b-990b-4928-be99-609cc77f690a.png";
export const యయమAudio = "f424949b-990b-4928-be99-609cc77f690a.wav";
export const గంపAudio = "2hf3h5t-08c8-4d51-b0ab-fhn2944093f2.wav";
export const గంపImg = "2hf3h5t-08c8-4d51-b0ab-fhn2944093f2.png";
//  English Alphabatic chart audio files

// E
export const EForEggAudio = "2515eeba-9012-4d1c-83e3-c081358bb6ae.wav";
export const EForPenAudio = "c39139dc-3a32-4d27-a1ef-37bb4fa7f54c.wav";
export const EForKiteAudio = "747d91c8-cbb2-4fb6-9e6d-81f9ff91a6a0.wav";

// A
export const AForAppleAudio = "f598d102-13f3-46a0-b9af-3e622abad375.wav";
export const AForCatAudio = "05fc4e45-2244-4082-bf7d-c0d80e26f56b.wav";
export const AForPeaAudio = "322e3e1d-44a1-44c3-9b88-23716af32fdc.wav";

// O
export const OForOrangeAudio = "82e7fc3b-3f32-411e-854d-9ccdf815d5b4.wav";
export const OForDogAudio = "77b3dd1d-a821-46f1-81c0-01c97982b77a.wav";
export const OForMangoAudio = "35a6443f-d246-4a96-b48f-dbd799ddf830.wav";

// I
export const IForIceAudio = "5a0c39a3-72c3-42da-b273-da45d080c59b.wav";
export const IForPigAudio = "a0b9f40b-10fc-43d2-9c8f-fafe1e710107.wav";
export const IForChillyAudio = "fc9e55e0-6e26-42e6-acac-ad61ed20c6fe.wav";

// U
export const UForUmbrellaAudio = "611404ee-c235-432c-8f65-fad121aec7c9.wav";
export const UForDustbinAudio = "93e68509-5a29-4df3-9c75-e02b65ac4814.wav";
export const UForLadduAudio = "58984ac8-21ec-45e8-a1ba-57cb6034ab0e.wav";

// T
export const TForTigerAudio = "a3724ed0-e3fb-4010-ac25-f8fbd62006cf.wav";
export const TForWatchAudio = "df661acd-4d6e-4ed6-952b-a81611718a0e.wav";
export const TForPlantAudio = "6be9dc9a-99b2-4a5a-8811-8246b6bb3df7.wav";

// N
export const NForNestAudio = "2164c504-199e-4667-b31a-8c22bba8ddb4.wav";
export const NForHoneyAudio = "a9eae2c0-7120-488c-9590-b578e1ba59a1.wav";
export const NForPenAudio = "2c0e1f0c-6029-47c2-ba65-07b742bcc2e8.wav";

// S
export const SForSunAudio = "42e2449b-b6d5-4e9b-b8c4-8607fc494465.wav";
export const SForHorseAudio = "ab753059-da16-4304-929e-127ede9523d3.wav";
export const SForBusAudio = "35eeef2a-9e4d-4349-8e49-80b8b755d2ed.wav";

// R
export const RForRatAudio = "14bea4de-4c59-4e6d-939e-3bbd46c7543e.wav";
export const RForCarrotAudio = "7f9a95cc-c5f1-4260-821c-b3bdd25964c3.wav";
export const RForCarAudio = "9d9e46ef-1ac2-4c26-9f33-382fb497d0c0.wav";

// H
export const HForHandAudio = "0aaad6e1-194a-4508-b592-acd973fb1b76.wav";
export const HForTeacherAudio = "d9f37c5b-5a06-4d7e-b12e-ea8243f3a544.wav";
export const HForEarthAudio = "dc5bcdf2-fdb1-466f-bf4d-0745098ef9c4.wav";

// L
export const LForLionAudio = "0239daaf-cd3f-46ae-9662-67649fd916a4.wav";
export const LForBalloonAudio = "c944813f-2e4f-4b9b-b1c6-29232a473805.wav";
export const LForBellAudio = "e8fc724a-9249-496f-a6cc-bd2363110932.wav";

// D
export const DForDogAudio = "da47db39-90e3-45e5-b351-601f6be408ef.wav";
export const DForWindowAudio = "c2dff408-acdc-4ddc-9177-5c3f5296847d.wav";
export const DForSwordAudio = "8ea22cdf-c810-459b-bbce-a15084a8c68d.wav";

// C
export const CForCatAudio = "6b28371e-81dd-41c2-a2c9-34c53c2fb925.wav";
export const CForIceAudio = "6066c331-0946-4661-ad62-8ff674f083d4.wav";
export const CForGarlicAudio = "a3023315-cbe4-4575-885a-467dd75490db.wav";

// M
export const MForMangoAudio = "be8dfa70-7bcf-4fd1-b1cc-043c74bda0e4.wav";
export const MForLemonAudio = "904c2791-c283-4e4d-99cf-523dd51479e9.wav";
export const MForJamAudio = "d0394475-6b44-459e-a54f-74e8b8c30d07.wav";

// F
export const FForFishAudio = "132fd81a-dbae-4d0f-a71c-d2a0fb29cbb7.wav";
export const FForGiraffeAudio = "6a368f3f-c8a6-4a63-8063-b824d4283850.wav";
export const FForLeafAudio = "1f65b4a9-04ca-4bbd-bbc3-841e7a14a7c5.wav";

// Y
export const YForYakAudio = "36df248f-7dc3-48f3-9598-de01a6adabb4.wav";
export const YForPapayaAudio = "950fe741-cd71-4d63-b177-2ed536d4736a.wav";
export const YForKeyAudio = "4f9be1ef-1a6a-453e-a5fc-fd9971cb09a9.wav";

// W
export const WForWindowAudio = "770c780f-0d05-421b-ae8c-984ba2835d61.wav";
export const WForSwordAudio = "fe103524-86fd-4275-8327-2ef665f9d726.wav";
export const WForCrowAudio = "57ec12a1-4d4b-4f3d-a1a8-93443912bbe4.wav";

// G
export const GForGoatAudio = "76cf4677-9c49-466d-b061-e6f9d400cc5f.wav";
export const GForTigerAudio = "dcf7fdb5-b0b9-4a3c-b3cb-f1bd0d0023b0.wav";
export const GForDogAudio = "bd62dd6b-93c6-41b8-a6c1-e529bc12b4f1.wav";

// P
export const PForPenAudio = "328d8995-7570-4784-b4a3-ffc5370e43ac.wav";
export const PForAppleAudio = "f28531ae-e205-43f9-8e40-782ef12b578c.wav";
export const PForCapAudio = "65d8044a-b04c-40c9-9240-8d42bc546d0d.wav";

// B
export const BForBallAudio = "8599da32-cf7c-4cd7-9aac-300835857e29.wav";
export const BForZebraAudio = "4b4dddba-908e-4e0f-850b-07d4dd88e21c.wav";
export const BForCubAudio = "3389299b-3896-454b-b840-97818fc6128f.wav";

// V
export const VForVanAudio = "cc0986f6-80e7-4ddc-a814-9320bbf95e72.wav";
export const VForGuavaAudio = "3f1c5922-69a9-4731-b43a-9d081c8a0e97.wav";

// K
export const KForKiteAudio = "8dd0951c-1567-412a-8afe-3a6d6199283d.wav";
export const KForMonkeyAudio = "b993bc8d-7cf5-43e3-bf39-4c3c06d2cb1a.wav";
export const KForBookAudio = "0d3a57dd-f12c-489d-b6e9-a98b952e556b.wav";

// J
export const JForJamAudio = "995c4bbf-19b4-4545-a895-3cf199aa51a4.wav";
export const JForBrinjalAudio = "b60fa907-b2ff-4fec-a28f-ae4b9e108019.wav";

// X
export const XForXrayAudio = "e0ed8bbb-0019-4b80-80f1-40ddae155a08.wav";
export const XForTextbookAudio = "2ea194d0-62fe-4e7b-84eb-247bce877cb6.wav";
export const XForFoxAudio = "95a6b44b-ccd6-42d2-bf21-ba1bc8a94ddc.wav";

// Q
export const QForQueenAudio = "e4d5fa29-8864-4832-82bb-a9c4455e0848.wav";
export const QForMosquitoAudio = "0f1b513a-c2e7-48c0-8dae-e0df411e41d4.wav";

// Z
export const ZForZebraAudio = "e35c3798-85b2-430e-937f-c72e9f2ce0b9.wav";
export const ZForPuzzleAudio = "c1ee2575-7104-4be8-95fb-54e8da24c79d.wav";
export const ZForQuizAudio = "7d17e2a7-78db-4f3c-9b8b-218741a72e8b.wav";

//  Telugu Alphabatic chart audio files

// త
export const తతబలAudio = "e368570e-4d17-4a10-9d1a-d094d469aa3e.wav";
export const తజాతరAudio = "c4b0b3af-6531-4a86-b933-0ba16fdc910c.wav";
export const తఈతAudio = "06c36389-30f6-469e-8e37-500838acaa8d.wav";

// బ
export const బబంతిAudio = "804083e2-2359-4fb2-a3c3-83a51230d338.wav";
export const బతబలAudio = "34730d9a-6d45-4080-9c54-9aa75c460de0.wav";
export const బలబలబAudio = "32049957-1ab4-4bf1-b4e2-4155a70736ca.wav";

// ల
export const లలతAudio = "6bc0d5e5-64a1-4e4f-be7e-0a7195ccbb3c.wav";
export const లబలపంAudio = "38b1ed47-5e45-4889-abfe-3b5cc73b9e0c.wav";
export const లవెలAudio = "8ffd036d-38ef-4281-a0e0-df7c496a7ae2.wav";

// క
export const కకంజరAudio = "6d3c0397-c8e5-46e9-914d-b022a7c2d91d.wav";
export const కఆకలిAudio = "8bf3c14a-98a5-4408-9a6e-eee8d50c1abb.wav";
export const కచిలుకAudio = "f3fd2ed0-dd49-4eb5-b992-e143308a5c79.wav";

// జ
export const జజడAudio = "5dd0c5a4-1e23-459c-b0f2-081d119a832c.wav";
export const జకంజరAudio = "cb66ba1a-e92b-4efe-beec-e6d05200e2c8.wav";
export const జజలజAudio = "da40489a-26a7-4714-96a5-398bf8a9ae1c.wav";

// ర
export const రరవిAudio = "cee98aad-7e7d-4aa6-ba7a-94c7aebcede0.wav";
export const రగిరకAudio = "93db15d3-01e1-4d6a-9ea6-db24eb188ca4.wav";
export const రచీరAudio = "d9ef786f-8949-49b1-8c6a-f2ce915a8787.wav";

// ఆ
export const ఆఆటAudio = "d21ab9ef-ae51-4354-9f9f-31a66a8c214e.wav";

// ట
export const టటమాటAudio = "9eabf7f6-4681-4fdb-bb74-72b0bb1f6363.wav";
export const టనాటకంAudio = "2fab597c-c092-4e13-901f-0f651e57875e.wav";
export const టతోటAudio = "819ffa51-79d5-45c3-afb3-5a46075cd107.wav";

// ఉ
export const ఉఉంగరంAudio = "51bd6eb3-90ab-4a3d-a7c9-5807946f2416.wav";

// గ
export const గగదAudio = "b040f3a4-8564-4434-80b4-9e0d858a80d2.wav";
export const గఉంగరంAudio = "a5cbea8d-7601-4f4a-87ac-58766a13ad46.wav";
export const గపండుగAudio = "8bd53264-2dcb-4059-814f-8c510eda4e15.wav";

// శ
export const శశనగAudio = "1e0fca89-507e-460e-8a56-20f5bab59293.wav";
export const శదశమిAudio = "6027b5e4-faa0-42ab-9a77-b39e2b3cf1f9.wav";
export const శదిశAudio = "610e252f-bbe5-4336-9198-4d26c491021e.wav";

// అ
export const అఅనపAudio = "b46b1e16-9b96-42aa-b6cf-54a196e43081.wav";

// ప
export const పపంటAudio = "2fb6b402-1e36-4104-b492-8bf0312a5a82.wav";
export const పచేపలుAudio = "12e0ae64-2430-4e99-b21d-cb0163fa3379.wav";
export const పపాపAudio = "ea0809fc-51fd-41d4-9fea-fdb7947fc484.wav";

// స
export const ససవరంAudio = "2bf80eeb-f9e6-401f-9e78-64e7aff3305b.wav";
export const సదసరాAudio = "fad2f812-2dfa-480d-b8a7-59f20f60b419.wav";
export const సపనసAudio = "017ec6ff-4662-4647-a210-24a69033c81a.wav";

// వ
export const వవలAudio = "4d7aaf5a-c772-438f-b15d-da36b3e28dfb.wav";
export const వలవణంAudio = "f26c92a2-ad1d-4c1d-a7db-9033e5adfb8a.wav";
export const వపడవAudio = "30f6d802-dd0f-4fde-a49e-7854c118c461.wav";

// ఊ
export const ఊఊయలAudio = "4556cae3-9029-404b-a64f-c7ed43df0666.wav";

// డ
export const డడబ్బాAudio = "8152b0fd-9d10-4a18-b496-2ac3373d62b1.wav";
export const డఅడవిAudio = "8fdad419-54a6-4c14-8d6e-687b5a0a435a.wav";
export const డబండAudio = "caca2d21-3052-473c-b038-9bbeba2e90ab.wav";

// ద
export const దదండAudio = "6bac6a0f-8282-4287-a7c9-14b7f22f3e54.wav";
export const దఉదయంAudio = "6eae3bf9-4ef7-4760-840f-9344627e89b0.wav";
export const దకిందAudio = "c19ec88e-a775-4b1f-b02c-bb28378702c5.wav";

// ఈ
export const ఈఈతAudio = "e53f07b7-c3a3-4372-841d-43336e95a89b.wav";

// మ
export const మమరAudio = "583c7279-821f-472e-a3dd-06aff52fa85c.wav";
export const మనెమలిAudio = "5d766fc1-6453-4a31-bad8-e07427d708fb.wav";
export const మచీమAudio = "a2d6d808-868c-4dfe-8822-9ab6acdb05e7.wav";

// చ
export const చచరకాAudio = "fc51e04f-b2a1-4b7d-99fe-3353c48db2fc.wav";
export const చరచనAudio = "c174c84f-aada-42bb-8d40-9db38c37fb81.wav";
export const చకిచకిచAudio = "39d619a5-b1a7-4f03-8b50-6d6f4bc2cf0c.wav";
export const ఒఒకAudio = "cc95b761-837b-48de-93bb-a125934a4c5e.wav";

// ఓ
export const ఓఓడAudio = "920cb7c6-6d8e-4f4c-be37-586e45798eaf.wav";
export const ఔఔటుAudio = "d3e7bc78-fbad-402d-9b46-99c31b4c57a7.wav";

// య
export const యయదAudio = "58e1707d-d5b0-4382-8181-877ef95c5401.wav";
export const యకాయలుAudio = "c84fe9d4-8386-43b4-b64e-ee328a7a841d.wav";
export const యవంకాయAudio = "7928a11a-0bfb-4a3d-8b14-41e9e38bb476.wav";

// ఇ
export const ఇఇటుకAudio = "f0b48c06-0b2a-4f28-8449-bde21365a802.wav";

// ఎ
export const ఎఎలుకAudio = "7f40265e-3955-4290-a078-d46d151bd871.wav";

// ఏ
export const ఏఏనుగుAudio = "a0e732fa-28d3-4ac0-94e7-30f5b85c21d0.wav";

// ఐ
export const ఐఐదుAudio = "cdcdb2cc-0d02-4168-a86e-16845bfe0123.wav";

// ణ
export const ణగణపతిAudio = "f79f1e21-5653-4b8c-b957-98aafcc31a9f.wav";
export const ణవీణAudio = "9a6fb5ad-08b6-471b-a41f-72db49594d75.wav";

// ళ
export const ళతాళంAudio = "73e2acca-d9c1-4bf0-a74b-7f7cd2b73e3f.wav";
export const ళకళAudio = "da9bf10c-b41a-412c-acf1-0a055bccd2ed.wav";

// హ
export const హహంసAudio = "ea4aa993-cce7-4f86-ad5a-8d194205d386.wav";
export const హవాహనంAudio = "b9e93855-2852-45a7-83fa-599cd978a78a.wav";
export const హగుహAudio = "a152cba6-c2fc-482d-8ac6-05ae77abe49c.wav";

// ఖ
export const ఖఖగంAudio = "7c5cda20-51c8-4110-873d-e50c7061282a.wav";
export const ఖముఖముAudio = "62e78bf1-71c4-4a0a-8256-085572d8132e.wav";
export const ఖశంఖంAudio = "8df7b151-20b4-4520-a662-4928d13ab066.wav";

// ఛ
export const ఛఛత్రముAudio = "3ea2b313-c59d-4ffa-9566-eeb9909ca104.wav";
export const ఛపింఛంAudio = "fd77c926-30dc-4ff8-96ed-1d28a59750c1.wav";

// ఠ
export const ఠపాఠశాలAudio = "79c16b15-14ee-45d0-ae09-ce7d9f5d97d2.wav";
export const ఠపాఠంAudio = "9abef1b9-bcda-46d6-893a-f3c6ede1d508.wav";

// ఢ
export const ఢఢమఢమAudio = "b0a2d4ab-b539-4d6e-8d11-97100efcffe2.wav";

// ఘ
export const ఘఘటంAudio = "1c08c73b-175f-4a01-b2bc-576c84111440.wav";
export const ఘసంఘటనAudio = "4adc5ef2-1df3-48e2-9f9b-06d71828264a.wav";
export const ఘమేఘంAudio = "3bce22a4-b970-4f48-97d2-890870967538.wav";

// ఝ
export const ఝఝషంAudio = "e25b9277-daa1-44d9-87d6-9f1a6411f8a3.wav";

// ఋ
export const ఋఋషిAudio = "48990066-6673-4c0a-af23-b2d984847fe6.wav";

// ష
export const షషరాAudio = "071b1e9c-4bc4-4e13-8d34-debfca4f9efd.wav";
export const షవిషముAudio = "2417835e-c414-440d-a029-a5fe53cd9737.wav";
export const షఉషAudio = "3fe29189-6177-4698-ae5b-50395015391b.wav";

// థ
export const థథర్మోస్Audio = "d30ded47-4925-43aa-9d8f-b3d577b8486d.wav";
export const థరథముAudio = "d563dfd9-bbb2-4835-868b-c195648742cc.wav";
export const థకథAudio = "3aebf0d4-be54-4873-8981-74ef00b18e6d.wav";

// ధ
export const ధధనంAudio = "bc22404b-51f7-4076-bbb9-3e2d296a5c08.wav";
export const ధక్రోధముAudio = "eaba3074-81d8-4341-83a9-2fbcd2fd8e21.wav";
export const ధబాధAudio = "2b4c170e-cff4-4d1d-9abb-2fdf1ea5543a.wav";

// ఫ
export const ఫఫలముAudio = "a2cc579a-9a7d-438f-80c5-f1b22c0dee7f.wav";
export const ఫటెలిఫోనుAudio = "9abdb5cd-046b-4dfd-a265-411c821cf0ca.wav";
export const ఫసీతాఫలంAudio = "9ee56f4f-01c9-435b-97f6-586d09102020.wav";

// భ
export const భభజనAudio = "5ab059b3-3fb8-4045-ba93-73368a972ac2.wav";
export const భసభAudio = "012f4056-1338-4b8c-a46d-90d36bb4ac96.wav";

// క్ష
export const క్షక్షత్రియుడుAudio = "a0974a68-4bba-43f0-9946-00b9f3d831f9.wav";
export const క్షఅక్షరంAudio = "5ee3c4d8-256f-4949-b4e9-524e28877d18.wav";
export const క్షపరీక్షAudio = "25d5b1b9-6f8e-4275-94a9-34efc3a01f16.wav";

// అం
export const అంఅంగడిAudio = "c9cf0040-6581-4e9c-8b31-e00d25b72938.wav";

// ఙ
export const ఙఙAudio = "b3620be8-eb3c-418a-adff-637bcb6c20fa.wav";

// ఞ
export const ఞఞAudio = "9bf3c533-46bd-4da0-b768-c831cd2f4b1e.wav";

// అః
export const అఃఅఃAudio = "cce673f8-9b25-4f1f-a193-1c57716ee52b.wav";

// ఱ
export const ఱఱంపంAudio = "77946613-6d78-4292-acfa-163b1620e59c.wav";

// న
export const ననగAudio = "c90c2967-d501-4389-adcb-8d6562086394.wav";

// ౠ
export const ౠౠకAudio = "c55c9287-3dcc-4cba-ad32-787ae015675e.wav";

//F1 New assets
export const underImg = "1ca4d613-a5b3-4a05-8b76-922b576b6c78.png";
export const underAudio = "87fe21d5-5182-4c03-93ab-a1df00392837.wav";
export const underSingleAudio = "1ca4d613-a5b3-4a05-8b76-922b576b6c78.wav";
export const DustSingleAudio = "85918c66-eb87-403e-842e-baed2bb5da62.wav";
export const LadyImg = "48e50de5-aa47-4989-a6ad-95c7a0319ebb.png";
export const LadySingleAudio = "48e50de5-aa47-4989-a6ad-95c7a0319ebb.wav";
export const SadImg = "e4217e84-d7b1-4ecc-bc52-3b2e24142f26.png";
export const SadSingleAudio = "e4217e84-d7b1-4ecc-bc52-3b2e24142f26.wav";
export const WindImg = "5b97396d-021a-441b-80f5-c02e18cee70f.png";
export const WindAudio = "a5e73645-8955-4a5b-bda4-8d8ca30a9cb6.wav";
export const WindSingleAudio = "5b97396d-021a-441b-80f5-c02e18cee70f.wav";
export const SweetImg = "3916e540-7b61-410c-ba4a-589eabbab489.png";
export const SweetSingleAudio = "3916e540-7b61-410c-ba4a-589eabbab489.wav";
export const EqualImg = "dcbc93ac-49cd-4f7f-a8fb-04132b1a2cda.png";
export const EqualSingleAudio = "dcbc93ac-49cd-4f7f-a8fb-04132b1a2cda.wav";

//F2 New assets
export const HearImg = "33f0d932-879c-4943-a41a-4c9c187ec3d3.png";
export const HearSingleAudio = "33f0d932-879c-4943-a41a-4c9c187ec3d3.wav";
export const atlasImg = "1fe1a332-0e9c-42fb-9c9b-ce4ae6521d7e.png";
export const atlasSingleAudio = "1fe1a332-0e9c-42fb-9c9b-ce4ae6521d7e.wav";
export const sitImg = "b2dea51d-b37e-4740-8c65-add26ac48ae5.png";
export const sitSingleAudio = "b2dea51d-b37e-4740-8c65-add26ac48ae5.wav";
export const MotherImg = "4c81ceff-e680-40ab-8c13-8d1d5dc027c0.png";
export const MotherSingleAudio = "4c81ceff-e680-40ab-8c13-8d1d5dc027c0.wav";

//F2 Telugu assets

export const గదిAudio = "a412d0ae-c80b-42b2-aa37-d0d01cd35478.wav";
export const చేనుAudio = "6d77c3e7-096d-404d-87ad-a374bcbc5274.wav";
export const గీరుAudio = "1734e535-62d4-4c73-8fb5-9a3b6d7c6247.wav";
export const కోకిలAudio = "3e136472-4fc9-4acc-9582-5f7118c9f983.wav";
export const నీకుAudio = "b94ad383-8a3b-4b0d-972c-4028a5fa0d9a.wav";
export const బాలికAudio = "5a305c06-d14e-4d24-adae-f7186211f62b.wav";
export const నెమలిsplitAudio = "dca125fa-2293-4f78-ac7d-f89879d99bc8.wav";
export const నుదురుAudio = "e88113f6-dfce-412c-9a74-0fbbd9197381.wav";
export const మైదానంAudio = "15d25aa8-be33-45f8-99a4-4a82dfd87583.wav";
export const మొదలుAudio = "673c3eb9-d7d2-41bd-a493-dc76d745d7e7.wav";
export const మాటలుAudio = "d9e87544-c93f-4c00-a6f9-cfe951fa7528.wav";
export const చూడలేదుAudio = "0456a5d0-e645-4bb7-839a-0c0e01d05ec5.wav";
export const తోలుAudio = "53a752bd-4f2b-431a-abad-b16c3adf4878.wav";
export const పూజారిAudio = "ed6d931a-b05b-460d-b64f-a9dd1dd5eaf7.wav";
export const జాలరిAudio = "c095619e-2a52-4c48-a0b9-6ee165d59d68.wav";
export const కూజాAudio = "9ccdf205-8f89-4901-945b-bb815aa636a0.wav";
export const దివిటిAudio = "8e71191a-a11a-41ff-9806-85b2f8f3b6c0.wav";
export const గాలిAudio = "c7033024-a4c4-42e9-95a6-ec947861e31a.wav";
export const గోడAudio = "778e7f11-c614-4519-baf1-7a8f13125292.wav";
export const దురదAudio = "52122615-f2cb-409d-bd99-89049fdfbdb3.wav";
export const చదువుAudio = "32da8d66-21e8-4889-a7c9-00943e74d6ee.wav";
export const చేదుAudio = "20f91d80-3f06-49f0-9d47-41a4a314a1f7.wav";
export const కూతురుAudio = "56104669-618a-4a0a-9a95-43f3fb099bb5.wav";
export const పెసలుAudio = "15026c25-90d1-4f0a-b614-37fb8a2dc570.wav";
export const హారంAudio = "84401c92-43db-40b1-9bb3-36d477f9c55b.wav";
export const కిటికిAudio = "0dac8d1b-4da8-4285-9852-3eba98bf5f39.wav";
export const చీకటిAudio = "6e72b51a-536a-4ca7-ab03-617674d3040c.wav";
export const శునకంAudio = "14c09522-248d-4823-96a2-cf3f416bfc29.wav";
export const గెలుపుAudio = "7cfffd77-5d91-4750-b873-76a15b0eaeaf.wav";
export const మేకAudio = "1a5ca312-7357-4e95-9c07-0d0e0083b814.wav";
export const కోడిAudio = "cec84db6-fdd4-4170-88fc-47c62dff13f9.wav";
export const పాలు2Audio = "6bb9553b-5d19-463b-9a95-ee6ed3ba2e31.wav";
export const నీడAudio = "088668e3-a6ad-439f-b8d7-4f5279bb8d75.wav";
export const పూవులుAudio = "3097c758-eed6-422d-a313-53056da3652d.wav";
export const గురువుAudio = "4c8fd932-8f14-4099-96d7-4fde5676b3dc.wav";
export const జూలుAudio = "874c0ced-dcf6-40f9-ab91-aeab3c400781.wav";
export const దుకాణంAudio = "42142dc4-2ba0-4fe4-a747-0ed6b2cdd2aa.wav";
export const పీటAudio = "b5a6f527-16de-4e75-b423-b1278dca7f33.wav";
export const సాగరంAudio = "4e2e2390-02dc-4551-af71-9cc27e5c1196.wav";
export const మీసాలుAudio = "2dffa6f7-60f1-48a0-ae5a-813a84cc50bb.wav";
export const తిలకంAudio = "99ebe8ff-3dd1-474e-a151-aa2a185759b6.wav";
export const చామంతిAudio = "0d494bda-4edc-4449-8a0b-6de464f3d6ba.wav";
export const గిరిAudio = "2248cd32-bd46-49a2-a31d-ec2d7c8b9617.wav";
export const తోకAudio = "a62d3001-d2b2-4e31-991e-162397197858.wav";
export const మామిడిAudio = "e3780c15-d170-4c21-88e0-86a237101cf4.wav";
export const మీనంAudio = "49367f3b-1516-4955-8eff-2f6800a2a8ed.wav";
export const మూతిAudio = "39c201f0-488c-4e4c-919a-177b0c50bd49.wav";
export const రోజాAudio = "e3ac4e15-4f1a-4e83-b562-0f398508cdcb.wav";
export const బజారుAudio = "2b96f82b-6983-4661-8bcd-ebc99fd96e78.wav";
export const రూపాయిAudio = "277feeb7-0aea-4385-9878-695ef0a349a6.wav";
export const చపాతీAudio = "12f092fc-5db9-40d1-9548-c44b622f1a6a.wav";
export const జంతువుAudio = "ff5f710b-be16-4855-82fd-16e8d2ac5180.wav";
export const వేపాకుAudio = "6e079c49-e8af-4e9f-ba59-4b63e12bea1a.wav";

//F1 KN
export const ರಸImg = "9476e42b-4453-4aab-ac42-36ea0871c818.png";
export const ರಸAudio = "a6305f7f-f919-4ee9-a8ec-eaf3eebb8a64.wav";
export const ಅರಸImg = "eb0c2a30-fffe-46ce-b247-1a5077275732.png";
export const ಅರಸAudio = "c13fc3f0-0845-4868-907f-0d7b39cec56a.wav";
export const ದಸರImg = "96d6e03c-c0a7-4d56-9a7e-84e56c012056.png";
export const ದಸರAudio = "41e49d38-110b-4f3c-88ac-76b32b18d7cd.wav";
export const ಗರImg = "a7a01039-7e0e-4144-b2c6-5399545344e4.png";
export const ಗರAudio = "b5f00b7d-cdae-479f-9845-97146a2a2312.wav";
export const ಆಗಸImg = "9fb96c70-f34e-4372-9bcb-9404cf5fe9e0.png";
export const ಆಗಸAudio = "1918a748-72ef-4ba2-8b4e-76a84e40f3b0.wav";
export const ಉರಗImg = "75366d78-4f74-4b75-8e79-34306f625dbd.png";
export const ಉರಗAudio = "b3f4daf7-e2d5-4ddb-9f00-e3a9ac145ce7.wav";
export const ಸರImg = "19bbc6c5-0682-4ecb-8673-f877b0defa84.png";
export const ಸರAudio = "e4a19cb0-d21b-4de8-b5bc-a906b2105ce1.wav";
export const ಆಸನImg = "0b26c4aa-0552-4387-bee9-44d034da156f.png";
export const ಆಸನAudio = "2ddb7eff-461f-45c0-ae00-04d77b477a00.wav";
export const ರಸ2Img = "885b7810-eb82-4858-b17a-a1c35ec1a67c.png";
export const ರಸ2Audio = "15fe8b17-a3e5-47c2-ac72-2375507b7287.wav";
export const ದಸರ2Img = "4a61f48b-0698-4b72-8966-01d0513aba9c.png";
export const ದಸರ2Audio = "1453df9d-4a83-43b1-878d-c3e02242adef.wav";
export const ಉದಯImg = "da879b59-912d-4b9a-bf97-a5276beac32c.png";
export const ಉದಯAudio = "ed5cc0c3-110d-40bd-9b5d-76cf765e9763.wav";
export const ಕದImg = "30fde80d-f1a5-495c-81ec-02945e4d195b.png";
export const ಕದAudio = "517e86f7-923b-4926-abc7-c2f49a6a3392.wav";
export const ಅರಸ2Img = "53a6c460-5739-40c1-87d3-79055794695d.png";
export const ಅರಸ2Audio = "f620dd0f-0c1c-4ad7-91bf-7d749379df6f.wav";
export const ಜನImg = "192a2c2a-a121-4510-8657-1d165187df0e.png";
export const ಜನAudio = "8d6c7e4d-997c-4453-82bd-e21c64d639d3.wav";
export const ರಜತImg = "03c16c27-299c-423f-97fa-6fe4cb98d997.png";
export const ರಜತAudio = "81936b9a-8ef4-4515-8581-6379739b1a23.wav";
export const ಗಜImg = "58631833-98fe-43f2-a636-8add5a7d44c7.png";
export const ಗಜAudio = "3a3e00ce-d250-4ce9-bd49-95830731aedf.wav";
export const ವನImg = "a247a4bb-6cd5-450e-a2bf-94d9a27c4940.png";
export const ವನAudio = "efde99cf-7f30-4f11-97f6-f28c5301819f.wav";
export const ದವಸImg = "53f82a1f-dab7-41b0-bc7c-bc5960365f07.png";
export const ದವಸAudio = "7a11624b-5810-4230-a9a1-1e920c9b0cd6.wav";
export const ಬಸವImg = "c9a4d64a-4042-495c-b60d-44477f772d5f.png";
export const ಬಸವAudio = "b7732bde-3c29-4e06-ae2c-199e34daa61b.wav";
export const ಮರImg = "b0443c8d-dfda-4480-b09b-26e5655059c1.png";
export const ಮರAudio = "3a1e99bf-215e-4dd2-b2fa-8dc7f2734b74.wav";
export const ಕಮಲImg = "be7b29af-f7b0-4f28-beab-43750f6be5c3.png";
export const ಕಮಲAudio = "99637396-5b99-404b-a195-673a5b4704ef.wav";
export const ಸಮImg = "7d397f51-b4e4-446e-a6ab-644989226704.png";
export const ಸಮAudio = "0a39d77e-d48b-42c4-9b0a-5faaedd425d4.wav";
export const ಬನImg = "18c4382d-e0e1-4aeb-b27d-b27322489b8a.png";
export const ಬನAudio = "54f056a3-bde0-4e3e-a9e1-e42f63f11ab0.wav";
export const ತಬಲImg = "9658babf-39a2-4af3-aca2-069ced054976.png";
export const ತಬಲAudio = "0543320c-8687-4d8e-b307-03299cfbbfed.wav";
export const ಕಬImg = "df61fdf9-aac5-43c4-ad9a-150f695d60f4.png";
export const ಕಬAudio = "b617c072-e648-45a0-8a7f-f33d5d6f624f.wav";
export const ನಗImg = "55dda2a4-ce8f-4ceb-a9aa-98cdff0110ba.png";
export const ನಗAudio = "5f823a7b-f864-4e26-ac9e-cc63a9cc2a33.wav";
export const ವನಜImg = "9427a885-6039-4585-8db2-d678356fc25b.png";
export const ವನಜAudio = "4eff9a0a-3c80-488f-a427-74cbc72136b3.wav";
export const ನಯನImg = "c68a9185-62bc-4dda-bb9e-4111bb555320.png";
export const ನಯನAudio = "5b26e3b2-926a-427d-a83e-b3debcedfeba.wav";
export const ಪದImg = "cc6e56a2-e371-4889-96e2-890867e2b15d.png";
export const ಪದAudio = "c5df95bf-8f7d-4688-b982-4f7b5a2fc98b.wav";
export const ಟಪಟಪImg = "116c828a-1401-443e-aeca-5c68ac490ce8.png";
export const ಟಪಟಪAudio = "ab0005f8-095e-4636-9a87-5f242152193a.wav";
export const ಜಪImg = "d66099e6-eede-4ea9-b1cf-75733f040137.png";
export const ಜಪAudio = "6bda7387-b794-4a23-9a91-707739fe2b00.wav";
export const ಯಮImg = "7482a76a-19bc-427c-b447-305f8c22a879.png";
export const ಯಮAudio = "c569a6c4-2fb8-465f-8249-234402a7990f.wav";
export const ನಯನ2Img = "9d4769cd-e810-401a-9c0e-9d612221e230.png";
export const ನಯನ2Audio = "55629b64-a201-4844-9157-efcdc8e87e2e.wav";
export const ಜಯImg = "b74713e0-5a27-4cf7-86f1-15bf74dac744.png";
export const ಜಯAudio = "a7ce7432-898c-4e49-ba6b-c42af3cb2c12.wav";
export const ಉದಯ2Img = "13304f33-0b3f-4ae7-9222-c6ff0e897e94.png";
export const ಉದಯ2Audio = "5e5c978a-7a55-44a9-9139-eab8ab4fd0e4.wav";
export const ಡಮರImg = "0c95fa3d-6519-4444-abf7-55de97fd6385.png";
export const ಡಮರAudio = "54407d20-17c5-4376-80cd-c9976e5ec810.wav";
export const ಕಡಗImg = "568ec9bd-802b-4625-a32a-89b4d2a4c520.png";
export const ಕಡಗAudio = "e47e767b-34b3-476d-b3fd-2dbd49e6a2d9.wav";
export const ಉಡImg = "bd99aa6b-3561-41b9-a762-84377c78c652.png";
export const ಉಡAudio = "9252d4e0-90f4-4e10-97df-a870bc258ac9.wav";
export const ಟಪಟಪ2Img = "1dc2fa11-4ca7-4f7b-a9ba-ab08d5f06131.png";
export const ಟಪಟಪ2Audio = "6f1ab0b2-b425-4116-a91e-576974c1e1d9.wav";
export const ನಟಕImg = "4fcd7dde-fb1a-4281-8e4a-177445f12ba5.png";
export const ನಟಕAudio = "8d7cb88e-7416-4d6a-9bb6-0907b77c96b7.wav";
export const ಆಟImg = "8cf1c600-16c2-4c89-a46f-cf8bc7bf72b1.png";
export const ಆಟAudio = "c32db73c-0c02-43ac-a245-74766e2e07d0.wav";
export const ಚಮಚImg = "75d0b396-202f-45df-adda-ae360684eab1.png";
export const ಚಮಚAudio = "4a60198f-6424-4345-8fe6-eb20c47ab936.wav";
export const ಈಚಲImg = "c59f9915-ae10-4dd1-bffb-4f4ab780d391.png";
export const ಈಚಲAudio = "1a45150b-e7db-4dcf-9f7d-5f1e18a7e72e.wav";
export const ಮಚImg = "8bf4318f-51e0-498f-a559-43ef1f62a103.png";
export const ಮಚAudio = "464de7b6-f8ef-478e-82e9-110b68b40f93.wav";
export const ಲವಣImg = "a56acd38-4bf5-4ecd-b557-5024d8a91e70.png";
export const ಲವಣAudio = "17f5d56d-24fc-45c7-bb81-8bdd9f06aefc.wav";
export const ಕಲರವImg = "7acfd068-211d-4a99-9f54-7cebac122118.png";
export const ಕಲರವAudio = "f32d334d-5166-411a-a555-2032e28d304e.wav";
export const ಬಲImg = "bab568f0-398b-4ade-b4ac-4d0f54ab4a25.png";
export const ಬಲAudio = "873f695c-3e1e-4699-a3b5-80437a9970a9.wav";
export const ಈಚಲ2Img = "fb555613-f251-4783-9fea-570e77d01474.png";
export const ಈಚಲ2Audio = "fad97587-9001-4505-a165-93c47bd1a4ca.wav";
export const ಊಟImg = "ad24aea0-fb10-4360-b1e0-756278205096.png";
export const ಊಟAudio = "fd02cf2f-b961-43f9-8cc3-c65d8f8bbff9.wav";
export const ಕದ2Img = "b7fa29c3-866c-4df0-b575-a44bd473bf72.png";
export const ಕದ2Audio = "dfeb0962-e8d6-4a21-a53c-b7ef968655d2.wav";
export const ಟಕಟಕImg = "63104b28-f076-448a-8eb5-b163cfe658d1.png";
export const ಟಕಟಕAudio = "d909b05f-fb01-47d7-b1f6-a100354576de.wav";
export const ಪದಕImg = "3d3cb44e-4195-453a-97f7-3f6b09e9c2a0.png";
export const ಪದಕAudio = "76bb8894-3f0b-4a91-b8df-daee9745012a.wav";
export const ಎರಕImg = "fe78be10-bd21-4880-9beb-9bcc400ff923.png";
export const ಎರಕAudio = "7109449f-a460-44b4-8324-44254692a332.wav";
export const ಏತImg = "50ce6ba0-c4e2-4509-aff2-78cd19f35217.png";
export const ಏತAudio = "bcb46b74-367c-4c8e-be6a-92e289e33a9a.wav";
export const ಇಲImg = "feff971d-c169-4668-969d-4f635e6b4d9a.png";
export const ಇಲAudio = "3def7276-76b8-45d0-aa15-3d7e8975ff2e.wav";
export const ಆಲImg = "7cbbabe1-d90a-4801-ad4f-11eae7b6511e.png";
export const ಆಲAudio = "2745ae29-53ee-429a-9d8d-1586a5332c60.wav";
export const ತಬಲ2Img = "45c43ff3-aaf3-4b8b-874b-30111399ae53.png";
export const ತಬಲ2Audio = "3a9cf86b-1629-498c-9f0c-ea74c6da9392.wav";
export const ಔತಣImg = "a4db07c0-246b-4027-a128-e2ead4b984af.png";
export const ಔತಣAudio = "926c5a67-8f0e-4132-94f9-38d562bc3a33.wav";
export const ಊತImg = "287408aa-a754-452e-b845-4ea252df84b6.png";
export const ಊತAudio = "924d119d-bb0d-4e2c-8b59-0f9af9fa87b9.wav";
export const ಜಳಕImg = "aaae8fff-7a1c-4cea-9d20-7649f1138a92.png";
export const ಜಳಕAudio = "1b1ea5b3-4879-43a2-a4ed-1b82e891ffa7.wav";
export const ನಳImg = "e05230bc-9116-4b8a-af58-a52ba894d0c4.png";
export const ನಳAudio = "1932f04b-3f52-45bc-8c61-0eb0f4e6a5f3.wav";
export const ಓಟImg = "55cc5f67-b3cd-4dca-8db9-a93e58eda547.png";
export const ಓಟAudio = "3f7fe654-436e-4a90-a53b-e82b383bdaa6.wav";
export const ಔಡಲImg = "d639d726-ff38-416e-b76e-48311663ae32.png";
export const ಔಡಲAudio = "aeafc973-e5e2-4fee-b460-a3b27e69513f.wav";
export const ಹವಳImg = "13e69a58-736f-4d0e-bb0d-447c8f96fae9.png";
export const ಹವಳAudio = "d19851a9-26db-4278-9da2-5ff291c8ac7e.wav";
export const ವಹನImg = "b3942546-0c28-48a9-bfd0-5b9042a20562.png";
export const ವಹನAudio = "528c544f-e3a2-41ad-ad41-645481f9099f.wav";
export const ಕಲಹImg = "ea6844f4-b0c2-4541-82ec-93a4572f7635.png";
export const ಕಲಹAudio = "17c3dfa2-1e0d-4c49-bb7e-7ca4644d0db8.wav";
export const ಶರImg = "92aee081-75e6-434c-8981-f2fedaf89965.png";
export const ಶರAudio = "a49136fa-6d0c-492a-b161-e8cb2f871245.wav";
export const ದಶಕImg = "4a77945c-9a26-4cc6-a2a6-4a740fbab854.png";
export const ದಶಕAudio = "1231cda3-4616-451a-83d4-c191c1ea05ed.wav";
export const ಕಳಶImg = "7ca37b17-6694-47e6-8036-4ff9dc5f4e3e.png";
export const ಕಳಶAudio = "131f4637-a00b-430e-83e3-70bc5c74f6cc.wav";
export const ಉಷImg = "b7316a5f-470d-4249-9e1e-b936c083960d.png";
export const ಉಷAudio = "b03d0bf4-ce39-40f0-a945-626eb8a1e8f9.wav";
export const ಔಷಧImg = "caeaf6ec-8341-4cfd-ada0-cf53e22d0ea4.png";
export const ಔಷಧAudio = "a8413d5d-f72b-4e3f-9dfe-67b73322dbdb.wav";
export const ಐದಳImg = "1be0eb09-955a-4963-aa29-7a1a20e52d46.png";
export const ಐದಳAudio = "0280ec87-fdfa-4e7f-b8bd-a71f559a9bcd.wav";
export const ಋಷImg = "9a294849-0d28-4f3f-9d4d-ae7c69a774b4.png";
export const ಋಷAudio = "834bc975-ba87-469c-a810-0446e341f760.wav";
export const ಹಣತImg = "0120edf1-aeba-4690-a18a-4e5141149aec.png";
export const ಹಣತAudio = "86def655-bb0e-4029-9b99-e1a684840172.wav";
export const ಹಣImg = "1e05c89e-d93c-48cd-8626-e2d34b354ee2.png";
export const ಹಣAudio = "f084b9ad-fcfc-4cdb-aef3-f8e14ec0ac7b.wav";
export const ಛತರImg = "c5ccf948-0ea0-4efb-874a-a4c21236c18a.png";
export const ಛತರAudio = "33868659-1c0f-4d6b-a9b5-2f3758fc5deb.wav";
export const ಒಣಮರImg = "b997f743-46a0-45c2-aece-66605e063b34.png";
export const ಒಣಮರAudio = "8621fee2-2b0a-4f83-a66a-73fb62625b2e.wav";
export const ಧನImg = "4213b65e-83e9-407e-89c3-4f54dac90558.png";
export const ಧನAudio = "e83ab82c-8aa6-4fcb-a568-1ea0fcbe258a.wav";
export const ಧಗಧಗImg = "cc1d25f4-d311-4592-b378-829dd8cb49fe.png";
export const ಧಗಧಗAudio = "011f7b2a-59e6-4f2c-ae8e-3009bccd56d9.wav";
export const ಗಧImg = "12b07a1e-bbe0-400f-bb91-009fd5c520c6.png";
export const ಗಧAudio = "6f89f183-bcc9-40ff-9ef9-e9e76a4f4ea4.wav";
export const ಥಳಥಳImg = "ecd20737-6c08-4346-bd83-282fca90b3c2.png";
export const ಥಳಥಳAudio = "a55c0566-a3d8-46ad-aa0f-1a5dc13bffd9.wav";
export const ರಥImg = "e74fafdc-3c8d-43a1-b432-218c96fea858.png";
export const ರಥAudio = "0de853ca-0941-4eba-aec4-b536f749d81f.wav";
export const ಢಣಢಣImg = "d7799ce3-af1d-45f3-aa71-60584f71a05a.png";
export const ಢಣಢಣAudio = "89f3b2d5-cda7-43a1-8ca3-e4c6ee84567d.wav";
export const ಗಢImg = "592a69fb-8604-43fd-8955-b1c73259ab55.png";
export const ಗಢAudio = "7857e349-fbb1-40cc-a34b-dfd60aaf0198.wav";
export const ಭವನImg = "b4c078b8-543e-4089-8c69-885fe015db10.png";
export const ಭವನAudio = "3e334c6c-d24e-486c-ba18-646a642eeb7a.wav";
export const ಆಭರಣImg = "03d1b876-ad4c-450d-8e9e-460356f7f312.png";
export const ಆಭರಣAudio = "8caa85ac-9f8e-40bb-b409-8a40e3754361.wav";
export const ವಷಭImg = "1b1399f8-b4ac-440e-a0fe-5ce407439618.png";
export const ವಷಭAudio = "95d489f0-676a-4e55-a4ad-d3807364dd13.wav";
export const ಘಟImg = "ac9ec930-f2e1-4601-8065-e2b1f2fedb1d.png";
export const ಘಟAudio = "51d2b7d8-7816-4f2f-9cc4-0c31fcc9b8f2.wav";
export const ಠಕಕImg = "943dfccc-bc08-4166-8769-239b5e1a9460.png";
export const ಠಕಕAudio = "4e85e0b0-7969-497e-a682-5eece788f702.wav";
export const ಜಠರImg = "a6fe2da4-2158-4f75-83f1-fdb14e568a53.png";
export const ಜಠರAudio = "5767ca0e-c737-4b0d-b68b-26c7a8749e09.wav";
export const ಕಠImg = "1a018763-b756-4218-a4ea-0fbb8d2d352f.png";
export const ಕಠAudio = "f55aef68-3aba-436d-85e6-02d43c47cd53.wav";
export const ಫಲImg = "dccccb4e-d6d9-405b-bdc9-664f82e46fbd.png";
export const ಫಲAudio = "8e21a272-556b-4339-9cff-60b5347f9277.wav";
export const ಸಫಲImg = "d5f50f18-876f-4625-bd64-2bdeec57fa40.png";
export const ಸಫಲAudio = "da3d63c8-80e7-4c6d-b320-c83fe5b41fbd.wav";
export const ಕಫImg = "ee9cc62b-0312-4eb1-90cd-a7d63f593237.png";
export const ಕಫAudio = "98bdf6cf-07cb-4b70-ab20-3549d86e7357.wav";
export const ಝರImg = "a664121d-ca91-4b9b-a6bc-d687832a3e13.png";
export const ಝರAudio = "f848d3d4-abaa-498a-a362-f5df0e33771e.wav";
export const ಖಗImg = "39e1fc13-e5af-45c6-ad7f-997f329ea98a.png";
export const ಖಗAudio = "8c89b8e5-e531-48fa-a16b-5a2287733571.wav";
export const ಲಖನImg = "7e9bd7cb-054c-42aa-b883-da5605ea46c8.png";
export const ಲಖನAudio = "aac10d10-f96c-473e-bcbb-3d0d6da9d894.wav";
export const ಪಖImg = "c991bcc4-0d7f-4919-890d-31c62fb638c2.png";
export const ಪಖAudio = "e9fdb0a4-3ba5-434d-b2e5-5eeb02b95f7c.wav";
export const ಅಗಳImg = "45fc804f-a426-4da4-84ae-e680c38ac888.png";
export const ಅಗಳAudio = "6e8f5eb6-3822-45d1-b4ac-3b96115bb011.wav";
export const ವಚನImg = "44e489f0-676a-4e55-a4ad-d3807364dd13.png";
export const ವಚನAudio = "44e489f0-676a-4e55-a4ad-d3807364dd13.wav";
export const ಸಧನImg = "66a489f0-676a-4e55-a4ad-d3807364dd13.png";
export const ಸಧನAudio = "66a489f0-676a-4e55-a4ad-d3807364dd13.wav";
export const ಅImg = "1476e42b-4453-4aab-ac42-36ea0871c818.png";
export const ಅAudio = "16305f7f-f919-4ee9-a8ec-eaf3eebb8a64.wav";
export const ಙImg = "eb0c2a30-fffe-46ce-b247-1a5077275732.png";
export const ಙAudio = "213fc3f0-0845-4868-907f-0d7b39cec56a.wav";
export const ಞImg = "96d6e03c-c0a7-4d56-9a7e-84e56c012056.png";
export const ಞAudio = "31e49d38-110b-4f3c-88ac-76b32b18d7cd.wav";
export const ಕಷImg = "a7a01039-7e0e-4144-b2c6-5399545344e4.png";
export const ಕಷAudio = "45f00b7d-cdae-479f-9845-97146a2a2312.wav";
export const ಜಞImg = "9fb96c70-f34e-4372-9bcb-9404cf5fe9e0.png";
export const ಜಞAudio = "5918a748-72ef-4ba2-8b4e-76a84e40f3b0.wav";

//F2 KN
export const ಕಾಗೆAudio = "e0f3a327-0234-4c08-a30c-42a80d0424b1.wav";
export const ಮಾಲೆAudio = "40e9db50-289b-42bb-8166-a75b9de73663.wav";
export const ಗಿಳಿAudio = "2e58965a-74b1-4d24-983c-de2a927ef54a.wav";
export const ಸಿರಿAudio = "e4cb47ea-ebd0-4258-8e81-f9839388b79d.wav";
export const ಗುರುAudio = "486a75df-1465-4baa-9023-d5251a85e16a.wav";
export const ಹುಲಿAudio = "574f6deb-81c5-4047-a714-47db70ce851f.wav";
export const ಮೂರುAudio = "49f91714-5def-46da-89d0-d9a55c747c69.wav";
export const ಗೂಡುAudio = "dbe0641b-befe-4bf2-9b3d-da9c171ba3aa.wav";
export const ನೃಪAudio = "f2e6d0ca-1649-42c2-88cf-3e71b0b3e238.wav";
export const ಕೃತಿAudio = "9d6eb6c2-35fd-4305-986b-e5ba62131322.wav";
export const ಕೆರೆAudio = "49f958ed-0454-48f6-9a10-4f0136da4740.wav";
export const ಮೆರೆAudio = "128cdc98-fdd9-4240-b0b4-a8ecd6f33264.wav";
export const ದೇವಿAudio = "224c8799-88d2-4ef5-8c87-2806bd1b2464.wav";
export const ವೇಷAudio = "1804a6ff-44f4-44f2-81ac-e952a37918ab.wav";
export const ಕೈದಿAudio = "d4a7c872-7cbe-4577-899d-dd199677abd0.wav";
export const ಪೈರುAudio = "ebbb55b8-16a8-438a-ba3e-b142ee88b30e.wav";
export const ಹೊರೆAudio = "ffecdac6-6ea8-4252-b605-b61e083b3250.wav";
export const ಕೊಳೆAudio = "5b929182-1cb3-468e-9e5a-e1b6d73d209e.wav";
export const ಹೋರಿAudio = "8c980740-c5d3-4ebe-80ad-8334c00b15c0.wav";
export const ನೋಟುAudio = "b934c1ff-afb4-4417-b008-fe205292f859.wav";
export const ದೌಡುAudio = "59d5e319-6669-4c12-a241-fbba322da9b0.wav";
export const ಜೌಗುAudio = "ab945cf8-b5c7-4ef2-b46c-9a206f1a1bf4.wav";
export const ಕಂಸAudio = "91ef55bf-bf49-4357-a63f-419674b50118.wav";
export const ನಂದಿAudio = "f03cf197-15b2-4b85-b238-3e4a6031df0f.wav";
export const ಹಾವುAudio = "34a29d39-f7d1-43bd-9d9e-d58fbec3f4dd.wav";
export const ಬಿಳಿAudio = "d4076e2b-f8d0-4f76-93ea-6ef85a082f4a.wav";
export const ಹೊಗೆAudio = "68385e5a-96f4-4a7d-80c5-8a0a5345480f.wav";
export const ಕೆನೆAudio = "9f940196-bb74-477f-984d-7e835b8e49eb.wav";
export const ಕೇಳುAudio = "4d77df55-415c-4017-a121-b347094bff06.wav";
export const ನೌಕೆAudio = "18c3a47b-12ed-4e5e-b7d4-39d470ccada8.wav";
export const ನಾಳೆAudio = "e0900d1f-5fa0-4344-952a-cca902a220ed.wav";
export const ಚೀಟಿAudio = "a748fb5d-2544-4d38-8288-3fd646f41e3f.wav";
export const ಠೀವಿAudio = "ea431db9-3992-4e7e-91e2-a80c6d169821.wav";
export const ಸುಲಿAudio = "94ba21f0-edbb-451a-b7d0-053cda068fde.wav";
export const ಬೆವರುAudio = "8b8289fa-2837-4cc3-9b30-f9686adb0a15.wav";
export const ಹೇರುAudio = "4097349c-a232-4209-9974-79d77f0807a7.wav";
export const ಹಾಡುAudio = "1babfe08-2e70-4155-9f86-4e68084bfac3.wav";
export const ತೊರೆAudio = "ebfbab96-444f-46a5-a68f-957871c5acc5.wav";
export const ಚೇಳುAudio = "215baaee-7b31-43ec-ab33-793504abcb79.wav";
export const ಗೇಟುAudio = "ed9be6f1-f084-41cb-93bc-fcbac6d314f5.wav";
export const ಜೈಲುAudio = "dc30549a-83c9-4323-9a97-b978bf439f74.wav";
export const ಬಾಯಿAudio = "e16494eb-8f53-418c-8950-f82d47142a82.wav";
export const ಮೊರೆAudio = "e92cc90b-ca45-4be5-9a3c-69c41305865b.wav";
export const ಡಾಬಾAudio = "820289c3-c603-40e2-bc23-4a4bd1959254.wav";
export const ಗೋವುAudio = "8797167a-82fa-4363-8ed2-701685333d92.wav";
export const ಕುದಿಸುAudio = "af4868d0-b46b-416c-a2e5-2f270d26d739.wav";
export const ಡೋಲುAudio = "fd951b1d-b7da-41b4-b213-c5b913ab9d09.wav";
export const ಪೌಳಿAudio = "a1ef6b98-4e98-4bcc-afe2-a30e7f1d8e29.wav";
export const ಮೋರಿAudio = "295f291c-3b5a-40c3-b461-9bbefbae255d.wav";
export const ನೀರುAudio = "21bd59fc-aa40-4787-998c-8b9a2cff3b15.wav";
export const ದೋಣಿAudio = "8c83ace4-191e-4cdf-9e3a-9734fb7eb093.wav";
export const ದಾರಿAudio = "1afd798b-6e9f-477d-9b9c-25847b680c37.wav";
export const ಸೇರುAudio = "52cc2f73-7edc-4224-9221-60523e4e251e.wav";
export const ಲೈಲಾAudio = "cc60e51c-ca5e-42f3-8c11-84b79d032b52.wav";
export const ವೈರಿAudio = "8011d77e-bb9a-49d5-a9d7-8f0396167aca.wav";
export const ಕುರಿAudio = "d7f4f688-847b-4f96-ad07-2201b0ebcd1b.wav";
export const ಗಾಡಿAudio = "c02941c5-fb20-4dc2-9d38-879e40eebca1.wav";
export const ಸೌತೆAudio = "b397932a-191e-41b9-9ef5-dac96d4fdf3c.wav";
export const ಸಾರಿಗೆAudio = "b5fcbb39-5723-4896-9de1-bc45ff5ba899.wav";
export const ರಾಣಿAudio = "2346e3e1-b8eb-423d-898d-a0093ae1ff00.wav";
export const ಗೌರಿAudio = "d1e71e44-43af-40b6-92ce-7c23ba0f0ae7.wav";
export const ವೋಟುAudio = "914a73d4-bbf6-4d54-9725-844d4aadbf2d.wav";
export const ತೊಲೆAudio = "ed693c2b-ad21-4fd4-a76f-4bef5bbfcf9e.wav";
export const ಡೌಲುAudio = "41cabc78-d653-4631-8c91-2f13812e4445.wav";
export const ಮೌನಿAudio = "0a445260-3f10-415e-91bd-88df4b8cfae8.wav";
export const ಸೌದೆAudio = "a27d2d9b-c423-40b1-8d1c-c977f57a0c4e.wav";
export const ತೌರುAudio = "817e0f86-3d55-4d70-a04a-732908a811b8.wav";
export const ಕೋಡುAudio = "187f4a17-a8a3-4924-a006-12ddf8563e12.wav";
export const ಗೋಡೆAudio = "34f13d37-f639-4444-b70d-1bbbdf8a0f1d.wav";
export const ಚೋಟುAudio = "f6737e65-29bd-45ff-bed1-0fff60997722.wav";
export const ರೋಗಿAudio = "8c6c702b-324b-478d-8171-fde878af0bba.wav";
export const ಟೋಪಿAudio = "2060c6f5-d06f-4b37-aa82-6ab9f5bf62b3.wav";
export const ತೋಟಿAudio = "2d24469d-9a12-4ace-8793-ed3d1b975039.wav";
export const ಕೈದುAudio = "a160d325-83cb-4112-a4b9-a833574a0853.wav";
export const ಪೈಪುAudio = "e734ea57-f1f3-4652-9db3-8aecd749530a.wav";
export const ಬೆಳೆAudio = "50b82f99-e70a-4c26-8f5a-8d430cefc138.wav";
export const ಸೆಖೆAudio = "4a8607bd-6124-4be1-9b53-1deccdc9763e.wav";
export const ಪೇಡೆAudio = "60d2aed5-f909-492b-a730-8c414a77aee5.wav";
export const ರಂಭೆAudio = "47e358ae-8104-4135-b5ac-29c82cf859e5.wav";
export const ಗುಡಿಸುAudio = "d9c57a27-4e33-4d35-a3a2-9c35a9ac911a.wav";
export const ಯುವತಿAudio = "c8cfa19d-0707-4d1f-8249-d9f27ee51216.wav";
export const ಪಾಲಿಸುAudio = "96af5e0f-fe0b-4e8c-857d-3f4fc5357dfd.wav";
export const ಕಿಟಕಿAudio = "71d08ba6-6368-423f-b49f-d30dc4e33116.wav";
export const ಚಿರತೆAudio = "f2d9d495-117a-4b3b-b901-216c290a41fc.wav";
export const ವಾಸಿಸುAudio = "bb93eee6-b1a9-4887-8b6f-11d4f9ddf64c.wav";
export const ಹೆರಳುAudio = "e04ca553-af6c-4d4b-a3b0-e5bf03a1014c.wav";
export const ಯಾರಿಗೆAudio = "5604c12f-f021-4688-ad5b-7808f90c26a3.wav";
export const ತಾವರೆAudio = "f12209f0-af6b-48a5-9738-a210c98d94c3.wav";
export const ಜಿನುಗುAudio = "71068a64-bd0a-49d6-878b-107e260467e3.wav";
export const ಜೋಗುಳAudio = "b8cdf5e8-cd60-44d3-9969-a9fd12f60363.wav";
export const ತೋರಿಸುAudio = "ce7c43e4-5ad9-4fe6-8836-c1e3a95f4e39.wav";
export const ಯೋಜಿಸುAudio = "c39020ce-f780-42db-b32a-d9f1181fda9e.wav";
export const ಕೌತುಕAudio = "46eec2d1-0db4-45b1-9974-7debf88269c5.wav";
export const ಜೊತೆಗೆAudio = "ec602a9d-7948-4ca3-83cc-92188cb591ba.wav";
export const ಬೇಸಿಗೆAudio = "f3219c0b-5813-4bc6-a397-6b9a686db329.wav";
export const ಟೊಮೆಟೊAudio = "e5ccf255-df09-4f2d-a012-f65bf0f91441.wav";
export const ಮೈಮರೆAudio = "7733b5f0-549b-43b0-8f39-a44405616b71.wav";
export const ಮೈಸೂರುAudio = "bdbbdaec-c4e0-4e86-a974-15b549c39b87.wav";
export const ಯೌವನAudio = "88572af5-3f79-4a04-a81c-dd390d479474.wav";
export const ಮುದುಕAudio = "cea9784e-b443-4c58-bee1-1ff3bb160179.wav";
export const ಸೈನಿಕAudio = "be5a57f0-8a10-462c-a3a0-51ddf754ea58.wav";
export const ನೇರಳೆAudio = "9f023f85-6309-439b-b844-a819aeb60bb5.wav";
export const ಹೈದರಾಲಿAudio = "351563ab-0e56-4964-b3b9-cf5e5ce0a384.wav";
export const ಬೆದರಿಕೆAudio = "53bd583f-be57-4267-80a3-51b7e372585b.wav";
export const ಗೃಹAudio = "54bd583f-be57-4267-80a3-51b7e372585b.wav";
export const ಜೇನುAudio = "55bd583f-be57-4267-80a3-51b7e372585b.wav";
